import React, { useState, useRef, useEffect, useCallback, useLayoutEffect } from "react";
import { fabric } from "fabric-with-erasing";
import "bootstrap/dist/css/bootstrap.css";
import SiteNav from "./components/SiteNav";
import ItemSelection from "./components/ItemSelection";
import { OnboardingProvider } from "./contexts/OnboardingContext";
import HorizontalOnboarding from "./components/HorizontalOnboarding";
import OnboardingFlowController from "./components/onboarding/OnboardingFlowController";
import EditorTourHighlighter from "./components/onboarding/EditorTourHighlighter";
// import AccessoriesSelection from "./components/accessories/AccessoriesSelection";
import ShapeSelection from "./components/ShapeSelection";
import ZoomAndPan from "./components/zoomAndPan/ZoomAndPan";
import FloatingZoomControls from "./components/zoomControls/FloatingZoomControls";
import Resizer from 'react-image-file-resizer';
import UploadImage from "./components/uploadImage/UploadImage";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth"; // Import Firebase auth functions
import Auth from "./components/auth/Auth";
import Account from "./components/account/Account";
import CanvasPopup from "./components/canvasPopup/CanvasPopup";
// consolidated import from ./base (useAuth merged into the main import below)
import ItemColors from "./components/ItemColors";
import CustomPresetColors from "./components/colors/CustomPresetColors";
import Grids from "./components/options/grids/Grids";
import ToolsSelection from "./components/tools/ToolsSelection";
import EraserDraw from "./components/eraserDraw/EraserDraw";
import Calibration from "./components/calibration/Calibration";
import CalibrationDisplay from "./components/calibration/CalibrationDisplay";
import TransumSelectionView from "./components/options/transums/TransumSelectionView";
import $ from "jquery";
import ItemSelectionView from "./components/itemSelectionView/ItemSelectionView";
import AccessoriesSelectionView from "./components/accessories/AccessoriesSelectionView";
import OptionsSelectionView from "./components/optionsSelectionView/OptionsSelectionView";
import DoorsSelectionView from "./components/doorsSelectionView/DoorsSelectionView";
import addTransum from "./otherJS/HandleTransums";
import sidesSizeAndPosition from "./otherJS/sidesSizeAndPosition";
import { addDoors } from "./components/doors/handleDoors";
import { addGarageDoors } from "./components/doors/handleGarageDoors";
import { addWindows } from "./components/windows/handleWindows";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Spinner } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { availableLanguages, } from './i18nextConf';
import { customProps } from "./helpers/helpers";
import { createPortal } from 'react-dom';
import {
  saveCanvasState,
  undo,
  redo,
  removeAllObjects,
  removeAllObjects2,
  fadeObjects,
  changeAction,
  enableDraw,
  enableEraser,
  waitForAnimationFrames
} from "./helpers/helpers";
import { setObjectPerspective, getRelatedObject } from './helpers/fabricPerspective';
import {
  unGroupItems,
  groupItems,
  resetZoom,
  panZoomOut,
  panZoomIn,
  goLeft,
  goRight,
  goUp,
  goDown,
  objectfliphorizontal,
  objectflipvertical,
  cutItem,
  copyItem,
  pasteItem,
  copyAndPasteItem,
} from "./helpers/helpers";
import {
  db,
  getStorage,
  ref,
  storage,
  deleteObject,
  uploadString,
  uploadBytes,
  getDownloadURL,
  auth,
  logout,
  useAuth
} from "./base";
import {
  addDoc, collection, updateDoc, doc, getDoc, query,
  where, getDocs, setDoc, arrayUnion, Timestamp, onSnapshot
} from "firebase/firestore";
import { getMetadata } from "firebase/storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import useContextMenu from "./hooks/useContextMenu";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import SaveIcon from "@mui/icons-material/Save";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import "./index.css";
import "./mediaqueries.css";
import Banner1 from "./components/banners/Banner1";
import NewsBanner from "./components/banners/NewsBanner";
//consent and terms
import CombinedTermsOfUse from "./components/legal/CombinedTermsOfUse";
import CookieConsent from "react-cookie-consent";
import { Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import CombinedCookiePolicy from "./components/legal/CombinedCookiePolicy";
import ContentModal from './components/contentModal/ContentModal';
//email confirm
import EmailConfirmationSuccessModal from './components/emailConfirmation/EmailConfirmationSuccessModal';
import EmailVerificationPendingModal from './components/emailConfirmation/EmailVerificationPendingModal';
//chat
import FacadeDesigner from './components/designer/FacadeDesigner';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import ContactFormModal from './ContactFormModal';
import { Aod } from "@mui/icons-material";
import CustomTooltip from './components/toolTips/CustomToolTip';
import AccessoriesSelection from "./components/accessories/AccessoriesSelection";
import addAccessoryImage from "./components/accessories/addAccessoryImage";
//AI selection
import { triggerDetection } from './components/AI/aiDetections';
import { CanvasTooltip } from './components/toolTips/CanvasToolTip'; // Adjust the import path as needed
import SecondaryNav from "./components/secondaryNav/SecondaryNav";
import ScrollToTopButton from "./components/homepage/ScrollToTopButton";
import Home from "./components/homepage/Home";
import LoadingToast from "./components/toasts/LoadingToast";
import CanvasTutorialBadge from "./components/videoModal/CanvasTutorialBadge";
import { handleAnalyticsEvent, trackPageView } from "./helpers/analyticsHandler";
import { recordAdminJourneyEvent } from "./helpers/adminAnalytics";
import { activatePendingStandardTrial } from './helpers/standardTrial';
import { getDetectionImageUrl } from './helpers/detectionImageUrl';
import { hasLoadedFabricImage } from './helpers/fabricImageValidation';
import PricingSection from "./plans/PricingSection";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import NotFoundPage from "./components/homepage/404";

import { colorList } from "./components/colors/colorHelper"
// UserNoticeModal replaced by WhatsNewButton in SiteNav
// import UserNoticeModal from './components/userMessage/UserNoticeModal';  // Import the modal component
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { getColorByName } from './components/colors/colorUtils';

import WallTextureCanvas from './components/AI/WallTextureCanvas'; // Assuming this component displays the detected walls and textures

import Hammer from 'hammerjs';
import ItemDetailsModal from "./components/ItemDetailsModal";
import ReferenceDimensionModal from "./components/ReferenceDimensionModal";
// AI evaluation features removed - going directly to Designer
// import DesignVariationCarousel from "./components/carousel/DesignVariationCarousel"
import MenuComponent from "./components/menu/MenuComponent";
import SelectionComponent from "./components/itemSelectionView/SelectionComponent";
// AI evaluation features removed - going directly to Designer
// import { evaluateProjectImage } from "./components/AI/utility/evaluateProjectImage";
import { updateAllDimensions, getDimensionInfo, setReferenceItem, clearReferenceItem, isReferenceItem, inchesToCm, cmToInches } from './helpers/dynamicDimensionHelper';
// import { EvaluationProgress } from "./components/AI/utility/EvaluationProgress";




let optionUrl = "";
// let itemColor = "rgba(0, 0, 0, 1)";
const PENDING_ONBOARDING_REQUEST_KEY = 'facade_pending_onboarding_request';
const PENDING_POST_PURCHASE_RETURN_KEY = 'facade_pending_post_purchase_return';

const applyFabricTextBaselinePatch = (() => {
  let isPatched = false;

  return () => {
    if (isPatched || !fabric?.Text?.prototype) {
      return;
    }

    fabric.Text.prototype._setTextStyles = function setTextStyles(ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';

      if (this.path) {
        switch (this.pathAlign) {
          case 'center':
            ctx.textBaseline = 'middle';
            break;
          case 'ascender':
            ctx.textBaseline = 'top';
            break;
          case 'descender':
            ctx.textBaseline = 'bottom';
            break;
          default:
            break;
        }
      }

      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    };

    isPatched = true;
  };
})();

applyFabricTextBaselinePatch();

function EditorTrialWatermarkOverlay({ visible, label, fabricCanvas }) {
  const [container, setContainer] = React.useState(null);
  const [watermarkStyle, setWatermarkStyle] = React.useState(null);

  React.useEffect(() => {
    let mounted = true;

    const resolveContainer = () => {
      if (!mounted) return;

      const fabricWrapper = document.querySelector('.canvas-container');
      const canvasOuter = document.querySelector('.canvasContainer');

      if (fabricWrapper) {
        setContainer(fabricWrapper);
      } else if (canvasOuter) {
        setContainer(canvasOuter);
      } else {
        setContainer(null);
      }
    };

    resolveContainer();
    const timer = setTimeout(resolveContainer, 500);

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, [visible]);

  React.useEffect(() => {
    if (!visible || !container || !fabricCanvas) {
      setWatermarkStyle(null);
      return undefined;
    }

    const updateWatermarkPosition = () => {
      const lowerCanvasEl = container.querySelector('.lower-canvas');
      const backgroundImage = fabricCanvas.backgroundImage;

      if (!lowerCanvasEl || !backgroundImage) {
        setWatermarkStyle(null);
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const canvasRect = lowerCanvasEl.getBoundingClientRect();
      const fabricWidth = typeof fabricCanvas.getWidth === 'function' ? fabricCanvas.getWidth() : lowerCanvasEl.width;
      const fabricHeight = typeof fabricCanvas.getHeight === 'function' ? fabricCanvas.getHeight() : lowerCanvasEl.height;

      if (!fabricWidth || !fabricHeight) {
        setWatermarkStyle(null);
        return;
      }

      const rect = typeof backgroundImage.getBoundingRect === 'function'
        ? backgroundImage.getBoundingRect(true, true)
        : {
            left: backgroundImage.left || 0,
            top: backgroundImage.top || 0,
            width: (backgroundImage.width || 0) * (backgroundImage.scaleX || 1),
            height: (backgroundImage.height || 0) * (backgroundImage.scaleY || 1),
          };

      if (!rect.width || !rect.height) {
        setWatermarkStyle(null);
        return;
      }

      const scaleX = canvasRect.width / fabricWidth;
      const scaleY = canvasRect.height / fabricHeight;
      const canvasOffsetLeft = canvasRect.left - containerRect.left;
      const canvasOffsetTop = canvasRect.top - containerRect.top;
      const imageLeft = canvasOffsetLeft + rect.left * scaleX;
      const imageTop = canvasOffsetTop + rect.top * scaleY;
      const imageWidth = rect.width * scaleX;
      const imageHeight = rect.height * scaleY;
      const maxWidth = Math.max(180, imageWidth * 0.82);
      const bottomInset = Math.max(24, Math.min(64, imageHeight * 0.08));
      const watermarkLift = Math.max(52, Math.min(140, imageHeight * 0.16));

      setWatermarkStyle({
        left: imageLeft + imageWidth / 2,
        top: imageTop + imageHeight - bottomInset - watermarkLift,
        maxWidth,
      });
    };

    updateWatermarkPosition();

    const handleResize = () => {
      updateWatermarkPosition();
    };

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(() => updateWatermarkPosition())
      : null;

    resizeObserver?.observe(container);
    window.addEventListener('resize', handleResize);
    fabricCanvas.on?.('after:render', updateWatermarkPosition);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', handleResize);
      fabricCanvas.off?.('after:render', updateWatermarkPosition);
    };
  }, [visible, container, fabricCanvas]);

  if (!visible || !container || !watermarkStyle) {
    return null;
  }

  const overlay = (
    <div className="editorTrialWatermark" style={watermarkStyle} aria-hidden="true">
      {label}
    </div>
  );

  try {
    return createPortal(overlay, container);
  } catch (e) {
    return null;
  }
}

const App = () => {
  const { t, i18n } = useTranslation(["translation"]);

  const mainCanvasRef = useRef(null);
  const topBarRef = useRef(null);
  const menuRef = useRef(null);
  const hideLoaderTimeoutRef = useRef(null);
  const guestSessionGeneratedImageKeysRef = useRef(new Map());
  const lastGuestOpenedProjectIdRef = useRef(null);
  const generatedProjectImagesRef = useRef([]);
  const designerReferenceActionsRef = useRef(null);

  const currentUser = useAuth();
  const [authStateResolved, setAuthStateResolved] = useState(false);
  const [canvas, setCanvas] = useState("");
  const [canvasProject, setCanvasProject] = useState("");
  const [upload, setUpload] = useState(false);
  const [uploadImageUrl, setUploadImageUrl] = useState(null);
  // const [auth, setAuth] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalContext, setAuthModalContext] = useState(null);
  const [login, setLogin] = useState(false);
  const [isLoginOut, setIsLoginOut] = useState(false);
  const [account, setAccount] = useState(false);
  const [isSelectedItem, setIsSelectedItem] = useState(false);
  const [typeName, setTypeName] = useState("");
  const [itemColor, setItemColor] = useState("rgba(0, 0, 0, 1)");
  const [canvasProjectImage, setCanvasProjectImage] = useState("");
  const [projectName, setProjectName] = useState("");
  const [imageName, setImageName] = useState("");
  const [newProjectCreationName, setNewProjectCreationName] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [windowURL, setWindowURL] = useState(""); // window or door url
  const [windowGridType, setWindowGridType] = useState(""); // option type
  const [isSameType, setIsSameType] = useState(true);
  const [isMixMatched, setIsMixMatched] = useState(false);
  const [skewX, setSkewX] = useState(0);
  const [skewY, setSkewY] = useState(0);
  const [isSkewVisible, setIsSkewVisible] = useState(false);
  const [skewSliderLeft, setSkewSliderLeft] = useState("160px");
  const [skewSliderTop, setSkewSliderTop] = useState("65px");
  const [isObjSelected, setIsObjSelected] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthStateResolved(true);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!currentUser || currentUser.email?.startsWith('guest_')) {
      return;
    }

    try {
      sessionStorage.removeItem('adminGuestMode');
      sessionStorage.removeItem('adminGuestSourceRole');
    } catch (storageError) {
      console.warn('Unable to clear admin guest testing flag:', storageError);
    }
  }, [currentUser]);

  const [isPanelVisible, setIsPanelVisible] = useState(false);
  const [isAccessoriesPanelVisible, setIsAccessoriesPanelVisible] = useState(false);
  const [isOptionsPanelVisible, setIsOptionsPanelVisible] = useState(false);
  const [isTransumPanelVisible, setIsTransumPanelVisible] = useState(false);
  const [isAvaillableDoorsPanelVisible, setIsAvaillableDoorsPanelVisible] =
    useState(false);
  const [itemToSearch, setItemToSearch] = useState("");
  const [isProjectList, setIsProjectList] = useState(false);

  const [isSelectedShape, setIsSelectedShape] = useState(false);
  const [glassToSearch, setGlassToSearch] = useState(""); //size of glass
  const [stringToSearch, setStringToSearch] = useState(""); //door name and type
  const [stringToSearchSide, setStringToSearchSide] = useState(""); //side name
  const [isItemAdded, setIsItemAdded] = useState(false);
  const [backgroundImageStorageUrl, setBackgroundImageStorageUrl] =
    useState("");
  const [canvasImageName, setCanvasImageName] = useState("");
  const [isTransum, setIsTransum] = useState(false);
  const [isLoaderFinish, setIsLoaderFinish] = useState(false);

  const [selectedObject, setSelectedObject] = useState(null);

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState("");

  const [showLoader, setShowLoader] = useState(false);
  const [loaderConfig, setLoaderConfig] = useState({
    variant: 'generic',
    title: '',
    message: '',
    note: '',
  });
  const [loaderStartedAt, setLoaderStartedAt] = useState(null);
  const [loaderElapsedSeconds, setLoaderElapsedSeconds] = useState(0);
  const [isFocus, setIsFocus] = useState(false);

  const [isDragging, setIsDragging] = useState(false);
  
  // App state tracking for onboarding
  const [appState, setAppState] = useState({
    projectLoading: false,
    projectName: '',
    projectId: null,
    projectClicked: false,
    projectOpening: false,
    projectSetupStarted: false,
    projectSaved: false,
    hasActiveProjectLoaded: false,
    editorVisible: false,
    editorReady: false,
    canvasReady: false,
    accountModalOpen: false,
    aiDesignerVisible: false,
    aiShowModeSelected: false,
    aiMessageSent: false,
    aiProcessing: false,
    showMeClicked: false,
    aiDetectionStarted: false,
    detectionComplete: false,
    elementsPlaced: false
  });
  const [isZoomModalOpen, setIsZoomModalOpen] = useState(false);
  const [showCanvasPopupModal, setShowCanvasPopupModal] = useState(false);
  const [currentAction, setCurrentAction] = useState('select');
  const [brushWidth, setBrushWidth] = useState(10);
  const [isObjectSelected, setIsObjectSelected] = useState(false);
  const [hasCanvasChanged, setHasCanvasChanged] = useState(false);
  const [hasActiveProjectLoaded, setHasActiveProjectLoaded] = useState(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [isUnsavedActionLoading, setIsUnsavedActionLoading] = useState(false);
  const bypassUnsavedWarningRef = useRef(false);
  const pendingNavigationPathRef = useRef(null);
  const pendingNavigationCallbackRef = useRef(null);
  const currentRoutePathRef = useRef('');
  const historyTrapArmedRef = useRef(false);
  const pendingHistoryActionRef = useRef(null);
  const preNewProjectStateRef = useRef(null);
  const [eraseMode, setEraseMode] = useState(false);
  const [drawMode, setDrawMode] = useState(false);
  const [modeType, setModeType] = useState("");
  const [buttonClass, setButtonClass] = useState('before-after-button btn btn-light');
  const [bgImageProps, setBgImageProps] = useState([]);
  const [bgImagePositionProps, setBgImagePositionProps] = useState([])
  const [projects, setProjects] = useState([]);
  const [newProjectImage, setNewProjectImage] = useState("");
  const [generatedProjectImages, setGeneratedProjectImages] = useState([]);
  const [activeGeneratedImageUrl, setActiveGeneratedImageUrl] = useState("");
  useEffect(() => {
    generatedProjectImagesRef.current = generatedProjectImages;
  }, [generatedProjectImages]);
  const [generatedImageModalUrl, setGeneratedImageModalUrl] = useState("");
  const [isGeneratedImageModalOpen, setIsGeneratedImageModalOpen] = useState(false);
  const [generatedImageModalPosition, setGeneratedImageModalPosition] = useState({ x: 0, y: 0 });
  const [isFacadeAIGeneratingFromMenu, setIsFacadeAIGeneratingFromMenu] = useState(false);
  const [facadeAIGenerationElapsedFromMenu, setFacadeAIGenerationElapsedFromMenu] = useState(0);
  const generatedImageModalDragRef = useRef({
    isDragging: false,
    startX: 0,
    startY: 0,
    originX: 0,
    originY: 0,
  });
  const generatedImagePreviewRef = useRef(null);
  const generatedImagePreviewImgRef = useRef(null);
  const generatedImageLensRef = useRef(null);
  const generatedImagePreviewFrameRef = useRef(null);

  //calibration tool
  const [scaleFactor, setScaleFactor] = useState(1);
  const [projectScaleFactor, setProjectScaleFactor] = useState(null);
  const [knownLength, setKnownLength] = useState(10);
  const [dimension, setDimension] = useState('width');
  const [unit, setUnit] = useState('inches');
  const [showCalibrationOverlay, setShowCalibrationOverlay] = useState(false);
  const [pixelLength, setPixelLength] = useState(null);
  const [isCalibrationMode, setCalibrationMode] = useState(false);
  const [isCalibrating, setIsCalibrating] = useState(false);
  const [selectedObjectHeightReal, setSelectedObjectHeightReal] = useState(0);
  const [selectedObjectWidthReal, setSelectedObjectWidthReal] = useState(0);
  const [realDimensions, setRealDimensions] = useState({ width: 0, height: 0 });
  const [calibrationGroup, setCalibrationGroup] = useState(null);
  const [selectedObjectId, setSelectedObjectId] = useState(null);
  const [calibrationDisplay, setCalibrationDisplay] = useState(false);
  const [hasCalibration, setHasCalibration] = useState(false);
  //admin
  const [userRole, setUserRole] = useState(null);
  const [userAccessProfile, setUserAccessProfile] = useState(null);
  useEffect(() => {
    if (!currentUser?.uid || currentUser.email?.startsWith('guest_')) {
      setUserAccessProfile(null);
      return undefined;
    }

    return onSnapshot(doc(db, 'users', currentUser.uid), (snapshot) => {
      setUserAccessProfile(snapshot.exists() ? snapshot.data() : null);
    }, (error) => {
      console.error('Could not load user access profile:', error);
      setUserAccessProfile(null);
    });
  }, [currentUser?.uid, currentUser?.email]);
  //banner
  const [userPlan, setUserPlan] = useState(null);
  //client custom logo
  const [userCompanyName, setUserCompanyName] = useState(null);
  //cookies
  const [showConsentBanner, setShowConsentBanner] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const pagePath = `/app${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath);
  }, [location.pathname, location.search, location.hash]);
  const navigate = useNavigate();

  const logUnsavedGuard = (...args) => {
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    const event = {
      at: new Date().toISOString(),
      args,
    };

    if (typeof window !== 'undefined') {
      if (!Array.isArray(window.__UNSAVED_GUARD_EVENTS__)) {
        window.__UNSAVED_GUARD_EVENTS__ = [];
      }
      window.__UNSAVED_GUARD_EVENTS__.push(event);
      if (window.__UNSAVED_GUARD_EVENTS__.length > 200) {
        window.__UNSAVED_GUARD_EVENTS__.shift();
      }
    }

    return;
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development' || typeof window === 'undefined') {
      return;
    }

    if (!Array.isArray(window.__UNSAVED_GUARD_EVENTS__)) {
      window.__UNSAVED_GUARD_EVENTS__ = [];
    }
  }, []);
  //email confirm
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showEmailVerificationPending, setShowEmailVerificationPending] = useState(false);
  const [pendingVerificationEmail, setPendingVerificationEmail] = useState('');
  const [pendingVerificationUserName, setPendingVerificationUserName] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  //chat
  const [showModal, setShowModal] = useState(false);
  const [trialStatusNow, setTrialStatusNow] = useState(Date.now());
  //itemscolor eye dropper
  const [eyePickerActiveColor, setEyePickerActiveColor] = useState('');
  const bgImagePositionPropsRef = useRef(null);
  //contact form
  const [showContactForm, setShowContactForm] = useState(false);
  //help in canonical
  const getCanonicalPath = (pathname) => {
    if (pathname === '/' || pathname === '/en' || pathname === '/en/') {
      return '/en/';
    }
    if (pathname === '/fr' || pathname === '/fr/') {
      return '/fr/';
    }
    return pathname;
  };
  const getAlternateUrls = (pathname) => {
    return {
      en: 'https://facadewebapp.com/en/',
      fr: 'https://facadewebapp.com/fr/',
      default: 'https://facadewebapp.com/en/',
    };
  };
  const canonicalUrl = `https://facadewebapp.com${getCanonicalPath(location.pathname)}`;
  const { en: alternateEnUrl, fr: alternateFrUrl, default: alternateDefaultUrl } = getAlternateUrls(location.pathname);
  //beta news
  const [isNewsVisible, setIsNewsVisible] = useState(true);
  //accessories
  const [selectedAccessory, setselectedAccessory] = useState('');
  const [isAccessoryTypeSelected, setIsAccessoryTypeSelected] = useState(false);
  const [accessoryType, setAccessoryType] = useState('');
  const [isAccessoriesSelectionPanelVisible, setIsAccessoriesSelectionPanelVisible] = useState(false);
  //ai detection
  const [isDimensionsVisible, setIsDimensionsVisible] = useState(true);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false); // ✅ Set to false to prevent unwanted modal
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [toastId, setToastId] = useState(null);
  const [uploadComplete, setUploadComplete] = useState(false); // State to track upload completion
  const [editComplete, setEditComplete] = useState(false); // State to track upload completion

  // Add localStorage sync for userRole
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (userRole) {
      try {
        localStorage.setItem('userRole', userRole);
      } catch (e) {
        console.warn('Failed to set userRole in localStorage', e);
      }
    } else {
      try {
        localStorage.removeItem('userRole');
      } catch (e) {}
    }
  }, [userRole]);

  //walls and textures detections
  const [wallsAndTexturesDetections, setWallsAndTexturesDetections] = useState(null);
  const [detectionImage, setDetectionImage] = useState(null);
  const [detectionImageWidth, setDetectionImageWidth] = useState(null);
  const [detectionImageHeight, setDetectionImageHeight] = useState(null);

  //dVirtual designer


  const [isDesignerModalOpen, setDesignerModalOpen] = useState(false);
  const [isDetectionTriggered, setIsDetectionTriggered] = useState(false);
  const [designerTriggered, setDesignerTriggered] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [projectChangeKey, setProjectChangeKey] = useState(0);
  const [shouldShowEditorWatermark, setShouldShowEditorWatermark] = useState(false);

  const [movementX, setMovementX] = useState(0);
  const [movementY, setMovementY] = useState(0);
  const imageWidth = 5;
  const imageHeight = 20;

  const isGuestUser = currentUser && currentUser.email.startsWith("guest_");
  const isActiveStandardTrialForData = (data = userAccessProfile) => {
    if (data?.standardTrialStatus !== 'active' || !data?.standardTrialEndsAt) {
      return false;
    }

    const rawEndsAt = data.standardTrialEndsAt;
    const endsAt = typeof rawEndsAt?.toDate === 'function' ? rawEndsAt.toDate() : new Date(rawEndsAt);
    return endsAt.getTime() > Date.now();
  };

  const hasActiveStandardTrial = isActiveStandardTrialForData();
  const getTrialEndsAtDate = (data = userAccessProfile) => {
    const rawEndsAt = data?.standardTrialEndsAt;
    if (!rawEndsAt) {
      return null;
    }

    return typeof rawEndsAt?.toDate === 'function' ? rawEndsAt.toDate() : new Date(rawEndsAt);
  };

  const getUserPlanName = (data = userAccessProfile) => data?.planName || data?.planType || data?.currentPlan || null;

  const hasPaidPlanAccess = (data = userAccessProfile) => {
    const planName = getUserPlanName(data);
    const hasPaidPlan = ['my_project_plan', 'standard_plan', 'pro_plan', 'My Project', 'Standard', 'Pro'].includes(planName);
    const hasPurchasedProject = Number(data?.extraProjectPurchased || 0) > 0;
    const hasActiveSubscription = data?.isSubscription && ['active', 'cancel_at_period_end'].includes(data?.subscriptionStatus);

    return hasPaidPlan || hasPurchasedProject || hasActiveSubscription;
  };

  const trialEndsAtDate = getTrialEndsAtDate();
  const hasTrialHistory = Boolean(userAccessProfile?.standardTrialStartedAt || userAccessProfile?.standardTrialEndsAt);
  const isExpiredStandardTrial = Boolean(
    hasTrialHistory &&
    !hasActiveStandardTrial &&
    !hasPaidPlanAccess()
  );

  useEffect(() => {
    if (!hasActiveStandardTrial) {
      return undefined;
    }

    setTrialStatusNow(Date.now());
    const intervalId = window.setInterval(() => {
      setTrialStatusNow(Date.now());
    }, 60000);

    return () => window.clearInterval(intervalId);
  }, [hasActiveStandardTrial]);

  useEffect(() => {
    let isMounted = true;

    const syncEditorWatermarkVisibility = async () => {
      try {
        const shouldWatermark = await shouldWatermarkDownloadsForUser();
        if (isMounted) {
          setShouldShowEditorWatermark(Boolean(shouldWatermark));
        }
      } catch (error) {
        if (isMounted) {
          setShouldShowEditorWatermark(false);
        }
      }
    };

    syncEditorWatermarkVisibility();

    return () => {
      isMounted = false;
    };
  }, [currentUser?.uid, userRole, userAccessProfile]);

  const tooltipMessage = t('tooltip-message', {
    defaultValue: "This feature is only available for registered users.",
  });

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);

  // Reference dimension modal states
  const [isReferenceDimensionModalOpen, setIsReferenceDimensionModalOpen] = useState(false);
  const [referenceDimensionModalData, setReferenceDimensionModalData] = useState(null);
  const [isDoor, setIsDoor] = useState(false);
  const [activeObjectDetails, setActiveObjectDetails] = useState(null);
  const [selectedItemColor, setSelectedItemColor] = useState(null);
  const [roboflowFoundDetections, setRoboflowFoundDetections] = useState([]);
  const [geminiScaleFactor, setGeminiScaleFactor] = useState(null);
  const [isFixed, setIsFixed] = useState(true);
  const [isCanvasVisible, setIsCanvasVisible] = useState(true); // Tracks visibility of canvasContainer
  const [fileId, setFileId] = useState(true); // Tracks visibility of canvasContainer

  const [currentStep, setCurrentStep] = useState("uploading");
  // AI evaluation features removed - going directly to Designer
  // const [useAI, setUseAI] = useState(false);
  const [isCreatingNewProject, setIsCreatingNewProject] = useState(false); // ✅ Track new project creation
  const [isSettingProjectThumbnail, setIsSettingProjectThumbnail] = useState(false);
  const [hasJustLoggedIn, setHasJustLoggedIn] = useState(false); // ✅ Track when user just logged in
  const [hasJustSignedUp, setHasJustSignedUp] = useState(false); // ✅ Track when user just signed up
  const [isGoogleProcessing, setIsGoogleProcessing] = useState(false); // ✅ Track Google account processing
  const [saveConversationFunction, setSaveConversationFunction] = useState(null); // ✅ Store conversation save function
  const [isReturningFromStripe, setIsReturningFromStripe] = useState(false); // ✅ Track if user is returning from Stripe checkout
  const [authProcessed, setAuthProcessed] = useState(false); // ✅ Track if we've already processed auth for this session
  const [onboardingStartRequest, setOnboardingStartRequest] = useState(null);

  // ✅ Create stable callback to prevent setState during render
  const handleConversationSaveReady = useCallback((saveFunction) => {
    setSaveConversationFunction(() => saveFunction);
  }, []);

// Function to update step
const updateProgress = (step) => {
  setCurrentStep(step);
};


  // useEffect(() => {
  //   if (process.env.NODE_ENV === 'development') {
  //     console.log("Clearing IndexedDB for development...");
  //     indexedDB.deleteDatabase('firebaseLocalStorageDb');
  //     indexedDB.deleteDatabase('firestore/[appName]');
  //   }
  // }, []);

  const handleScroll = useCallback(() => {
    if (!canvasContainerRef.current) {
      return;
    }

    const containerRect = canvasContainerRef.current.getBoundingClientRect();
    const screenHeight = window.innerHeight;
    const hasRenderableHeight = containerRect.height > 0;

    // Keep the menu fixed until the canvas container has real dimensions.
    if (!hasRenderableHeight) {
      setIsFixed(true);
      return;
    }

    // Once the canvas bottom is inside the viewport, anchor the menu to the canvas.
    setIsFixed(containerRect.bottom > screenHeight);
  }, []);



  // Keep the menu position in sync with initial canvas layout, resize, and scroll.
  useLayoutEffect(() => {
    let frameId = null;
    let resizeObserver = null;

    const scheduleMenuPositionCheck = () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }

      frameId = requestAnimationFrame(() => {
        handleScroll();

        frameId = requestAnimationFrame(() => {
          handleScroll();
        });
      });
    };

    scheduleMenuPositionCheck();

    window.addEventListener("scroll", scheduleMenuPositionCheck, { passive: true });
    window.addEventListener("resize", scheduleMenuPositionCheck);
    window.addEventListener("load", scheduleMenuPositionCheck);

    if (typeof ResizeObserver !== "undefined" && canvasContainerRef.current) {
      resizeObserver = new ResizeObserver(() => {
        scheduleMenuPositionCheck();
      });
      resizeObserver.observe(canvasContainerRef.current);
    }

    return () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("scroll", scheduleMenuPositionCheck);
      window.removeEventListener("resize", scheduleMenuPositionCheck);
      window.removeEventListener("load", scheduleMenuPositionCheck);
    };
  }, [handleScroll, projectName, showCalibrationOverlay]);



  let modalTitle, modalContent;
  if (location.pathname === '/cookies') {
    modalTitle = t('Cookie Policy');
    modalContent = <CombinedCookiePolicy />;
  } else if (location.pathname === '/terms') {
    modalTitle = t('Terms of Use');
    modalContent = <CombinedTermsOfUse />;
  }


  // Old notice system replaced by WhatsNewButton
  // useEffect(() => {
  //   if (currentUser && !localStorage.getItem('importantNoticeDismissed')) {
  //     setShowNotice(true);
  //   }
  // }, [currentUser]);

  // const handleCloseNotice = () => {
  //   setShowNotice(false);
  //   localStorage.setItem('importantNoticeDismissed', 'true');
  // };

  useEffect(() => {
    if (location.pathname === '/cookies' || location.pathname === '/terms') {
      setModalOpen(true);
    } else {
      setModalOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const userConsentCookie = document.cookie.split('; ').find(row => row.startsWith('user_consent='));
    setTermsAccepted(userConsentCookie)


  }, [termsAccepted]);

  // ✅ Detect when user is returning from Stripe success page
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get('session_id');
    const canceled = queryParams.get('canceled'); // Check if transaction was canceled
    const isSuccessRoute = location.pathname === '/success' || location.pathname.endsWith('/success');
    
    // If user is on success page with session_id OR canceled flag, they're returning from Stripe
    if (isSuccessRoute && (sessionId || canceled)) {
      setIsReturningFromStripe(true);
      
      // Also reset login flags to prevent delayed modal appearance
      setHasJustLoggedIn(false);
      setHasJustSignedUp(false);
      setAuthProcessed(true); // Mark auth as processed to prevent re-processing
      
      // Reset the flag after a delay to allow normal modal behavior later
      const timeoutId = setTimeout(() => {
        setIsReturningFromStripe(false);
      }, 15000); // Extended to 15 seconds to be safe
      
      return () => clearTimeout(timeoutId);
    } else if (!isSuccessRoute) {
      // Reset flags when user navigates away from success page
      setIsReturningFromStripe(false);
      setAuthProcessed(false); // Reset auth processed flag for new sessions
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const isSuccessRoute = location.pathname === '/success' || location.pathname.endsWith('/success');
    if (isSuccessRoute) {
      return;
    }

    if (!currentUser || currentUser.email?.startsWith('guest_')) {
      return;
    }

    try {
      const pendingRequestRaw = sessionStorage.getItem(PENDING_ONBOARDING_REQUEST_KEY);
      if (!pendingRequestRaw) {
        return;
      }

      const pendingRequest = JSON.parse(pendingRequestRaw);
      if (!pendingRequest?.flow) {
        sessionStorage.removeItem(PENDING_ONBOARDING_REQUEST_KEY);
        return;
      }

      setOnboardingStartRequest({
        flow: pendingRequest.flow,
        startStep: pendingRequest.startStep || null,
        force: Boolean(pendingRequest.force),
        token: `pending-${currentUser.uid}-${Date.now()}`
      });
      setAuthProcessed(true);
      sessionStorage.removeItem(PENDING_ONBOARDING_REQUEST_KEY);
      sessionStorage.removeItem(PENDING_POST_PURCHASE_RETURN_KEY);
    } catch (error) {
      console.warn('Failed to restore pending onboarding request:', error);
      sessionStorage.removeItem(PENDING_ONBOARDING_REQUEST_KEY);
      sessionStorage.removeItem(PENDING_POST_PURCHASE_RETURN_KEY);
    }
  }, [currentUser, location.pathname]);

  // ✅ Function to close email verification pending modal
  const closeEmailVerificationPendingModal = useCallback(() => {
    setShowEmailVerificationPending(false);
    setPendingVerificationEmail('');
    setPendingVerificationUserName('');
  }, []);

  const handleVerifiedEmailState = useCallback(async (verifiedUser) => {
    if (!verifiedUser || !verifiedUser.uid) {
      return;
    }

    if (!verifiedUser.emailVerified) {
      return;
    }

    try {
      const userDocRef = doc(db, 'users', verifiedUser.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const trialActivated = await activatePendingStandardTrial(db, verifiedUser);
        if (trialActivated) {
          await recordAdminJourneyEvent(db, {
            eventName: 'trial_activated', userId: verifiedUser.uid, email: verifiedUser.email,
            source: userData.standardTrialSource || 'email_link',
          });
          handleAnalyticsEvent('trial_email_verified', 'trial', 'email_link');
          handleAnalyticsEvent('trial_activated', 'trial', 'email_verified');
        }
        if (!userData.emailConfirmed || userData.email !== verifiedUser.email) {
          await updateDoc(userDocRef, {
            emailConfirmed: true,
            ...(verifiedUser.email ? { email: verifiedUser.email } : {}),
            emailVerificationSyncedAt: Timestamp.now(),
          });
        }
      }
    } catch (error) {
      console.error('Error handling verified email state:', error);
      // Keep the pending dialog open so its polling can retry an interrupted trial activation.
      return;
    }

    // Keep tabs in sync so pending modals close everywhere once verification is done.
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('facade_email_verified', String(Date.now()));

      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('emailVerified')) {
        currentUrl.searchParams.delete('emailVerified');
        const nextUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
        window.history.replaceState({}, document.title, nextUrl);
      }
    }

    closeEmailVerificationPendingModal();
    setShowAuthModal(false);
    setShowCanvasPopupModal(false);
    setShowConfirmationModal(true);
  }, [closeEmailVerificationPendingModal]);

  const handleDismissPendingVerificationToLogin = useCallback(async () => {
    closeEmailVerificationPendingModal();
    setShowAuthModal(false);

    try {
      const authUser = auth.currentUser;
      if (authUser && !authUser.emailVerified) {
        await logout();
      }
    } catch (error) {
      console.error('Error signing out unverified user:', error);
    }

    setLogin(true);
    setIsLoginOut(false);
    setShowAuthModal(true);
  }, [closeEmailVerificationPendingModal]);

  useEffect(() => {
    // Parse the query parameters
    const queryParams = new URLSearchParams(location.search);
    const emailVerifiedParam = queryParams.get('emailVerified') === 'true';
    const signedInUser = auth.currentUser || currentUser;

    if (emailVerifiedParam && signedInUser) {
      const syncVerifiedState = async () => {
        try {
          await signedInUser.reload();
          if (signedInUser.emailVerified) {
            await handleVerifiedEmailState(signedInUser);
          }
        } catch (error) {
          console.error('Error reloading user after email verification:', error);
        }
      };

      syncVerifiedState();
    }

    // Open auth modal directly when entering from landing links, e.g. /app/en?auth=login|signup
    const authAction = queryParams.get('auth');
    const loginFlag = queryParams.get('login') === 'true';
    if (!signedInUser && (authAction === 'login' || authAction === 'signup' || loginFlag)) {
      setLogin(authAction === 'signup' ? false : true);
      setIsLoginOut(false);
      setShowAuthModal(true);
    }
  }, [currentUser, location.search, i18n.language, handleVerifiedEmailState]);




  const sendWelcomeEmail = async (user, language) => {
    const payload = {
      userData: {
        email: user.email,
        name: user.name
      },
      language: language,
      includeSpamNotice: true // Flag to include spam folder notice
    };

    // http://localhost:9999/.netlify/functions/sendWelcomeEmail /.netlify/functions/sendWelcomeEmail

    try {
      const response = await fetch('/.netlify/functions/sendWelcomeEmail', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  // ✅ Function to show email verification pending modal
  const showEmailVerificationPendingModal = (email, userName) => {
    setPendingVerificationEmail(email);
    setPendingVerificationUserName(userName);
    setShowEmailVerificationPending(true);
  };

  // ✅ Monitor user email verification status
  useEffect(() => {
    let verificationCheckInterval = null;
    
    if (showEmailVerificationPending) {
      verificationCheckInterval = setInterval(async () => {
        const authUser = auth.currentUser;
        if (!authUser) {
          return;
        }

        try {
          await authUser.reload();
          if (authUser.emailVerified) {
            await handleVerifiedEmailState(authUser);
          }
        } catch (error) {
          console.error('Error while checking email verification status:', error);
        }
      }, 2000); // Check every 2 seconds
    }

    return () => {
      if (verificationCheckInterval) {
        clearInterval(verificationCheckInterval);
      }
    };
  }, [showEmailVerificationPending, handleVerifiedEmailState]);

  // ✅ Cross-tab sync: when verification completes in another tab, close this pending state too.
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'facade_email_verified' && event.newValue) {
        closeEmailVerificationPendingModal();
        setShowAuthModal(false);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [closeEmailVerificationPendingModal]);

  const originalRotationAngle = 0;

  let lastX = 0;
  let lastY = 0;
  let pausePanning = false;
  let zoomStartScale = 1;
  let rightDecorativeGlass;
  let rightSidelightDecorativeGlass;
  let leftSidelightDecorativeGlass;
  let rightLeftSidelightDecorativeGlassLeft;
  let rightLeftSidelightDecorativeGlassRight;
  let sidelightFallbackUrl = '';  // Fallback for missing sidelight sizes



  const initCanvas = () => {
    // Create a new Fabric.js canvas instance with performance optimizations
    const canvas = new fabric.Canvas("canv", {
      index: 0,
      state: [],
      // backgroundColor: "#333",
      stateaction: true,
      fireRightClick: true,
      selection: false,
      // ✅ Performance optimizations with better quality
      renderOnAddRemove: true,  // Enable automatic render when items are added/removed
      skipTargetFind: false,     // Allow target finding but optimize when possible
      enableRetinaScaling: true, // Enable for high-quality rendering on retina displays
      imageSmoothingEnabled: true,
      preserveObjectStacking: true
    });

    // ✅ Optimize canvas context for high-quality rendering
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high'; // Use high quality for better image rendering
    
    // ✅ Keep object caching disabled for flexibility
    fabric.Object.prototype.objectCaching = false;
    fabric.Object.prototype.statefullCache = false;

    return canvas;
  };

  let canvasHeight = canvas.height;
  let canvasWidth = canvas.width;

  // toast for consent
  const ConsentToast = () => (
    <div style={{ textAlign: 'center' }}>
      <div>{t('toast.message')}</div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
        <button style={{ marginRight: '10px' }} onClick={handleAccept}>
          {t('toast.accept')}
        </button>
        <button onClick={handleDecline}>
          {t('toast.decline')}
        </button>
      </div>
    </div>
  );

  useEffect(() => {
    // Check if the cookies are set at the start
    if (document.cookie.includes("user_consent_beta=true") && document.cookie.includes("user_consent=true")) {
      setShowConsentBanner(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Check for the presence of the user_consent cookie using the native browser API
      const userConsentCookie = document.cookie.split('; ').find(row => row.startsWith('user_consent='));
      if (!userConsentCookie) {
        toast(<ConsentToast />, {
          position: "bottom-center",
          autoClose: false,
          closeOnClick: false,
          pauseOnHover: true,
          closeButton: false,
          toastId: "consent-toast"
        });
      }
    }, 20000); // 20 seconds delay

    return () => clearTimeout(timer);
  }, []);


  //   const {
  //     anchorPoint,
  //     showMenu,
  // } = useContextMenu(menuRef, isDragging);
  useEffect(() => {
    let cancelled = false;
    const fetchUserRole = async (retryCount = 0, maxRetries = 3) => {
      if (!currentUser) {
        setIsAccountModalOpen(false);
        return;
      }

      try {
        const userDocRef = doc(db, "users", currentUser.uid);

        // For new users, try server-first to get latest data
        const userDocSnapshot = await getDoc(userDocRef);

        if (userDocSnapshot.exists()) {
          const { role, planType, companyName } = userDocSnapshot.data();
          if (!cancelled) {
            setUserRole(role);
            setUserPlan(planType);
            setUserCompanyName(companyName);
          }
        } else {
          // If user document doesn't exist and we have retries left, wait and retry
          if (retryCount < maxRetries) {
            setTimeout(() => {
              if (!cancelled) fetchUserRole(retryCount + 1, maxRetries);
            }, 1000);
            return;
          }
          console.warn(`No user data found for UID: ${currentUser.uid} after ${maxRetries} retries`);
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
        // If there's an error and we have retries left, try again
        if (retryCount < maxRetries) {
          setTimeout(() => {
            if (!cancelled) fetchUserRole(retryCount + 1, maxRetries);
          }, 1000);
        }
      }
    };

    fetchUserRole();
    return () => { cancelled = true; };
  }, [currentUser]);


  useEffect(() => {
    // fixed the double canvas by conditionning creation of the canvas with the current user state
    if (currentUser) {
      // handleShowLoader();
      setIsLoaderFinish(false);
      setCanvas(initCanvas());
      // handleHideLoader(); // Move hideLoader() inside the timeout callback

    }
  }, [currentUser]);

  // ✅ Batch rendering optimization to reduce expensive render calls
  let renderTimeout = null;
  const batchRender = () => {
    if (renderTimeout) clearTimeout(renderTimeout);
    renderTimeout = setTimeout(() => {
      if (canvas) {
        canvas.renderAll();
      }
    }, 16); // ~60fps batching
  };

  // ✅ Image preloading cache for faster loading
  const imageCache = new Map();
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (imageCache.has(url)) {
        resolve(imageCache.get(url));
        return;
      }
      
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        imageCache.set(url, img);
        resolve(img);
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  // Function to update Fabric.js settings based on zoom level
  const updateFabricSettings = (zoom = 1) => {
    const isTouchDevice =
      typeof window !== "undefined" &&
      ("ontouchstart" in window ||
        (typeof navigator !== "undefined" && navigator.maxTouchPoints > 0));

    const baseCornerSize = isTouchDevice ? 42 : 28;
    const baseTouchSize = isTouchDevice ? 72 : 44;
    const baseControlOffset = isTouchDevice ? 26 : 18;
    const rotationOffset = isTouchDevice ? 90 : 55;

    const cornerSize = baseCornerSize / zoom;
    const controlOffset = baseControlOffset / zoom;
    const rotationCursorHandler =
      fabric.controlsUtils.rotationStyleHandler ||
      fabric.controlsUtils.rotationCursorStyleHandler;

    fabric.Object.prototype.cornerSize = cornerSize;
    fabric.Object.prototype.touchCornerSize = baseTouchSize;
    fabric.Object.prototype.cornerStyle = "circle";
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = "#0d6efd";
    fabric.Object.prototype.cornerStrokeColor = "#ffffff";
    fabric.Object.prototype.cornerStrokeWidth = 2;
    fabric.Object.prototype.cornerHitTolerance = Math.max(14, baseTouchSize / 3) / zoom;
    fabric.Object.prototype.padding = Math.max(8, baseCornerSize / 3) / zoom;
    fabric.Object.prototype.hasControls = true;
    fabric.Object.prototype.lockUniScaling = false;
    fabric.Object.prototype.rotatingPointOffset = rotationOffset / zoom;

    const touchSize = {
      touchSizeX: baseTouchSize,
      touchSizeY: baseTouchSize,
    };

    fabric.Object.prototype.controls = {
      ...fabric.Object.prototype.controls,
      tl: new fabric.Control({
        x: -0.5,
        y: -0.5,
        offsetX: -controlOffset,
        offsetY: -controlOffset,
        actionHandler: fabric.controlsUtils.scalingEqually,
        cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
        render: fabric.controlsUtils.renderCircleControl,
        ...touchSize,
      }),
      tr: new fabric.Control({
        x: 0.5,
        y: -0.5,
        offsetX: controlOffset,
        offsetY: -controlOffset,
        actionHandler: fabric.controlsUtils.scalingEqually,
        cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
        render: fabric.controlsUtils.renderCircleControl,
        ...touchSize,
      }),
      bl: new fabric.Control({
        x: -0.5,
        y: 0.5,
        offsetX: -controlOffset,
        offsetY: controlOffset,
        actionHandler: fabric.controlsUtils.scalingEqually,
        cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
        render: fabric.controlsUtils.renderCircleControl,
        ...touchSize,
      }),
      br: new fabric.Control({
        x: 0.5,
        y: 0.5,
        offsetX: controlOffset,
        offsetY: controlOffset,
        actionHandler: fabric.controlsUtils.scalingEqually,
        cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
        render: fabric.controlsUtils.renderCircleControl,
        ...touchSize,
      }),
      mtr: new fabric.Control({
        x: 0,
        y: -0.5,
        offsetY: -rotationOffset / zoom,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        cursorStyleHandler: rotationCursorHandler,
        render: fabric.controlsUtils.renderCircleControl,
        ...touchSize,
      }),
    };
  };

  useEffect(() => {
    // handleShowLoader();
    if (!canvas) {
      handleHideLoader();
      return;
    }

    canvas.setDimensions({
      width: 1200,
      height: 1200,
    });

    updateFabricSettings(1);

    // Add zoom event listener to dynamically update control settings
    const handleZoom = () => {
      const zoom = canvas.getZoom();
      updateFabricSettings(zoom); // Update control settings based on zoom level
    };

    canvas.on("mouse:wheel", (opt) => {
      const delta = opt.e.deltaY;
      let zoom = canvas.getZoom();
      zoom *= 0.999 ** delta;
      zoom = Math.max(0.2, Math.min(zoom, 5)); // Limit zoom level
      
      // Zoom to cursor position for better UX
      const pointer = canvas.getPointer(opt.e);
      canvas.zoomToPoint(pointer, zoom);
      
      opt.e.preventDefault();
      opt.e.stopPropagation();
      handleZoom(); // Trigger control update after zoom change
    });
    canvasHeight = canvas.height;
    canvasWidth = canvas.width;
    initCanvasEvents(setIsDragging);
    initKeyboardEvents();
    if (projectName) setIsLoaderFinish(true);
    // handleHideLoader();

    // Cleanup events on unmount
    return () => {
      canvas.off("mouse:wheel");
      document.removeEventListener("keyup", initKeyboardEvents);
    };
  }, [canvas]);

  const handlePan = (deltaX, deltaY) => {
    panCanvas(canvas, { x: deltaX, y: deltaY });
  };


  // Set up Hammer.js for gesture recognition
  useEffect(() => {
    if (!canvas) return;

    const container = canvasContainerRef.current;
    let zoomStartScale = canvas.getZoom();
    const originalZoom = 1;  // Assume this is the original zoom level of the canvas
    const minZoomLevel = originalZoom;  // Minimum zoom level should be the original size

    if (container) {

      const hammer = new Hammer(container);
      hammer.get('pinch').set({ enable: true });
      hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });

      // Function to check if any object is active
      const isObjectActive = () => {
        const activeObject = canvas.getActiveObject();

        return activeObject !== null && activeObject !== undefined;
      };

      // Handle pinch start to initialize zoom level
      hammer.on('pinchstart', () => {
        if (isObjectActive()) return;  // Disable pinch if an object is active
        zoomStartScale = canvas.getZoom();

      });

      // Handle pinch to zoom in/out with restricted minimum zoom level
      hammer.on('pinch', (e) => {
        if (isObjectActive()) return;  // Disable zoom if an object is active
        const newZoomLevel = Math.max(minZoomLevel, zoomStartScale * e.scale);  // Restrict zoom-out level


        applyCenteredZoom(canvas, newZoomLevel);
      });

      const PAN_SENSITIVITY = 0.15;

      // Handle pan to move the canvas, conditionally applied if no object is active
      hammer.on('pan', (e) => {
        if (isObjectActive()) return;  // Disable pan if an object is active

        const deltaX = e.deltaX * PAN_SENSITIVITY;
        const deltaY = e.deltaY * PAN_SENSITIVITY;

        panCanvas(canvas, { x: deltaX, y: deltaY });

      });

      // Reset panning position on pan end for smooth control
      hammer.on('panend', () => {

      });

      // Clean up Hammer.js instance
      return () => {
        hammer.destroy();

      };
    } else {
      return;
    }
  }, [canvas]);

  const handleTouchMoveX = (newX) => {
    const deltaX = newX - movementX;
    setMovementX(newX);
    panCanvas(canvas, { x: deltaX, y: 0 });
  };

  const handleTouchMoveY = (newY) => {
    const deltaY = newY - movementY;
    setMovementY(newY);
    panCanvas(canvas, { x: 0, y: deltaY });
  };



  function panCanvas(canvas, delta) {
    const vpt = canvas.viewportTransform.slice(0); // Clone the viewport transform

    // Apply the delta
    vpt[4] += delta.x;
    vpt[5] += delta.y;

    // Get scaled canvas dimensions
    const canvasWidth = canvas.getWidth() * canvas.getZoom();
    const canvasHeight = canvas.getHeight() * canvas.getZoom();

    // Set container boundaries (update as per actual container size)
    const containerWidth = 1280;
    const containerHeight = 720;

    // Boundary checks to keep the canvas within bounds
    vpt[4] = Math.min(0, Math.max(vpt[4], containerWidth - canvasWidth));
    vpt[5] = Math.min(0, Math.max(vpt[5], containerHeight - canvasHeight));

    // Apply the new viewport transform to the canvas

    canvas.setViewportTransform(vpt);
    canvas.renderAll();
  }



  const applyCenteredZoom = (canvas, newZoom) => {
    const zoomPoint = new fabric.Point(canvas.width / 2, canvas.height / 2);


    // Directly apply zoom at the specified point
    canvas.zoomToPoint(zoomPoint, newZoom);
    canvas.requestRenderAll();
  };


  useEffect(() => {
    if (selectedObject) {

      setIsSelectedItem(true)
      // React to changes in selectedObject

    }
  }, [selectedObject]);


  useEffect(() => {
    if (canvas) {
      // Handle selection events
      const handleSelection = (event) => {
        const selectedObject = event.selected?.[0];
        if (selectedObject) {
          // Extract itemColor (fill or stroke)
          const color = selectedObject.fill || selectedObject.stroke || "rgba(255, 255, 255, 1)";
          setSelectedItemColor(color); // Save to state
        }
      };

      const clearSelection = () => {
        setSelectedItemColor(null); // Reset the color when selection is cleared
      };

      // Listen to canvas events
      canvas.on("selection:created", handleSelection);
      canvas.on("selection:updated", handleSelection);
      canvas.on("selection:cleared", clearSelection);

      canvas.on("object:added", (event) => {
        const addedObject = event.target; // Get the added object

        if (addedObject && addedObject._objects?.[1]) {
          // Reset the custom property on the object
          addedObject._objects[1].windowGridType = null;
        }

        // Reset modal-related state
        setWindowGridType(null);
        setIsDoor(false);
      });

      return () => {
        if (canvas) {
          canvas.off("selection:created", handleSelection);
          canvas.off("selection:updated", handleSelection);
          canvas.off("selection:cleared", clearSelection);
        }
      };
    }
  }, [canvas]);


  useEffect(() => {
    if (canvas && !isExpiredStandardTrial) {

      updateColor(itemColor);
    }
  }, [itemColor, canvas, isExpiredStandardTrial]);

  // Keep start/open project flow manual via navbar actions.
  useEffect(() => {
    // Keep auth flags clean without auto-opening modal.
    if (hasJustLoggedIn) {
      setHasJustLoggedIn(false);
    }

    if (hasJustSignedUp && !isGoogleProcessing) {
      setHasJustSignedUp(false);
    }

    // Hide modal if user loads a project or starts creating one.
    if ((projectName || isCreatingNewProject) && showCanvasPopupModal) {
      setShowCanvasPopupModal(false);
    }
  }, [hasJustLoggedIn, hasJustSignedUp, isGoogleProcessing, projectName, isCreatingNewProject, showCanvasPopupModal]);

  // ✅ Detect login vs signup events by monitoring currentUser changes
  useEffect(() => {
    if (currentUser && !authProcessed) {
      const hasPendingPostPurchaseReturn = (() => {
        try {
          return sessionStorage.getItem(PENDING_POST_PURCHASE_RETURN_KEY) === 'true';
        } catch (storageError) {
          return false;
        }
      })();

      // Check if this is a new user (signup) by checking if user was created very recently
      const creationTime = new Date(currentUser.metadata?.creationTime);
      const lastSignInTime = new Date(currentUser.metadata?.lastSignInTime);
      const timeDifference = Math.abs(lastSignInTime - creationTime);
      
      // If creation and last sign-in are within 10 seconds, consider it a new signup
      const isNewUser = timeDifference < 10000; // 10 seconds
      
      // Don't set login flags if user is returning from Stripe
      if (isReturningFromStripe || hasPendingPostPurchaseReturn) {
        setAuthProcessed(true); // Still mark as processed to prevent future runs
        return;
      }
      
      if (isNewUser) {
        setHasJustSignedUp(true);
        setHasJustLoggedIn(false);
        // Ensure Auth modal is closed for new signups
        setShowAuthModal(false);
        setOnboardingStartRequest({
          flow: 'signup',
          startStep: 'purchase-plan',
          token: `signup-${currentUser.uid}-${Date.now()}`
        });
      } else {
        setHasJustLoggedIn(true);
        setHasJustSignedUp(false);
      }
      
      setAuthProcessed(true); // Mark as processed
    } else if (!currentUser) {
      // Reset flags when no user
      setHasJustLoggedIn(false);
      setHasJustSignedUp(false);
      setAuthProcessed(false);
    }
  }, [currentUser, isReturningFromStripe, authProcessed]);

  useEffect(() => {
    if (canvas) {
      canvas.forEachObject((obj) => {
        if (eraseMode) {

          // console.log("opacity custom prop :", obj.originalOpacity)
          if (!obj.originalOpacity) obj.originalOpacity = obj.opacity || 1; // Store original opacity if not set
          obj.set({ opacity: 0.4 }); // Apply eraser opacity
        } else {
          obj.set({ opacity: obj.originalOpacity || 1 }); // Revert to original opacity
        }
      });
      canvas.renderAll();
    }
  }, [canvas, eraseMode]);


  useEffect(() => {
    if (canvasProject) {
      const scaleFactor = canvasProject.scaleFactor || null;

      if (scaleFactor !== null) {
        setHasCalibration(true);
        setScaleFactor(scaleFactor);

      } else {
        setHasCalibration(false);
      }
    }
  }, [canvasProject]);

  // Remember that this browser has seen a real account session.
  useEffect(() => {
    if (!currentUser || currentUser.email?.startsWith('guest_')) {
      return;
    }

    try {
      localStorage.setItem('facade_known_account', 'true');
      if (currentUser.email) {
        localStorage.setItem('facade_known_account_email', currentUser.email);
      }
    } catch (storageError) {
      console.warn('Unable to persist known account marker:', storageError);
    }
  }, [currentUser]);


  useEffect(() => {
    if (canvas) {
      const handleSelection = (options) => {

        if (options.selected[0]) {
          let relevantId;

          if (options.selected[0].windowStackImageId) {
            relevantId = options.selected[0].windowStackImageId;
          } else if (options.selected[0].doorStackImageId) {
            relevantId = options.selected[0].doorStackImageId;
          }


          if (relevantId !== selectedObjectId) {
            setSelectedObjectId(relevantId);

            const selectedObject = options.selected[0];
            const actualWidth = selectedObject.width * selectedObject.scaleX;
            const actualHeight = selectedObject.height * selectedObject.scaleY;

            const realWidth = (selectedObject.width * selectedObject.scaleX) * scaleFactor;
            const realHeight = (selectedObject.height * selectedObject.scaleY) * scaleFactor;

            setRealDimensions({ width: realWidth.toFixed(2), height: realHeight.toFixed(2) });

          }
        }
      };

      canvas.on('selection:created', handleSelection);
      canvas.on('selection:updated', handleSelection);

      // Also handle the case where the selection is cleared
      canvas.on('selection:cleared', () => {
        setSelectedObjectId(null);
      });

      return () => {
        canvas.off('selection:created', handleSelection);
        canvas.off('selection:updated', handleSelection);
        canvas.off('selection:cleared');
      };
    }
  }, [selectedObjectId, canvas, scaleFactor]);


  useEffect(() => {
    if (calibrationGroup && isCalibrationMode) {

      const handleModified = () => {

        const newPixelLengthScaled = dimension === 'width'
          ? calibrationGroup.width * calibrationGroup.scaleX
          : calibrationGroup.height * calibrationGroup.scaleY;

        handlePixelLengthSet(newPixelLengthScaled);
      };


      calibrationGroup.on('modified', handleModified);
      calibrationGroup.on('selected', handleModified);
      calibrationGroup.on('upddated', handleModified);


      // Cleanup: remove the event listener when the component is unmounted or conditions change
      return () => {
        calibrationGroup.off('modified', handleModified);
        calibrationGroup.off('selected', handleModified);
        calibrationGroup.off('upddated', handleModified);
      };
    }
  }, [calibrationGroup, isCalibrationMode, dimension]);

  useEffect(() => {
    if (canvas) {
      const toggleScrolling = () => {
        if (canvas.isDrawingMode) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
      };

      // Attach listener to detect changes in `isDrawingMode`
      canvas.on('mouse:down', toggleScrolling);
      canvas.on('mouse:up', toggleScrolling);
      canvas.on('mouse:out', toggleScrolling);

      // Cleanup on unmount
      return () => {
        canvas.off('mouse:down', toggleScrolling);
        canvas.off('mouse:up', toggleScrolling);
        canvas.off('mouse:out', toggleScrolling);
      };
    }
  }, [canvas.isDrawingMode]);



  useEffect(() => {
    if (canvas) {

      const handleModified = (options) => {
        if (options.target) {
          const modifiedObject = options.target;
          
          // ✅ Update dimensions for all objects when any door/window is scaled
          if (modifiedObject && (modifiedObject.itemType === 'doors' || modifiedObject.itemType === 'window')) {
            // Update dimensions for all objects based on the new scale
            const updateResult = updateAllDimensions(canvas);
          }
          
          // Keep the existing scaling behavior for background image  
          const actualWidth = modifiedObject.width * modifiedObject.scaleX;
          const actualHeight = modifiedObject.height * modifiedObject.scaleY;

          const realWidth = (modifiedObject.width * modifiedObject.scaleX) * scaleFactor;
          const realHeight = (modifiedObject.height * modifiedObject.scaleY) * scaleFactor;

          // Update your React state to reflect the new dimensions
          setRealDimensions({ width: realWidth.toFixed(2), height: realHeight.toFixed(2) });
        }
      };

      canvas.on('object:modified', handleModified);

      return () => {
        canvas.off('object:modified', handleModified);
      };
    }
  }, [canvas, scaleFactor]);

  useEffect(() => {
    // Extract the language code from the URL path
    const languageCode = window.location.pathname.split('/')[1];
    
    // First check if there's a stored language preference
    const storedLanguage = localStorage.getItem('i18nextLng');
    
    // Check if user has manually selected a language (stored in localStorage)
    const hasManualSelection = storedLanguage && availableLanguages.includes(storedLanguage);
    
    // Priority order: URL language > manual selection (localStorage) > browser language
    if (availableLanguages.includes(languageCode)) {
      // URL has a valid language code - use it and update localStorage
      i18n.changeLanguage(languageCode);
    } else if (hasManualSelection) {
      // Use stored language preference from manual selection
      i18n.changeLanguage(storedLanguage);
    } else {
      // Fallback to browser's language setting only if no manual selection exists
      const browserLang = i18n.language || window.navigator.language.split('-')[0];
      i18n.changeLanguage(browserLang);
    }
  }, [i18n, location.pathname]);



  const canvasContainerRef = useRef(null);

  const knownLengthRef = useRef(knownLength);

  useEffect(() => {
    knownLengthRef.current = knownLength;
  }, [knownLength]);

  useEffect(() => {
    if (showCalibrationOverlay || !showCalibrationOverlay) {
      function handleOverlayClosed() {
        if (canvas && calibrationGroup) {
          // Remove the calibration square tool and deselect it
          canvas.discardActiveObject();
          canvas.remove(calibrationGroup);
          canvas.requestRenderAll();
        }
      }

      // Function to toggle canvas object visibility
      const toggleCanvasObjectsVisibility = (isVisible) => {
        if (!canvas) return; // Guard clause in case canvas is not available
        canvas.discardActiveObject();
        const objects = canvas.getObjects();
        objects.forEach((obj) => {
          if (obj !== calibrationGroup) {
            obj.set('visible', isVisible);
          }
        });
        canvas.requestRenderAll();
      };


      if (showCalibrationOverlay) {
        toggleCanvasObjectsVisibility(false);

        // Add your Calibration tool here, if needed
        // toggleCalibrationMode()

      } else if (!showCalibrationOverlay) {
        toggleCanvasObjectsVisibility(true);

        // Remove the Calibration tool
        handleOverlayClosed();
      }

      // Listen to the custom 'overlayClosed' event
      window.addEventListener('overlayClosed', handleOverlayClosed);

      return () => {
        // Remove the event listener when the component unmounts
        window.removeEventListener('overlayClosed', handleOverlayClosed);
      };
    }
  }, [canvas, calibrationGroup, showCalibrationOverlay]);

  useEffect(() => {
    if (topBarRef.current) {
      topBarRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [projectName, isFocus]);

  // AI evaluation features removed - no longer needed
  // const toggleAI = () => { setUseAI(!useAI); };

  const toggleOptionsPanel = () => {
    setIsOptionsPanelVisible((prevValue) => !prevValue);
  };



  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);


  const handleShowLoader = (config = {}) => {
    setShowLoader(true);
    setIsLoaderFinish(false);
    setLoaderConfig({
      variant: config?.variant || 'generic',
      title: config?.title || '',
      message: config?.message || '',
      note: config?.note || '',
    });
    setLoaderStartedAt(Date.now());
    setLoaderElapsedSeconds(0);
  };

  const handleHideLoader = () => {
    if (hideLoaderTimeoutRef.current) {
      clearTimeout(hideLoaderTimeoutRef.current);
    }

    hideLoaderTimeoutRef.current = setTimeout(() => {
      setShowLoader(false);
      setLoaderConfig({
        variant: 'generic',
        title: '',
        message: '',
        note: '',
      });
      setLoaderStartedAt(null);
      setLoaderElapsedSeconds(0);
      hideLoaderTimeoutRef.current = null;
    }, 1000);
    setIsLoaderFinish(true);
  };

  useEffect(() => {
    if (!showLoader || !loaderStartedAt) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setLoaderElapsedSeconds(Math.max(0, Math.floor((Date.now() - loaderStartedAt) / 1000)));
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [showLoader, loaderStartedAt]);

  useEffect(() => {
    return () => {
      if (hideLoaderTimeoutRef.current) {
        clearTimeout(hideLoaderTimeoutRef.current);
        hideLoaderTimeoutRef.current = null;
      }
    };
  }, []);

  async function canvasBackground(url, scaleFactorOverride = null) {
    return new Promise(async (resolve, reject) => {
      if (url) {
        try {
          // ✅ Use preloading cache for faster image loading
          await preloadImage(url);
          
          // ✅ Optimize image loading with high-quality rendering
          fabric.Image.fromURL(url, (oImg) => {
            if (oImg) {
              clearCanvas();
              // ✅ Enable high-quality rendering for background images
              oImg.set({
                objectCaching: false,
                crossOrigin: 'anonymous'
              });
              
              // If scaleFactorOverride is passed, use it, otherwise calculate the scale factor
              const scaleFactor = scaleFactorOverride || scaleAndPositionImage(oImg);
              
              // ✅ Use batch rendering instead of immediate render
              batchRender();
              
              resolve(scaleFactor); // Resolve with the scale factor
            } else {
              reject("Error loading image");
            }
          }, { 
            crossOrigin: "anonymous",
            // ✅ High-quality settings for background images
            objectCaching: false,
            statefullCache: false,
            selectable: false
          });
        } catch (error) {
          console.error("❌ Error preloading image:", error);
          reject("Error preloading image");
        }
      } else {
        reject("No image URL provided");
      }
    });
  }




  //  scale canvas image for better fit
  function scaleAndPositionImage(bgImage) {
    // get the scale
    // it is the min of the 2 ratios
    let scale_factor = Math.min(
      canvas.width / bgImage.width,
      canvas.height / bgImage.height
    );

    // Lets get the new width and height based on the scale factor
    let newWidth = bgImage.width * scale_factor;
    let newHeight = bgImage.height * scale_factor;

    // get the top left position of the image
    // in order to center the image within the canvas
    let x = canvas.width / 2 - newWidth / 2;
    let y = 0;

    // setBgImageProps(prevProps => [
    //   ...prevProps,
    //   {
    //     x: x,
    //     y: y,
    //     newWidth: newWidth,
    //     newHeight: newHeight,
    //   }
    // ]);


    setBgImageProps({
      scaleX: scale_factor,
      scaleY: scale_factor,
      left: x,
      top: y,
      newWidth: newWidth,
      newHeight: newHeight,
    });


    // When drawing the image, we have to scale down the image
    // width and height in order to fit within the canvas

    canvas.setBackgroundImage(
      bgImage,
      canvas.renderAll.bind(canvas),
      {
        scaleY: scale_factor,
        scaleX: scale_factor,
        left: x,
        top: y,
        originX: "left", // Set the origin of transformation to the left
        originY: "top", // Set the origin of transformation to the top
      },
      {
        crossOrigin: "Anonymous",
      }
    );

    return scale_factor; // Return the scale factor to be used elsewhere
  }

  fabric.Object.NUM_FRACTION_DIGITS = 8;


  // add a custom property
  fabric.Object.prototype.toObject = (function (toObject) {
    return function (propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat([
        "windowType",
        "optionType",
        "itemType",
        "realWidth",   // Include realWidth
        "realHeight",  // Include realHeight
        "isDimension"  // Example: Include isDimension if used
      ]);
      return toObject.apply(this, [propertiesToInclude]);
    };
  })(fabric.Object.prototype.toObject);



  const handleActionChange = (action) => {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    if (action === "erase") {
      setEraseMode(true);
    }
    if (action === "draw") {
      setDrawMode(true);
    }
    if (action === "undo") {
      setEraseMode(false);
      setModeType("regular")
    }

    setCurrentAction(action);
    changeAction(action, canvas, brushWidth); // Pass the width to changeAction
  };


  const handleWidthChange = (width) => {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setBrushWidth(width); // Update the brush width state
    if (currentAction === 'erase') {
      enableEraser(canvas, width);
    } else if (currentAction === 'draw') {
      enableDraw(canvas, width);
    }
    // //saveCanvasState(canvas);
  };

  function extractGridTypeFromUrl(url) {
    // Decode URL to handle encoded characters like '%2F' 
    const decodedUrl = decodeURIComponent(url);

    // Use a regular expression to find the Grid Type
    const regex = /Grid(\d+)_GridOnly/;
    const match = decodedUrl.match(regex);

    // If a match is found, return it
    if (match && match[1]) {
      return 'Grid' + match[1];
    }

    // Otherwise, return a default or null
    return null;
  }

  function extractDecorativeGlassFromUrl(url) {
    setIsDoor(true)
    // Decode URL to handle encoded characters like '%2F'
    const decodedUrl = decodeURIComponent(url);

    // Extract the relevant portion between "doors/" and the file name
    const match = decodedUrl.match(/doors\/decorativeGlass\/([^/]+)\/([^_]+)_([^_]+)_[^ ]+/);

    if (match && match.length >= 4) {
      const manufacturer = match[1]; // e.g., Novatech
      const model = `${match[2]} ${match[3]}`; // e.g., Cachet Patine
      return `${manufacturer} ${model}`; // Combine into desired format
    }

    // Return a default value if no match is found
    return "Unknown Decorative Glass";
  }

  // Convert AI-detected door to manual mode for decorative glass positioning
  function convertAIDoorToManual(tmpObject) {
    console.log("🔄 Converting AI door to manual mode for decorative glass", {
      type: tmpObject.type,
      usePerspective: tmpObject.usePerspective,
      hasAIDimensions: tmpObject.aiDetectedDimensions ? "YES" : "NO"
    });
    
    // Check if this is an AI-detected door
    // Can be either a polygon with usePerspective OR a group with aiDetectedDimensions
    if (tmpObject.aiDetectedDimensions && tmpObject.usePerspective) {
      console.log("✅ AI door detected, removing AI flags for manual decorative glass positioning");
      
      // Clear AI dimensions so decorative glass uses manual positioning
      delete tmpObject.aiDetectedDimensions;
      
      // Mark as converted
      tmpObject.convertedToManual = true;
      
      console.log("✅ AI flags removed, decorative glass will use manual positioning");
    } else {
      console.log("⏭️ Not an AI-detected door, no conversion needed (type:", tmpObject.type, ", hasDims:", !!tmpObject.aiDetectedDimensions, ")");
    }
  }


  // replace objects filler images like the optionUrl to grid or decorativeGlass image
  function setSrc(tmpObject, gridUrl) {

    var i = tmpObject;
    if (tmpObject.type === "polygon" && tmpObject.usePerspective) {
      i = tmpObject.originObject;
    }

    // Helper function to load image with fallback - using Image object for better error handling
    const loadImageWithFallback = (primaryUrl, fallbackUrl, onSuccess) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = function() {
        onSuccess(img);
      };
      
      img.onerror = function() {
        // If primary fails, try fallback
        if (fallbackUrl && fallbackUrl !== primaryUrl) {
          console.warn(`⚠️ Failed to load ${primaryUrl.substring(primaryUrl.lastIndexOf('/') + 1)}, using fallback`);
          console.log('📍 Fallback URL:', fallbackUrl);
          const fallbackImg = new Image();
          fallbackImg.crossOrigin = 'anonymous';
          
          fallbackImg.onload = function() {
            onSuccess(fallbackImg);
          };
          
          fallbackImg.onerror = function() {
            console.error(`❌ Both primary and fallback failed for ${primaryUrl.substring(primaryUrl.lastIndexOf('/') + 1)}`);
            console.error(`❌ Fallback URL was:`, fallbackUrl);
          };
          
          fallbackImg.src = fallbackUrl;
        } else {
          console.error(`❌ Failed to load image: ${primaryUrl}`);
        }
      };
      
      img.src = primaryUrl;
    };

    // Reset windowGridType and isDoor to avoid stale values
    if (i && i.item(1)) {
      i.item(1).set("windowGridType", null);
    }
    setWindowGridType(null); // Reset global state
    setIsDoor(false); // Assume it's not a door unless determined otherwise

    // Extract grid type and decorative glass
    const gridOption = extractGridTypeFromUrl(gridUrl);
    const decorativeGlass = extractDecorativeGlassFromUrl(gridUrl);



    // Determine if the selected item is a door based on the gridUrl
    const isDoorItem = !!decorativeGlass && gridUrl.includes("doors");
    setIsDoor(isDoorItem); // Update global state

    // Determine the appropriate value for windowGridType
    const windowGridTypeValue = isDoorItem ? decorativeGlass : gridOption || "Unknown";

    // Update windowGridType for all relevant cases
    if (i && i.item(1)) {
      i.item(1).set("windowGridType", windowGridTypeValue);
    }
    setWindowGridType(windowGridTypeValue); // Update global state

    const objectStackPosition1 = i._objects[1];
    const objectStackPosition2 = i._objects[2];
    const objectStackPosition3 = i._objects[3];
    const objectStackPosition4 = i._objects[4];
    const objectStackPosition5 = i._objects[5];
    const objectStackPosition6 = i._objects[6];
    const objectStackPosition7 = i._objects[7];
    const objectStackPosition8 = i._objects[8];
    const objectStackPosition9 = i._objects[9];
    const objectStackPosition10 = i._objects[10];
    const objectStackPosition11 = i._objects[11];
    const objectStackPosition12 = i._objects[12];

    // Removed `i.type === "group"`. For groups, it's because of this function call.
    if (isSameType) {
      canvas.getActiveObjects().forEach((tObject) => {
        var object = tObject;
        if (tObject.type === "polygon" && tObject.usePerspective) {
          object = tObject.originObject;
        }
        // we separate the types so there is no error when select all

        const selectedObjectStackPosition1 = object._objects[1];
        const selectedObjectStackPosition2 = object._objects[2];

        if (gridUrl.includes("NoGrid")) {
          fabric.util.loadImage(
            gridUrl,
            function (img) {
              let switchOption = img;
              objectStackPosition1.setElement(switchOption);
              setObjectPerspective(canvas);
              canvas.renderAll();

              selectedObjectStackPosition1.filters = [];
              selectedObjectStackPosition1.applyFilters();
              setObjectPerspective(canvas);
              canvas.renderAll();
            },
            null,
            "anonymous"
          );
        }

        if (
          object.type === "group" &&
          !i.windowType.includes("Door") &&
          !gridUrl.includes("NoGrid")
        ) {
          selectedObjectStackPosition1.filters = [];
          selectedObjectStackPosition1.applyFilters();
          setObjectPerspective(canvas);
          canvas.renderAll();

          // console.log("object itemColor", object.itemColor)

          var filter = new fabric.Image.filters.BlendColor({
            color: object.itemColor,
            mode: "multiply",
            alpha: 0.95,
          });
          selectedObjectStackPosition1.filters[0] = filter;
          selectedObjectStackPosition1.applyFilters();
          setObjectPerspective(canvas);
          canvas.renderAll();
        }
        if (
          object.type === "group" &&
          selectedObjectStackPosition1.optionType.includes("Door")
        ) {
          selectedObjectStackPosition1.set("cutoutSize", glassToSearch);
        } else {
          return;
        }
        setObjectPerspective(canvas);
        canvas.renderAll();
      });
    }
    // we switch decorative glass option

    if (!i.windowType.includes("Door")) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;

          objectStackPosition1.setElement(switchOption);
          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption5 = img;
          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      i.itemUrl.includes("Double_Door_Right_Left_SideLight") &&
      !i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption5 = img;
          objectStackPosition9.setElement(switchOption5);

          objectStackPosition9.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let leftSidelight = img;

          objectStackPosition5.setElement(leftSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition5.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.RLheightSL,
              left: glassProperties.RLleftSL,
              top: glassProperties.RLtopSL,
              width: glassProperties.RLwidthSL,
            });
          } else {
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let rightSidelight = img;

          objectStackPosition10.setElement(rightSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition10.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition10.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.RLheightSR,
              left: glassProperties.RLleftSR,
              top: glassProperties.RLtopSR,
              width: glassProperties.RLwidthSR,
            });
          } else {
            objectStackPosition10.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      i.itemUrl.includes("Double_Door_Right_Left_SideLight") &&
      i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption5 = img;
          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      i.itemUrl.includes("Single_Door") &&
      !i.itemUrl.includes("Sidelight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      i.itemUrl.includes("Single_Door") &&
      i.itemUrl.includes("SidelightFull") &&
      !i.itemUrl.includes("Right_Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      !i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption3 = img;

          objectStackPosition4.setElement(switchOption3);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        leftSidelightDecorativeGlass,
        function (img) {
          let leftSidelight = img;

          objectStackPosition5.setElement(leftSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition5.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.heightSL || glassProperties.RLheightSL,
              left: glassProperties.leftSL || glassProperties.RLleftSL,
              top: glassProperties.topSL || glassProperties.RLtopSL,
              width: glassProperties.widthSL || glassProperties.RLwidthSL,
            });
          } else {
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente4") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption3 = img;

          objectStackPosition4.setElement(switchOption3);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightSidelightDecorativeGlass,
        function (img) {
          let rightSidelight = img;

          objectStackPosition5.setElement(rightSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition5.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.heightSR || glassProperties.RLheightSR,
              left: glassProperties.leftSR || glassProperties.RLleftSR,
              top: glassProperties.topSR || glassProperties.RLtopSR,
              width: glassProperties.widthSR || glassProperties.RLwidthSR,
            });
          } else {
            objectStackPosition5.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption3 = img;

          objectStackPosition4.setElement(switchOption3);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption4 = img;

          objectStackPosition5.setElement(switchOption4);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightSidelightDecorativeGlass,
        function (img) {
          let rightSidelight = img;

          objectStackPosition6.setElement(rightSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition6.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition6.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.heightSR || glassProperties.RLheightSR,
              left: glassProperties.leftSR || glassProperties.RLleftSR,
              top: glassProperties.topSR || glassProperties.RLtopSR,
              width: glassProperties.widthSR || glassProperties.RLwidthSR,
            });
          } else {
            objectStackPosition6.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          // //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      !i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption3 = img;

          objectStackPosition4.setElement(switchOption3);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOption4 = img;

          objectStackPosition5.setElement(switchOption4);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          // //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        leftSidelightDecorativeGlass,
        function (img) {
          let leftSidelight = img;

          objectStackPosition6.setElement(leftSidelight);

          // Recalculate positioning if AI dimensions are stored
          const poly = tmpObject.usePerspective ? tmpObject : null;
          const aiDetectedDimensions = poly?.aiDetectedDimensions || null;
          const stringToSearchSide = objectStackPosition6.cutoutSize || "Sidelight1A";
          
          if (aiDetectedDimensions && i.itemUrl) {
            const glassProperties = sidesSizeAndPosition(stringToSearchSide + (aiDetectedDimensions ? "AI" : ""), aiDetectedDimensions, i.itemUrl);
            objectStackPosition6.set({
              ownCaching: false,
              dirty: true,
              height: glassProperties.heightSL || glassProperties.RLheightSL,
              left: glassProperties.leftSL || glassProperties.RLleftSL,
              top: glassProperties.topSL || glassProperties.RLtopSL,
              width: glassProperties.widthSL || glassProperties.RLwidthSL,
            });
          } else {
            objectStackPosition6.set({
              ownCaching: false,
              dirty: true,
            });
          }

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;
          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption9 = img;

          objectStackPosition9.setElement(switchOption9);

          objectStackPosition9.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption10 = img;

          objectStackPosition10.setElement(switchOption10);

          objectStackPosition10.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      i.itemUrl.includes("Double_Door_Right_Left_SideLight") &&
      !i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;
          objectStackPosition11.setElement(switchOption6);

          objectStackPosition11.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption9 = img;

          objectStackPosition9.setElement(switchOption9);

          objectStackPosition9.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption10 = img;

          objectStackPosition10.setElement(switchOption10);

          objectStackPosition10.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let leftSidelight = img;

          objectStackPosition6.setElement(leftSidelight);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let rightSidelight = img;

          objectStackPosition12.setElement(rightSidelight);

          objectStackPosition12.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      i.itemUrl.includes("Double_Door_Right_Left_SideLight") &&
      i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;
          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption7 = img;

          objectStackPosition7.setElement(switchOption7);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption8 = img;

          objectStackPosition8.setElement(switchOption8);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption9 = img;

          objectStackPosition9.setElement(switchOption9);

          objectStackPosition9.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption10 = img;

          objectStackPosition10.setElement(switchOption10);

          objectStackPosition10.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      i.itemUrl.includes("Single_Door")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("Corriente5") &&
      i.itemUrl.includes("Single_Door") &&
      i.itemUrl.includes("SidelightFull")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption3 = img;

          objectStackPosition3.setElement(switchOption3);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Left_SideLight") &&
      !i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_SideLight") &&
      i.itemUrl.includes("Full") &&
      i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightSidelightDecorativeGlass,
        function (img) {
          let rightSidelight = img;

          objectStackPosition4.setElement(rightSidelight);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_SideLight") &&
      i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Left_SideLight") &&
      !i.itemUrl.includes("Right_Left_SideLight") &&
      !i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        leftSidelightDecorativeGlass,
        function (img) {
          let leftSidelight = img;

          objectStackPosition4.setElement(leftSidelight);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      i.itemUrl.includes("Double_Door") &&
      !i.itemUrl.includes("Right_Left_SideLight") &&
      !i.itemUrl.includes("Sidelight_Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      i.itemUrl.includes("Single_Door") &&
      !i.itemUrl.includes("Right_Left_SideLight") &&
      i.itemUrl.includes("Sidelight_Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("SidelightFull")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition4.setElement(switchOption4);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let switchOption = img;
          objectStackPosition4.setElement(switchOption);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switchOption = img;
          objectStackPosition8.setElement(switchOption);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      !i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          fabric.util.loadImage(
            rightLeftSidelightDecorativeGlassLeft,
            function (img) {
              let switchOption = img;
              objectStackPosition4.setElement(switchOption);

              objectStackPosition4.set({
                ownCaching: false,
                dirty: true,
              });
            },
            null,
            "anonymous"
          );
          setObjectPerspective(canvas);
          canvas.renderAll();

          fabric.util.loadImage(
            rightLeftSidelightDecorativeGlassRight,
            function (img) {
              let switchOption = img;
              objectStackPosition5.setElement(switchOption);

              objectStackPosition5.set({
                ownCaching: false,
                dirty: true,
              });

              setObjectPerspective(canvas);
              canvas.renderAll();
            },
            null,
            "anonymous"
          );

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      i.itemUrl.includes("3AGlassAt123") &&
      i.itemUrl.includes("Double_Door") &&
      i.itemUrl.includes("Right_Left_SideLight")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption2 = img;

          objectStackPosition2.setElement(switchOption2);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption1 = img;

          objectStackPosition3.setElement(switchOption1);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption4 = img;

          objectStackPosition7.setElement(switchOption4);

          objectStackPosition7.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption5 = img;

          objectStackPosition5.setElement(switchOption5);

          objectStackPosition5.set({
            ownCaching: false,
            dirty: true,
          });

          let switchOption6 = img;

          objectStackPosition6.setElement(switchOption6);

          objectStackPosition6.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let switchOption = img;
          objectStackPosition4.setElement(switchOption);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switchOption = img;
          objectStackPosition8.setElement(switchOption);

          objectStackPosition8.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      !objectStackPosition2.optionType &&
      objectStackPosition1.optionType.includes("Single_Door")
    ) {
      i.itemUrl.includes("3AGlassAt3");


      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;

          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
          setIsObjSelected(true);
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes("Double_Door") &&
      !objectStackPosition1.optionType.includes(
        "Double_Door_Right_Left_SideLight"
      )
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;
          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });
          let switchOptionRight = img;

          objectStackPosition2.setElement(switchOptionRight);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes("Single_Door_Right_SideLight") &&
      !i.itemUrl.includes("NoGlass") &&
      !i.itemUrl.includes("3AGlassAt123")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;

          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          if (!i.itemUrl.includes("Full")) {
            loadImageWithFallback(
              rightSidelightDecorativeGlass,
              rightDecorativeGlass,
              function (img) {
                let rightSidelight = img;

                objectStackPosition2.setElement(rightSidelight);

                objectStackPosition2.set({
                  ownCaching: false,
                  dirty: true,
                });

                setObjectPerspective(canvas);
                canvas.renderAll();
                setIsObjSelected(true);
                //saveCanvasState(canvas);
              }
            );
          }
          setObjectPerspective(canvas);
          canvas.renderAll();
        }
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes("Single_Door_Right_SideLight") &&
      !i.itemUrl.includes("Full") &&
      i.itemUrl.includes("NoGlass")
    ) {
      loadImageWithFallback(
        rightSidelightDecorativeGlass,
        sidelightFallbackUrl,
        function (img) {
          let rightSidelight = img;

          objectStackPosition1.setElement(rightSidelight);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        }
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes("Single_Door_Left_SideLight") &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("NoGlass")
    ) {

      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switchOption = img;

          objectStackPosition1.setElement(switchOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          if (!i.itemUrl.includes("Full")) {
            fabric.util.loadImage(
              leftSidelightDecorativeGlass,
              function (img) {
                let leftSidelight = img;

                objectStackPosition2.setElement(leftSidelight);

                objectStackPosition2.set({
                  ownCaching: false,
                  dirty: true,
                });

                setObjectPerspective(canvas);
                canvas.renderAll();
                setIsObjSelected(true);
                //saveCanvasState(canvas);
              },
              null,
              "anonymous"
            );
          }
          setObjectPerspective(canvas);
          canvas.renderAll();
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes("Single_Door_Left_SideLight") &&
      !i.itemUrl.includes("Full") &&
      i.itemUrl.includes("NoGlass")
    ) {
      loadImageWithFallback(
        leftSidelightDecorativeGlass,
        sidelightFallbackUrl, // Fallback to Novatech_Soft_118_948.png if sidelight doesn't exist
        function (img) {
          let leftSidelight = img;

          objectStackPosition1.setElement(leftSidelight);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          setIsObjSelected(true);
          //saveCanvasState(canvas);
        }
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Single_Door_Right_Left_SideLight"
      ) &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("NoGlass")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSidelightOption = img;

          objectStackPosition1.setElement(switcLeftSidelightOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      loadImageWithFallback(
        rightLeftSidelightDecorativeGlassLeft,
        sidelightFallbackUrl,
        function (img) {
          let switchDoorOptiont = img;

          objectStackPosition2.setElement(switchDoorOptiont);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        }
      );

      loadImageWithFallback(
        rightLeftSidelightDecorativeGlassRight,
        sidelightFallbackUrl,
        function (img) {
          let switcRightSidelightOption = img;

          objectStackPosition3.setElement(switcRightSidelightOption);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        }
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Single_Door_Right_Left_SideLight"
      ) &&
      !i.itemUrl.includes("Full") &&
      i.itemUrl.includes("NoGlass")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSidelightOption = img;

          objectStackPosition1.setElement(switcLeftSidelightOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switcRightSidelightOption = img;

          objectStackPosition2.setElement(switcRightSidelightOption);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Double_Door_Right_Left_SideLight"
      ) &&
      !i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("NoGlass") &&
      !i.itemUrl.includes("FlatWith") &&
      !i.itemUrl.includes("With") &&
      !i.itemUrl.includes("Tao")
    ) {
      fabric.util.loadImage(
        rightDecorativeGlass,
        function (img) {
          let switcRightSideDoubleDoor = img;

          objectStackPosition3.setElement(switcRightSideDoubleDoor);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSideDoubleDoor = img;

          objectStackPosition1.setElement(switcLeftSideDoubleDoor);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let switchRightSidelightOption = img;

          objectStackPosition2.setElement(switchRightSidelightOption);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switcRightSidelightOption = img;

          objectStackPosition4.setElement(switcRightSidelightOption);

          objectStackPosition4.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Double_Door_Right_Left_SideLight"
      ) &&
      i.itemUrl.includes("Full") &&
      !i.itemUrl.includes("NoGlass")
    ) {
      fabric.util.loadImage(
        rightDecorativeGlass,
        function (img) {
          let switcRightSideDoubleDoor = img;

          objectStackPosition2.setElement(switcRightSideDoubleDoor);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSideDoubleDoor = img;

          objectStackPosition1.setElement(switcLeftSideDoubleDoor);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Double_Door_Right_Left_SideLight"
      ) &&
      !i.itemUrl.includes("Full") &&
      (i.itemUrl.includes("NoGlass") ||
        i.itemUrl.includes("FlatWith") ||
        i.itemUrl.includes("With") ||
        i.itemUrl.includes("Tao"))
    ) {
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let switchRightSidelightOption = img;

          objectStackPosition2.setElement(switchRightSidelightOption);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switcRightSidelightOption = img;

          objectStackPosition1.setElement(switcRightSidelightOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();

          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Single_Door_Right_Left_SideLight"
      ) &&
      !i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSidelightOption = img;

          objectStackPosition1.setElement(switcLeftSidelightOption);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          //saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassLeft,
        function (img) {
          let switchDoorOptiont = img;

          objectStackPosition2.setElement(switchDoorOptiont);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );
      setObjectPerspective(canvas);
      canvas.renderAll();

      fabric.util.loadImage(
        rightLeftSidelightDecorativeGlassRight,
        function (img) {
          let switcRightSidelightOption = img;

          objectStackPosition3.setElement(switcRightSidelightOption);

          objectStackPosition3.set({
            ownCaching: false,
            dirty: true,
          });
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      //saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else if (
      objectStackPosition1.optionType.includes(
        "Double_Door_Right_Left_SideLight"
      ) &&
      i.itemUrl.includes("Full")
    ) {
      fabric.util.loadImage(
        rightDecorativeGlass,
        function (img) {
          let switcRightSideDoubleDoor = img;

          objectStackPosition2.setElement(switcRightSideDoubleDoor);

          objectStackPosition2.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          ////saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );
      fabric.util.loadImage(
        optionUrl,
        function (img) {
          let switcLeftSideDoubleDoor = img;

          objectStackPosition1.setElement(switcLeftSideDoubleDoor);

          objectStackPosition1.set({
            ownCaching: false,
            dirty: true,
          });

          setObjectPerspective(canvas);
          canvas.renderAll();
          ////saveCanvasState(canvas);
        },
        null,
        "anonymous"
      );

      setObjectPerspective(canvas);
      canvas.renderAll();
      setIsObjSelected(true);
      ////saveCanvasState(canvas);

      setObjectPerspective(canvas);
      canvas.renderAll();
    } else return;
    setObjectPerspective(canvas);
    // canvas.discardActiveObject();
    canvas.renderAll();
    setIsSelectAll(false); // Adjust based on your state management
  }

  //We add option to selected group
  function addOption(gridUrl, fabricObject = null) {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    let gridOption = extractGridTypeFromUrl(gridUrl);
    setWindowGridType(gridOption);

    if (gridUrl.includes("NoGrid")) {
      optionUrl = gridUrl;

      canvas.getActiveObjects().forEach((object) => {
        if (object.type === "group" || object.type === "polygon") {
          setSrc(object, gridUrl);
        } else {
          return;
        }
      });
    }

    if (gridUrl.includes("Grid")) {
      optionUrl = gridUrl;

      canvas.getActiveObjects().forEach((object) => {
        let filterColor;

        if (object.type === "group") {
          const targetObject = object._objects[2]; // Access index 2 of _objects
          setTypeName(targetObject.windowType);

          // Extract color from filters BEFORE setting src
          if (targetObject.filters && targetObject.filters.length > 0) {
            const colorFilter = targetObject.filters[0]; // Assuming first filter is relevant
            if (colorFilter && colorFilter.color) {
              filterColor = colorFilter.color; // Get the color from the filter
              setItemColor(filterColor); // Update the itemColor state
              object.itemColor = filterColor; // Update object's itemColor property immediately
            }
          }

          // Set grid URL and re-render
          setSrc(object, gridUrl);
          canvas.renderAll();
        }

        if (object.type === "polygon" && object.usePerspective) {
          const originTargetObject = object.originObject._objects[2];
          setTypeName(originTargetObject.windowType);

          // Extract color from filters BEFORE setting src
          if (originTargetObject.filters && originTargetObject.filters.length > 0) {
            const colorFilter = originTargetObject.filters[0]; // Assuming first filter is relevant
            if (colorFilter && colorFilter.color) {
              filterColor = colorFilter.color; // Get the color from the filter
              setItemColor(filterColor); // Update the itemColor state
              object.originObject.itemColor = filterColor; // Update object's itemColor property immediately
            }
          }

          // Set grid URL and re-render
          setSrc(object, gridUrl);
          canvas.renderAll();
        }
      });
    }


    if (gridUrl.includes("doors")) {
      optionUrl = gridUrl;

      // Extract decorative glass
      const decorativeGlass = extractDecorativeGlassFromUrl(gridUrl);
      if (fabricObject && fabricObject._objects?.[1]) {
        fabricObject._objects[1].windowGridType =
          decorativeGlass || "Unknown Decorative Glass";
      }

      rightDecorativeGlass = gridUrl;
      
      // Create fallback URL for missing sidelight sizes using Novatech_Soft_118_948.png
      if (gridUrl.includes('firebasestorage.googleapis.com')) {
        // Extract the base Firebase Storage URL and construct fallback
        const baseUrl = gridUrl.substring(0, gridUrl.indexOf('?'));
        const bucketMatch = gridUrl.match(/\/b\/([^\/]+)\/o\//);
        if (bucketMatch) {
          sidelightFallbackUrl = `https://firebasestorage.googleapis.com/v0/b/${bucketMatch[1]}/o/doors%2FdecorativeGlass%2FNovatech%2FNovatech_Soft_118_948.png?alt=media`;
        }
      } else {
        sidelightFallbackUrl = '/doors/decorativeGlass/Novatech/Novatech_Soft_118_948.png';
      }

      if (windowURL.includes("Sidelight1A")) {
        const regex = /326_.../;
        const replacementString = "118_948";
        const updatedURL = gridUrl.replace(regex, replacementString);
        rightSidelightDecorativeGlass = updatedURL;
        leftSidelightDecorativeGlass = updatedURL;
        rightLeftSidelightDecorativeGlassLeft = updatedURL;
        rightLeftSidelightDecorativeGlassRight = updatedURL;
      } else if (!windowURL.includes("SidelightFull")) {
        rightSidelightDecorativeGlass = gridUrl.replace("326_", "118_");
        rightLeftSidelightDecorativeGlassRight = gridUrl.replace("326", "118");
        leftSidelightDecorativeGlass = gridUrl.replace("326", "118");
        rightLeftSidelightDecorativeGlassLeft = gridUrl.replace("326", "118");
      }

      // Convert AI doors to manual mode before applying decorative glass
      canvas.getActiveObjects().forEach((object) => {
        // Convert AI door to manual mode for proper decorative glass positioning
        convertAIDoorToManual(object);
        
        if (object.type === "group")
          setTypeName(object._objects[2].windowType);
        if (object.type === "polygon" && object.usePerspective)
          setTypeName(object.originObject._objects[2].windowType);

        canvas.renderAll();
        if (object.type === "group" || object.type === "polygon") {
          if (!object.itemUrl.includes("Full")) {
            if (windowURL.includes("Sidelight1A")) {
              const regex = /326_.../;
              const replacementString = "118_948";
              const updatedURL = gridUrl.replace(regex, replacementString);
              rightSidelightDecorativeGlass = updatedURL;
            } else {
              rightSidelightDecorativeGlass = gridUrl.replace("326_", "118_");
              leftSidelightDecorativeGlass = gridUrl.replace("326", "118");
              rightLeftSidelightDecorativeGlassRight = gridUrl.replace(
                "326",
                "118"
              );
              rightLeftSidelightDecorativeGlassLeft = gridUrl.replace(
                "326",
                "118"
              );
            }
          }

          setSrc(object, gridUrl);
          canvas.renderAll();
        } else {
          return;
        }
      });

      // canvas.discardActiveObject();
      canvas.renderAll();
    }

    setIsSelectAll(false);
  }





  // We switch color
  function updateColor(colorChoice) {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    // Update windowGridOption


    // Unify to a single color format if needed
    const selectedColor = unifyColorFormat(colorChoice || itemColor);
    setItemColor(selectedColor);

    canvas.getActiveObjects().forEach(async (tmpObject) => {

      var object = tmpObject;

      if (tmpObject.type === "polygon" && tmpObject.usePerspective) {
        object = tmpObject.originObject;
      }
      object.itemColor = selectedColor;
      tmpObject.itemColor = selectedColor;

      if (object.type === "group") {
        const objectsInGroup = object.getObjects();

        if ((object.itemUrl && object.itemUrl.includes("Window")) || object.itemUrl.includes("GarageDoor")) {
          updateColorForObject(objectsInGroup[objectsInGroup.length - 1], selectedColor);

          // Update grid at index 1 if it exists and is an image
          const gridElement = objectsInGroup[1];
          if (gridElement && gridElement.type === 'image' && gridElement.windowGridType) {
            updateColorForObject(gridElement, selectedColor);
          }
        }

        if (object.itemUrl && object.itemUrl.includes("Door")) {
          updateColorForObject(objectsInGroup[objectsInGroup.length - 3], selectedColor);
        }
      }

      if (tmpObject.itemType === 'accessory') {
        updateColorForObject(tmpObject, selectedColor);
      }

      if (object.type === "circle" || object.type === "rect" || object.type === "triangle") {
        object.set({
          fill: selectedColor,
          alpha: 0.9,
        });
      } else if (object.type === "path") {
        object.set({
          stroke: selectedColor,
        });
      }

      setObjectPerspective(canvas, tmpObject);
    });
    // canvas.discardActiveObject();
    canvas.requestRenderAll();
    saveCanvasState(canvas);
    setIsSelectAll(false);
  }


  function updateColorForObject(obj, selectedColor) {

    if (!obj) return;

    // Initialize filters array if it doesn't exist
    if (!obj.filters) {
      obj.filters = [];
    }

    const existingFilter = obj.filters.find(
      (filter) => filter.type === 'BlendColor'
    );

    if (existingFilter) {
      // Update the existing filter's color
      existingFilter.color = selectedColor;
      existingFilter.alpha = 0.95;
    } else {
      // Add a new BlendColor filter if none exists
      const filter = new fabric.Image.filters.BlendColor({
        color: selectedColor,
        mode: "multiply",
        alpha: 0.95,
      });
      obj.filters.push(filter);
    }

    obj.applyFilters();
    canvas.requestRenderAll();
  }

  function unifyColorFormat(color) {
    // Convert color to a single format (e.g., Hex)
    // Implementation here...
    return color;
  }
  const extractItemColor = (object) => {
    // First, try to extract color from BlendColor filters in the fabric object
    if (object._objects && Array.isArray(object._objects)) {
      
      const isDoor = object.itemType === "doors";
      
      // For doors, the windowImage (main door) is typically at length-2 (second to last)
      // For windows, check multiple positions
      const targetIndices = isDoor 
        ? [object._objects.length - 2, object._objects.length - 3, object._objects.length - 1] // windowImage should be at -2
        : [object._objects.length - 1, object._objects.length - 2, 2]; // Windows: last, second-to-last, or index 2

      for (let index of targetIndices) {
        if (index >= 0 && index < object._objects.length) {
          const targetSubObject = object._objects[index];
          
          if (targetSubObject?.filters?.length > 0) {
            const blendColorFilter = targetSubObject.filters.find((filter) => filter.type === "BlendColor");
            if (blendColorFilter?.color) {
              return blendColorFilter.color;
            }
          }
        }
      }
    }

    // Fallback to itemColor property
    if (object.itemColor) {
      return object.itemColor;
    }
    
    // Fallback to fill property
    if (object.fill) {
      return object.fill;
    }
    
    // Default to black
    return "rgba(0, 0, 0, 1)";
  };


  const addItem = (window, tName, coords = null, isAICall = false, scaleFactor = null, realScaleFactor) => {
    if (!isAICall && shouldBlockExpiredTrialEditing()) {
      return Promise.resolve();
    }

    let newCoords = null;
    let itemColor = null;
    let isReplacement = false;

    // ✅ Calculate realScaleFactor for manual additions if not provided
    let effectiveRealScaleFactor = realScaleFactor;
    
    if (!effectiveRealScaleFactor && projectScaleFactor) {
      // Use stored projectScaleFactor from AI detection to calculate dimensions
      // Average the width and height scale factors for a general scale
      effectiveRealScaleFactor = (projectScaleFactor.width + projectScaleFactor.height) / 2;
    }

    const currentSelectedObject = isAICall ? null : getSelectedObject();

    // console.log("coords in add item", coords)

    // console.log("selected object", currentSelectedObject)

    if (currentSelectedObject) {
      isReplacement = true;
      
      // 🔍 DEBUG: Log selected object properties
      console.log("🔍 Selected Door Properties:", {
        scaleX: currentSelectedObject.scaleX,
        scaleY: currentSelectedObject.scaleY,
        tmpScaleX: currentSelectedObject.tmpScaleX,
        tmpScaleY: currentSelectedObject.tmpScaleY,
        width: currentSelectedObject.width,
        height: currentSelectedObject.height,
        getScaledWidth: currentSelectedObject.getScaledWidth?.(),
        getScaledHeight: currentSelectedObject.getScaledHeight?.(),
        originObjectWidth: currentSelectedObject.originObject?.width,
        originObjectHeight: currentSelectedObject.originObject?.height,
        type: currentSelectedObject.type
      });
      
      // ✅ For perspective objects (doors), use tmpScaleX/Y and originObject dimensions
      const actualScaleX = currentSelectedObject.tmpScaleX !== undefined ? currentSelectedObject.tmpScaleX : currentSelectedObject.scaleX;
      const actualScaleY = currentSelectedObject.tmpScaleY !== undefined ? currentSelectedObject.tmpScaleY : currentSelectedObject.scaleY;
      
      // ✅ Get the DISPLAYED width/height (scaled dimensions) for proper replacement sizing
      // For perspective objects, use originObject; otherwise use scaled dimensions
      const actualWidth = currentSelectedObject.originObject?.width 
        || (currentSelectedObject.getScaledWidth ? currentSelectedObject.getScaledWidth() : currentSelectedObject.width);
      const actualHeight = currentSelectedObject.originObject?.height 
        || (currentSelectedObject.getScaledHeight ? currentSelectedObject.getScaledHeight() : currentSelectedObject.height);
      
      console.log("✅ Using for replacement:", { actualScaleX, actualScaleY, actualWidth, actualHeight });
      
      newCoords = {
        left: currentSelectedObject.left,
        top: currentSelectedObject.top,
        scaleX: actualScaleX,
        scaleY: actualScaleY,
        width: actualWidth,
        height: actualHeight,
        realWidth: currentSelectedObject.realWidth,
        realHeight: currentSelectedObject.realHeight,
        originX: currentSelectedObject.originX, // Preserve the origin
        originY: currentSelectedObject.originY,
        isReferenceItem: currentSelectedObject.isReferenceItem, // ✅ Preserve reference status
      };

      // Extract color from the selected object
      itemColor = extractItemColor(currentSelectedObject);

      canvas.remove(currentSelectedObject);
    }

    const finalCoords = coords || newCoords || {
      // Provide default coordinates when no coords are available (manual addition)
      top: 250,
      left: canvas.getWidth() / 2 + 200
    };
    console.log("[ShowMeDebug] addItem.request", {
      window,
      tName,
      isAICall,
      isReplacement,
      inputCoords: coords,
      replacementCoords: newCoords,
      finalCoords,
      effectiveRealScaleFactor,
      canvasIsPerspective: canvas?.isPerspective,
      canvasObjectCountBefore: canvas?.getObjects?.().length,
    });
    const properties = buildProperties(
      window,
      tName,
      finalCoords,
      isAICall,
      scaleFactor,
      effectiveRealScaleFactor, // Use calculated scale factor
      false, // designerTriggered
      isReplacement, // isReplacement flag
      itemColor // extracted color for replacements
    );

    if (isAICall && canvas) {
      canvas.discardActiveObject();
    }



    if (window.includes("Door") && !window.includes("GarageDoor")) {
      return addDoors(canvas, properties, () => { }, effectiveRealScaleFactor).then((result) => {
        console.log("[ShowMeDebug] addItem.result", {
          tName,
          itemKind: "door",
          resultType: result?.type,
          resultLeft: result?.left,
          resultTop: result?.top,
          resultVisible: result?.visible,
          canvasObjectCountAfter: canvas?.getObjects?.().length,
        });
        return result;
      });
    } else if (window.includes("Window")) {
      return addWindows(canvas, properties, () => { }, effectiveRealScaleFactor).then((result) => {
        console.log("[ShowMeDebug] addItem.result", {
          tName,
          itemKind: "window",
          resultType: result?.type,
          resultLeft: result?.left,
          resultTop: result?.top,
          resultVisible: result?.visible,
          canvasObjectCountAfter: canvas?.getObjects?.().length,
        });
        return result;
      });
    } else if (window.includes("Garage")) {
      addGarageDoors(canvas, properties, () => { });
      return Promise.resolve();
    }

    canvas.renderAll();
    return Promise.resolve();
  };


  // Helper Function: Apply Gemini Scale Factor
  const applyGeminiScaleFactor = (coords, geminiScaleFactor) => {
    if (!coords) return null;

    return {
      left: coords.left * geminiScaleFactor,
      top: coords.top * geminiScaleFactor,
      width: coords.width * geminiScaleFactor,
      height: coords.height * geminiScaleFactor,
    };
  };





  function buildProperties(window, tName, coords, isAICall, scaleFactor, realScaleFactor, designerTriggered, isReplacement = false, extractedColor = null) {
    // Construct and return the properties object based on provided parameters
    return {
      window: window,
      tName: tName,
      isDimensionsVisible: isDimensionsVisible,
      typeName: tName,
      windowURL: windowURL,
      windowGridType: windowGridType,
      optionUrl: optionUrl,
      glassToSearch: glassToSearch,
      stringToSearch: stringToSearch,
      stringToSearchSide: stringToSearchSide,
      rightDecorativeGlass: rightDecorativeGlass,
      rightSidelightDecorativeGlass: rightSidelightDecorativeGlass,
      leftSidelightDecorativeGlass: leftSidelightDecorativeGlass,
      rightLeftSidelightDecorativeGlassLeft:
        rightLeftSidelightDecorativeGlassLeft,
      rightLeftSidelightDecorativeGlassRight:
        rightLeftSidelightDecorativeGlassRight,
      designerTriggered,
      // Include coords if provided
      ...coords,
      isAICall, // Include the AI flag directly
      scaleFactor,
      realScaleFactor,
      fill: extractedColor || itemColor, // Use extracted color for replacements, fallback to global itemColor
      isSelectAll,
      isReplacement, // Add the replacement flag
      // More properties can be added as necessary
    };
  }


  function getSelectedObject() {
    return canvas.getActiveObject();
  }

  // // Function to open the modal
  // const openDetailModal = (details, imageUrl, itemColor) => {
  //   setModalDetails({ details, imageUrl, itemColor });
  //   setIsDetailModalOpen(true);
  // };

  // Function to close the modal
  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setModalDetails(null); // Clear modal data
  };


  function openItemDetailsModal(targetObject) {
    if (!targetObject) {
      console.warn("No target object provided for modal.");
      return;
    }

    let filterColor = "N/A"; // Default value for color

    // Use the same extraction logic as extractItemColor for consistency
    if (targetObject._objects && Array.isArray(targetObject._objects)) {
      
      const isDoor = targetObject.itemType === "doors";
      
      // Use same indices as extractItemColor function
      const targetIndices = isDoor 
        ? [targetObject._objects.length - 2, targetObject._objects.length - 3, targetObject._objects.length - 1] // windowImage should be at -2
        : [targetObject._objects.length - 1, targetObject._objects.length - 2, 2]; // Windows: last, second-to-last, or index 2

      for (let index of targetIndices) {
        if (index >= 0 && index < targetObject._objects.length) {
          const targetSubObject = targetObject._objects[index];
          
          if (targetSubObject?.filters?.length > 0) {
            const blendColorFilter = targetSubObject.filters.find((filter) => filter.type === "BlendColor");
            if (blendColorFilter?.color) {
              filterColor = blendColorFilter.color;
              break; // Found color, stop searching
            }
          }
        }
      }
    }

    // Extract details from the target object
    // ✅ Get dynamic dimensions based on current scale
    const dimensionInfo = getDimensionInfo(targetObject, canvas);
    
    const details = {
      windowType: targetObject.windowType || "N/A",
      optionType: capitalizeFirstLetter(targetObject.optionType || "N/A"),
      itemType: capitalizeFirstLetter(targetObject.itemType || "N/A"),
      windowGridType: targetObject.itemType === "doors"
        ? targetObject?._objects?.[1]?.windowGridType || t("details.none") // Assign decorativeGlass for doors
        : targetObject?._objects?.[1]?.windowGridType || t("details.none"), // Assign windowGridType for others
      realWidth: dimensionInfo.realWidth !== "N/A" ? `${dimensionInfo.realWidth} inches` : "N/A",
      realHeight: dimensionInfo.realHeight !== "N/A" ? `${dimensionInfo.realHeight} inches` : "N/A",
      realWidthCm: dimensionInfo.realWidthCm ? `${dimensionInfo.realWidthCm} cm` : "N/A",
      realHeightCm: dimensionInfo.realHeightCm ? `${dimensionInfo.realHeightCm} cm` : "N/A",
      isReference: dimensionInfo.isReference,
      canSetAsReference: dimensionInfo.canSetAsReference,
      color: filterColor, // Use the dynamically extracted filter color
    };
    
    // Extract the image URL
    const imageUrl = targetObject.itemUrl || null;

    // Match the color in your predefined color list with improved matching
    const matchedColor = colorList.find((color) => {
      // Try exact match first
      if (color.color === filterColor) return true;
      
      // Try normalized RGBA matching with tolerance for slight variations
      const normalizeRgba = (rgbaStr) => {
        if (!rgbaStr || rgbaStr === "N/A") return null;
        const match = rgbaStr.match(/rgba?\(([^)]+)\)/);
        if (!match) return null;
        
        const values = match[1].split(',').map(v => parseFloat(v.trim()));
        // Round values to handle floating point precision issues
        return {
          r: Math.round(values[0]),
          g: Math.round(values[1]),
          b: Math.round(values[2]),
          a: values[3] || 1
        };
      };
      
      const filterColorValues = normalizeRgba(filterColor);
      const listColorValues = normalizeRgba(color.color);
      
      if (filterColorValues && listColorValues) {
        // Exact match required - no tolerance for RGB values
        const tolerance = 0;
        const rMatch = Math.abs(filterColorValues.r - listColorValues.r) <= tolerance;
        const gMatch = Math.abs(filterColorValues.g - listColorValues.g) <= tolerance;
        const bMatch = Math.abs(filterColorValues.b - listColorValues.b) <= tolerance;
        const aMatch = Math.abs(filterColorValues.a - listColorValues.a) <= 0.01;
        
        return rMatch && gMatch && bMatch && aMatch;
      }
      
      return false;
    });
    
    const itemColorName = matchedColor ? matchedColor.name : filterColor; // Show actual color if no match found

    // Prepare modal data
    const modalData = {
      details: { ...details, itemColor: itemColorName },
      imageUrl: imageUrl,
      itemColor: filterColor,
    };

    // console.log("Setting modal details with:", modalData);

    // Set modal details
    setModalDetails(modalData);

    // Open the modal after ensuring details are updated
    setTimeout(() => {
      // console.log("Opening modal after details are set.");
      setIsDetailModalOpen(true);
    }, 0);
  }

  const handleDesignerReferenceActionReady = useCallback((actions) => {
    designerReferenceActionsRef.current = actions;
  }, []);

  const handleUseSelectedItemAsReferenceImage = useCallback(() => {
    const addSelectedItemAsReferenceImage = designerReferenceActionsRef.current?.addSelectedItemAsReferenceImage;
    if (typeof addSelectedItemAsReferenceImage !== 'function') {
      return;
    }

    addSelectedItemAsReferenceImage();
    closeDetailModal();
  }, []);

  const handleUseColorSwatchAsReferenceImage = useCallback((colorValue, colorLabel) => {
    const addColorSwatchReferenceImage = designerReferenceActionsRef.current?.addColorSwatchReferenceImage;
    if (typeof addColorSwatchReferenceImage !== 'function') {
      return;
    }

    addColorSwatchReferenceImage(colorValue, colorLabel);
  }, []);

  const handleGenerateRealisticImageFromMenu = useCallback(() => {
    const generateRealisticImageFromCanvas = designerReferenceActionsRef.current?.generateRealisticImageFromCanvas;
    if (typeof generateRealisticImageFromCanvas !== 'function') {
      toast.error('Designer generation is not available right now');
      return;
    }

    generateRealisticImageFromCanvas();
    closeDetailModal();
  }, []);

  const handleFacadeAIGenerationStateChange = useCallback((nextState) => {
    const isGenerating = Boolean(nextState?.isGenerating);
    setIsFacadeAIGeneratingFromMenu(isGenerating);
    setFacadeAIGenerationElapsedFromMenu(Number.isFinite(nextState?.elapsedSeconds) ? nextState.elapsedSeconds : 0);

    if (isGenerating) {
      setGeneratedImageModalUrl("");
      setIsGeneratedImageModalOpen(true);
    }
  }, []);

  // ============================================================================
  // REFERENCE ITEM MANAGEMENT FUNCTIONS
  // ============================================================================

  /**
   * Handle setting an item as the reference item
   */
  const handleSetAsReference = (targetObject, realWidth, realHeight) => {
    if (!canvas || !targetObject) {
      console.error("❌ Canvas or target object not available");
      return false;
    }

    const success = setReferenceItem(canvas, targetObject, realWidth, realHeight);
    if (success) {
      // Trigger canvas update
      setHasCanvasChanged(true);
      
      // ✅ Refresh modal with updated reference status
      if (isDetailModalOpen) {
        setTimeout(() => {
          openItemDetailsModal(targetObject);
        }, 100); // Small delay to ensure reference status is updated
      }
      
      return true;
    } else {
      console.error("❌ Failed to set reference item");
      return false;
    }
  };

  /**
   * Handle clearing reference item status
   */
  const handleClearReference = () => {
    // Clear reference item from canvas
    
    if (!canvas) {
      console.error("❌ Canvas not available");
      return false;
    }

    const success = clearReferenceItem(canvas);
    if (success) {
      // Reference item cleared successfully
      setHasCanvasChanged(true);
      return true;
    } else {
      console.error("❌ Failed to clear reference item");
      return false;
    }
  };

  /**
   * Handle editing reference item dimensions
   */
  const handleEditReferenceDimensions = (targetObject, newWidth, newHeight) => {
    // Edit reference dimensions
    
    if (!canvas || !targetObject) {
      console.error("❌ Canvas or target object not available");
      return false;
    }

    // Update the reference item dimensions
    targetObject.realWidth = newWidth.toString();
    targetObject.realHeight = newHeight.toString();

    // Update all dimensions based on the new reference
    const updateResult = updateAllDimensions(canvas);
    
    if (updateResult) {
      // Reference dimensions updated successfully
      setHasCanvasChanged(true);
      
      // ✅ Refresh modal with updated dimensions
      if (isDetailModalOpen) {
        // Refreshing modal with updated reference dimensions
        setTimeout(() => {
          openItemDetailsModal(targetObject);
        }, 100); // Small delay to ensure dimensions are updated
      }
      
      return true;
    } else {
      console.error("❌ Failed to update reference dimensions");
      return false;
    }
  };

  /**
   * Open reference dimension editing modal
   */
  const openReferenceDimensionModal = (targetObject, isNewReference = false) => {
    setReferenceDimensionModalData({
      targetObject,
      isNewReference,
      currentWidth: targetObject.realWidth || '36.0',
      currentHeight: targetObject.realHeight || '82.5',
      itemType: targetObject.itemType || 'Item'
    });
    
    setIsReferenceDimensionModalOpen(true);
  };

  /**
   * Handle saving reference dimensions from modal
   */
  const handleSaveReferenceDimensions = (newWidth, newHeight) => {
    if (!referenceDimensionModalData) return;
    
    const { targetObject, isNewReference } = referenceDimensionModalData;
    
    if (isNewReference) {
      // Set as new reference item
      const success = handleSetAsReference(targetObject, newWidth, newHeight);
    } else {
      // Edit existing reference dimensions
      const success = handleEditReferenceDimensions(targetObject, newWidth, newHeight);
    }
    
    // Close modal
    setIsReferenceDimensionModalOpen(false);
    setReferenceDimensionModalData(null);
  };





  function capitalizeFirstLetter(string) {
    if (!string) return "N/A";
    return string
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase() // Convert to lowercase for consistent formatting
      .split(" ") // Split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join back with spaces
  }


  // Add event listener for context menu suppression
  document.addEventListener("contextmenu", (event) => {
    event.preventDefault(); // Prevent the browser's default context menu
  });

  let pressTimer;

  function initCanvasEvents(setIsDragging) {
    canvas.off("mouse:down");
    canvas.off("mouse:up");
    canvas.off("object:modified");
    canvas.off("object:moved");
    canvas.off("mouse:wheel");
    canvas.off("touch:gesture");
    canvas.off("object:selected");
    canvas.off("selection:cleared");
    canvas.off("selection:created");
    canvas.off("selection:updated");
    canvas.off("touch:drag");
    canvas.on({
      "touch:gesture": function (e) {


        if (e.e.touches && e.e.touches.length == 2) {
          pausePanning = true;
          var point = new fabric.Point(e.self.x, e.self.y);
          if (e.self.state === "start") {
            zoomStartScale = canvas.getZoom();
          }
          var delta = zoomStartScale * e.self.scale;
          canvas.zoomToPoint(point, delta);
          pausePanning = false;
        }
      },

      "object:added": (e) => {
        setHasCanvasChanged(true);
        saveCanvasState(canvas, hasCanvasChanged);
        setWindowURL(e.target.itemUrl)
      },

      "object:removed": (e) => {
        setHasCanvasChanged(true);
        saveCanvasState(canvas, hasCanvasChanged);
      },

      "object:selected": function (e) {
        pausePanning = true;
        updateSkew();
        updateObjectSelected();
      },
      "selection:created": function (e) {
        const activeObject = canvas.getActiveObject();
        if (activeObject) {
          const isDoorSelected = activeObject.itemType === "doors"; // Check if the selected item is a door
          setIsDoor(isDoorSelected); // Set the state based on the item type
          setSelectedObject(activeObject); // Update the selected object state
        }
        if (e.selected && e.selected.length > 0) {
          const activeObject = e.selected[0];
          setSelectedObject(activeObject);
        } else {
          console.log("No target found in selection:created event.");
        }

        setIsObjectSelected(true);
        updateSkew();
        setObjectPerspective(canvas);
      },
      "selection:updated": function () {
        const activeObject = canvas.getActiveObject();
        if (activeObject) {
          const isDoorSelected = activeObject.itemType === "doors"; // Check if the selected item is a door
          setIsDoor(isDoorSelected); // Set the state based on the item type
          setSelectedObject(activeObject); // Update the selected object state
        }
        updateSkew();
        updateObjectSelected();
        setObjectPerspective(canvas);
      },
      "selection:cleared": function () {
        pausePanning = false;
        updateSkew();
        setSelectedObject(null);
        setIsObjectSelected(false);
        updateObjectSelected();
        if (!setIsObjSelected) {
          setIsOptionsPanelVisible(false);
        }
      },

      "touch:drag": function (e) {
        if (
          pausePanning === false &&
          undefined !== e.e.layerX &&
          undefined !== e.e.layerY
        ) {
          var currentX = e.e.layerX;
          var currentY = e.e.layerY;
          var xChange = currentX - lastX;
          var yChange = currentY - lastY;

          if (
            Math.abs(currentX - lastX) <= 50 &&
            Math.abs(currentY - lastY) <= 50
          ) {
            var delta = new fabric.Point(xChange, yChange);
            canvas.relativePan(delta);
          }

          lastX = e.e.layerX;
          lastY = e.e.layerY;
        }
      },
      "mouse:down": function (e) {

        if (canvas.isDrawingMode) {
          // Prevent default behavior for drawing or erasing
          if (e.e.button === 0) { // Left mouse button
            e.e.preventDefault();
            e.e.stopPropagation();
          }
          return; // Skip further processing for drawing/erasing
        }

        // Existing logic for mouse:down starts here

        // Long press handling (if needed)
        // pressTimer = setTimeout(() => {
        //   if (e.target) {
        //     // Long press detected
        //     openItemDetailsModal(e.target); // Open your modal with the selected object
        //   }
        // }, 800); // 800ms for a long press

        const mobileActiveObject = canvas.getActiveObject();

        if (mobileActiveObject) {
          setWindowURL(mobileActiveObject.itemUrl);
          setIsSelectedItem(true)
        }

        // Right-click handling
        if (e.e.button === 2) { // Right-click (button 2)

          const target = canvas.findTarget(e.e); // Get the object under the cursor
          if (target) {
            canvas.setActiveObject(target); // Programmatically set the target as the active object
            setSelectedObject(target); // Update the state with the selected object
            canvas.renderAll(); // Ensure the canvas updates visually
            // Prevent the browser's default context menu
            e.e.preventDefault();
            e.e.stopPropagation();

            // Open the modal with the selected item's details
            openItemDetailsModal(target);
            return; // Stop further processing for right-click
          } else {
            console.log("No target found under right-click.");
          }
        }

        // Left-click or other mouse interactions
        if (e.e.button === 0) { // Left-click (button 0)
          setIsObjSelected(true);

          const activeObject = canvas.getActiveObject(); // Get the active object
          if (activeObject) {
            // Logic for when an object is selected
            activeObject.offsetX = e.e.offsetX;
            activeObject.offsetY = e.e.offsetY;

            setIsSelectedItem(true);
            setIsItemAdded(true);
          } else {
            // Logic for when no object is selected
            setIsMixMatched(false);
            setIsSelectedItem(false);
            return;
          }

          if (e.target && e.target.type !== "group") {
            if (
              e.target.type === "polygon" &&
              e.target.usePerspective &&
              e.target.originObject.type === "group"
            ) {
              setTypeName(e.target.originObject.windowType);
              setWindowURL(e.target.originObject.itemUrl);
              setIsSelectedItem(true);
              e.target.opacity = 0.4;
              canvas.requestRenderAll();
              return;
            }
            // Additional logic for specific types of objects
            setIsSelectedItem(false);
            setIsOptionsPanelVisible(false);
            setIsSelectedShape(true);
            return;
          }

          if (e.target) {
            setTypeName(e.target.windowType);
            setWindowURL(e.target.itemUrl);
            setIsSelectedItem(true);
            e.target.opacity = 0.4;
          }

          canvas.requestRenderAll();
        }
      },



      "mouse:up": function (e) {

        // clearTimeout(pressTimer); // Clear the timer on mouse up

        if (e.target) {
          e.target.opacity = 1;
          canvas.requestRenderAll();
        }
        setHasCanvasChanged(true);
        saveCanvasState(canvas, hasCanvasChanged);

      },

      "object:moved": function (e) {
        // Minimize work here to avoid causing render jank while moving
        try {
          // keep a slight translucency while moving
          e.target.opacity = 0.6;
          // enable object caching for smoother repaints during move
          if (typeof e.target.set === 'function') {
            e.target.set('objectCaching', true);
          } else {
            e.target.objectCaching = true;
          }
        } catch (err) {
          // ignore
        }
        // Batch the render to the browser's animation frame
        if (!canvas.__moveRaf) {
          canvas.__moveRaf = true;
          requestAnimationFrame(() => {
            canvas.requestRenderAll();
            canvas.__moveRaf = false;
          });
        }
      },
      "object:moving": function (e) {
        // Mark dragging state and enable caching for smoother movement
        setIsDragging(true);
        try {
          if (e.target) {
            if (typeof e.target.set === 'function') {
              e.target.set('objectCaching', true);
              e.target.set('dirty', false);
            } else {
              e.target.objectCaching = true;
              e.target.dirty = false;
            }
          }
        } catch (err) {
          // ignore
        }
        // Throttle render calls using requestAnimationFrame
        if (!canvas.__moveRaf) {
          canvas.__moveRaf = true;
          requestAnimationFrame(() => {
            canvas.requestRenderAll();
            canvas.__moveRaf = false;
          });
        }
      },
      "object:modified": function (e) {
        setHasCanvasChanged(true);
        // Clear dragging state and restore caching settings
        setIsDragging(false);
        try {
          if (e.target) {
            if (typeof e.target.set === 'function') {
              e.target.set('objectCaching', false);
              e.target.set('dirty', true);
            } else {
              e.target.objectCaching = false;
              e.target.dirty = true;
            }
          }
        } catch (err) {
          // ignore
        }
        // Ensure final render
        canvas.requestRenderAll();
        // saveCanvasState(canvas, hasCanvasChanged);
      },

      // "mouse:wheel": function (opt) {
      //   //https://codepen.io/MarsAndBack/pen/MWKzYPe
      //   //saveCanvasState(canvas, canvas.getZoom());
      //   var delta = opt.e.deltaY;
      //   var zoom = canvas.getZoom();
      //   zoom *= 0.999 ** delta;
      //   if (zoom > 20) zoom = 20;
      //   if (zoom < 0.01) zoom = 0.01;
      //   canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      //   opt.e.preventDefault();
      //   opt.e.stopPropagation();
      // },
    });
  }

  function initKeyboardEvents() {
    const handleKeyUp = (e) => {
      // Prevent unintended behaviors (optional for keyup)
      e.preventDefault();
      e.stopPropagation();

      // Check for specific key combinations
      if (e.key === "Delete" || e.key === "Backspace") {
        setIsAvaillableDoorsPanelVisible(false);
        setIsPanelVisible(false);
        setIsOptionsPanelVisible(false)
        setIsPanelVisible(false)
        // Call removeObject() if necessary
        console.log("Delete or Backspace pressed");
      }
      if (e.ctrlKey && e.key === "z") {
        console.log("Undo triggered");
        e.preventDefault(); // Prevent browser's undo
        handleUndo();
      }
      if (e.ctrlKey && e.key === "y") {
        console.log("Redo triggered");
        e.preventDefault(); // Prevent browser's undo
        handleRedo();
      }
    };

    // Attach the keyup listener
    document.addEventListener("keyup", handleKeyUp);

    // Cleanup the listener on component unmount
    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }



  function removeObject() {
    var activeObject = canvas.getActiveObject();
    if (!activeObject) return;
    if (activeObject.type === "activeSelection") {
      activeObject.forEachObject(function (object) {
        canvas.remove(object);
        if (canvas.getActiveObject() < 1) {
          setIsItemAdded(false);
        }
      });
    } else {
      canvas.remove(activeObject);
      if (canvas.getActiveObject() < 1) {
        setIsItemAdded(false);
      }
    }
  }

  const checkForSeletedItems = () => {
    const aObj = canvas.getActiveObject(); // Get the active object

    let isSelect = false;
    let typeName = null;
    let isDoorSelected = false;

    if (aObj) {
      isSelect = true;

      if (aObj.type === "group") {
        typeName = aObj.windowType || aObj._objects?.[2]?.windowType || null;
      } else {
        typeName = aObj.windowType || null;
      }

      isDoorSelected = typeName?.includes("Door");
    }

    // Update state with active object details
    setActiveObjectDetails({
      isSelected: isSelect,
      typeName,
      isDoorSelected,
      itemType: aObj?.itemType || null,
      windowURL: aObj?.windowImageURL || null,
    });

    return isSelect;
  };


  function checkSelectedObjectType() {
    var aObj = canvas.getActiveObject();
    let windowTypes = [];
    var ttName = null;
    var isMix = false;
    var isSame = true;
    var type = "";
    if (aObj && aObj.type === "polygon") {
      aObj = aObj.originObject;
    }
    if (aObj && aObj.type === "group") {
      if (aObj._objects && aObj._objects[2]) {
        var tName = aObj._objects[2].windowType;
        if (ttName && tName !== ttName) {
          // we check to seeif all items added on canvas are the same type, important for otions
          isSame = false;
        }
        type = tName;
        ttName = tName;
      }
      if (aObj._objects && !windowTypes.includes(aObj._objects[2].windowType)) {
        windowTypes.push(aObj._objects[2].windowType);
      }
      if (windowTypes.length > 1) {
        isMix = true;
      } else if (windowTypes.length === 1) {
        type = windowTypes[0];
      }
    } else if (aObj && aObj.type === "activeSelection") {
      aObj.getObjects().forEach(function (o) {
        if (o._objects && o._objects[2]) {
          var tName = o._objects[2].windowType;
          if (ttName && tName !== ttName) {
            // we check to seeif all items added on canvas are the same type, important for otions
            isSame = false;
          }
          type = tName;
          ttName = tName;
        }
        if (o._objects && !windowTypes.includes(o._objects[2].windowType)) {
          windowTypes.push(o._objects[2].windowType);
        }
      });
      if (windowTypes.length > 1) {
        isMix = true;
      } else if (windowTypes.length === 1) {
        type = windowTypes[0];
      }
    }
    setIsMixMatched(isMix);
    setIsSameType(isSame);
    setTypeName(type);

    return {
      isMix: isMix,
      isSame: isSame,
      type: type,
    };
  }

  function handleProjectName(pName) {
    setProjectName(pName);
    // Update onboarding state to indicate project was clicked
    updateAppState({
      projectName: pName,
      projectClicked: true
    });
  }

  const hasSerializableCanvas = () => {
    return Boolean(
      canvas &&
      typeof canvas === 'object' &&
      typeof canvas.toDataURL === 'function' &&
      typeof canvas.clear === 'function'
    );
  };

  async function toJson(projectNameOverride = "") {
    console.time("NewProject.toJson");
    if (!hasSerializableCanvas()) {
      console.timeEnd("NewProject.toJson");
      return null;
    }

    setIsProjectList(false);

    const safeProjectName = (projectNameOverride || projectName || "untitled_project").replaceAll(" ", "_");

    let latestBgProps = null;
    if (bgImageProps && bgImageProps.length > 0) {
      latestBgProps = bgImageProps[bgImageProps.length - 1];
      canvas['backgroundImageProps'] = latestBgProps;
    } else {
      latestBgProps = canvas['backgroundImageProps'];
    }

    // ✅ Optimize canvas rendering options for faster generation
    const canvasOptions = {
      format: 'png',
      multiplier: 1,
      enableRetinaScaling: false, // Disable for faster rendering
      withoutTransform: false
    };

    // Generate PNG data URL from canvas
    let dataURL;
    if (latestBgProps) {
      const { x, y, newWidth, newHeight } = latestBgProps;
      dataURL = canvas.toDataURL({
        ...canvasOptions,
        left: x,
        top: y,
        width: newWidth,
        height: newHeight,
      });
    } else {
      dataURL = canvas.toDataURL(canvasOptions);
    }

    const userId = currentUser.uid;
    try {
      const storage = getStorage();

      // Resize and upload PNG image
      const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      };
      const file = dataURItoBlob(dataURL);
      let resizedDataURL = await new Promise((resolve, reject) => {
        Resizer.imageFileResizer(
          file,
          800,
          800,
          'PNG',
          100,
          0,
          (uri) => {
            resolve(uri);
          },
          'base64'
        );
      });

      const resizedFilename = `${safeProjectName}_${userId}_resized.png`;
      const resizedStorageRef = ref(
        storage,
        `usersProjectsImages/${userId}/canvasImages/canvasImagesResized/${resizedFilename}`
      );
      await uploadString(resizedStorageRef, resizedDataURL, 'data_url');
      const resizedDownloadURL = await getDownloadURL(resizedStorageRef);

      // Return an array of URLs for use in other functions
      return {
        resized: resizedDownloadURL
      };

    } catch (error) {
      console.error("❌ Error in toJson() - Image upload failed:", error);
      console.error("Error details:", {
        message: error.message,
        code: error.code,
        stack: error.stack
      });
      // Re-throw error so saveNewProject can handle it properly
      throw new Error(`Image upload failed: ${error.message}`);
    } finally {
      console.timeEnd("NewProject.toJson");
    }

    canvas.renderAll();
  }


  // Function to get the selected item's type
  const getSelectedItemType = () => {
    if (!canvas) return null;

    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      return activeObject.itemType || null; // Return `itemType` or `null` if not present
    }
    return null; // No active object
  };








  function toggleDimensionsOnCanvas(isVisible) {
    const objects = canvas.getObjects();

    objects.forEach((obj) => {
      if (obj.isDimension) { // Check the custom attribute
        obj.visible = isVisible;
      }
    });

    canvas.requestRenderAll();
  }



  const toggleDimensionsVisibility = () => {
    const newVisibility = !isDimensionsVisible;
    setIsDimensionsVisible(newVisibility); // Update state
    toggleDimensionVisibilityOnCanvas(canvas, !isDimensionsVisible);
    // Toggle visibility of all dimension objects on the canvas
    toggleDimensionsOnCanvas(newVisibility); // Use the new state immediately

  };

  const toggleDimensionVisibilityOnCanvas = (canvas, isVisible) => {
    canvas.getObjects().forEach((obj) => {
      if (obj.isDimension) {  // Check if the object has the isDimension property
        obj.set('visible', isVisible);  // Set visibility based on the checkbox state
      }
    });
    canvas.renderAll();  // Re-render the canvas to reflect visibility changes
  };

  const waitForCanvasRender = async (frames = 2) => {
    await waitForAnimationFrames(frames);
  };


  // Ensure `proposedColors` is normalized and passed correctly
  const detectAndApplyColors = async (proposedColors) => {

    handleShowLoader()
    // Normalize proposed colors to handle different casing or formatting
    const filteredColors = Object.keys(proposedColors)
      .filter(key => key.toLowerCase() !== 'garagedoor' && key.toLowerCase() !== 'portedugarage')
      .reduce((acc, key) => {
        // Normalize the key to singular form if it's 'windows'
        let normalizedKey = key.toLowerCase().replace(/\s+/g, '');
        if (normalizedKey === 'windows') {
          normalizedKey = 'window';  // Use singular form for consistency
        }
        acc[normalizedKey] = proposedColors[key];
        return acc;
      }, {});


    try {
      if (!isDetectionTriggered) {
        await triggerAIDetectionForOpenedProject(filteredColors, { skipAutoSave: true, throwOnError: true });
        setIsDetectionTriggered(true);
      }

      canvas.renderAll();
      await waitForCanvasRender();

      setHasCanvasChanged(true);
      saveCanvasState(canvas, hasCanvasChanged);

      const objects = canvas.getObjects();
      if (objects.length === 0) {
        throw new Error("No objects detected on the canvas. Colors will not be applied.");
      }

      await applyColorsToCanvasItems(filteredColors); // Use filtered colors
      await waitForCanvasRender();
      await waitForAnimationFrames(2);

      const isGuestUser = currentUser && currentUser.email.startsWith("guest_");
      if (!isGuestUser) {
        try {
          await waitForAnimationFrames(2);
          await saveUpdate();
        } catch (error) {
          console.error("❌ Error saving project after applying colors:", error);
        }
      }

      // Save canvas as WebP after detection
      const canvasDataUrl = canvas.toDataURL({
        format: "webp",
        quality: 0.8,
      });

      const webPFilename = `${projectName.replaceAll(" ", "_")}_${currentUser.uid}_detections.webp`;
      const webPStorageRef = ref(
        storage,
        `usersProjectsImages/${currentUser.uid}/canvasImages/canvasImagesWebP/${webPFilename}`
      );

      await uploadString(webPStorageRef, canvasDataUrl, "data_url");
      const downloadURL = await getDownloadURL(webPStorageRef);

      setDesignerTriggered(true);
      return downloadURL;

    } catch (error) {
      console.error('Error during detection and color application:', error);
      throw error;
    } finally {
      toggleDimensionsOnCanvas(false);
      handleHideLoader()
    }
  };

  const handleFeedbackSubmit = async (feedback, feedbackId) => {
    try {
      const feedbackRef = feedbackId
        ? doc(db, "AIDetectionsRatings", currentUser.uid, "Feedback", feedbackId) // Update existing feedback
        : doc(collection(db, "AIDetectionsRatings", currentUser.uid, "Feedback")); // Create new feedback

      const feedbackData = {
        ...feedback,
        timestamp: new Date().toISOString(),
        userId: currentUser.uid,
        projectName,
      };

      await setDoc(feedbackRef, feedbackData, { merge: true }); // Create or update the feedback document
      return feedbackRef.id; // Return the ID of the feedback document
    } catch (error) {
      console.error("Error submitting feedback:", error);
      throw error;
    }
  };



  // Function to fetch AI detection from the Netlify function
  async function fetchNetlifyFunctionForWallsAndTexturesDetection(imageUrl) {

    try {
      const response = await fetch('/.netlify/functions/directai-handler', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ imageUrl }),
      });

      if (!response.ok) {
        throw new Error('AI detection failed');
      }


      const data = await response.json();
      // console.log('DirectAI response data:', data); // Log the API response
      return data;
    } catch (error) {
      console.error('Error in fetchNetlifyFunctionForWallAndTextureDetection:', error);
      throw error;
    }
  }

  async function getImageMetadata(imageUrl) {
    // Create a reference to the file in Firebase Storage
    const storageRef = ref(storage, imageUrl);

    try {
      // Fetch the metadata using Firebase SDK
      const metadata = await getMetadata(storageRef);
      // console.log("Metadata:", metadata); // This includes content-type, size, etc.

      // Create an Image object to get the width and height of the image
      const img = new Image();
      img.src = imageUrl;

      return new Promise((resolve, reject) => {
        img.onload = function () {
          const imageWidth = img.width;
          const imageHeight = img.height;
          // console.log("Image dimensions:", { imageWidth, imageHeight });
          resolve({ imageWidth, imageHeight });
        };

        img.onerror = function (err) {
          reject(err);
        };
      });

    } catch (error) {
      console.error("Error fetching metadata:", error);
      return null;
    }
  }

  // Function to trigger the DirectAI detection
  const handleWallsAndTexturesDetection = async () => {
    const imageURL = getActiveProjectDetectionImageUrl();
    setDetectionImage(imageURL)

    getImageMetadata(imageURL).then(({ imageWidth, imageHeight }) => {
      console.log(`Image dimensions: ${imageWidth}x${imageHeight}`);

      // Now pass these dimensions along with the image URL to your canvas component
      setDetectionImageWidth(imageWidth);
      setDetectionImageHeight(imageHeight);
    });
    console.log("image width and height ;", detectionImageWidth, detectionImageHeight)
    try {
      const response = await fetchNetlifyFunctionForWallsAndTexturesDetection(imageURL);
      setWallsAndTexturesDetections(response); // Set the detections from the API response
      console.log('Detections set:', response); // Log the detections after setting the state
    } catch (error) {
      console.error('Error during detection:', error);
    }
  };


  // App.js
  async function triggerWallsAndTexturesDetection() {
    handleShowLoader(); // Show loader while detection is happening
    const imageURL = getActiveProjectDetectionImageUrl();
    setDetectionImage(imageURL); // Set detection image to be used for the canvas

    try {
      // Set the background image on the canvas
      await canvasBackground(imageURL);

      // Apply sharpening and contrast adjustment on the canvas image
      const canvasImage = canvas.backgroundImage; // Assuming this is the Fabric image object

      if (canvasImage) {
        // Apply sharpen filter (Convolute)
        const sharpenFilter = new fabric.Image.filters.Convolute({
          matrix: [
            0, -1, 0,
            -1, 5, -1,
            0, -1, 0
          ]
        });
        canvasImage.filters.push(sharpenFilter);

        // Apply contrast adjustment (Brightness filter to simulate contrast)
        const contrastFilter = new fabric.Image.filters.Brightness({
          brightness: 0.2  // Adjust for slight contrast increase; try other values as needed
        });
        canvasImage.filters.push(contrastFilter);

        // Apply the filters
        // canvasImage.applyFilters();
        canvas.renderAll();
      }

      // Fetch detection results from Netlify function for walls and textures
      const aiDetectionResults = await fetchNetlifyFunctionForWallsAndTexturesDetection(imageURL);

      // Access the first set of detection results (as in the previous logic)
      const detections = aiDetectionResults[0];  // Assuming the detection data is in index 0

      // Filter to only include walls and textures
      const filteredDetections = detections.filter(detection => detection.class === 'bricks' || detection.class === 'texture');

      // Iterate over each filtered detection
      filteredDetections.forEach((detection, index) => {
        console.log(`Processing detection #${index} (class: ${detection.class}):`, detection); // Log each detection object

        // Adjust and add the detection to the canvas
        addDetectedWallAndTexture(canvas, detection);
      });

      handleHideLoader(); // Hide loader after detection
      setIsDetectionTriggered(true);
    } catch (error) {
      console.error("Error setting up the canvas background:", error);
      console.error("Error during walls and textures detection:", error);
      handleHideLoader(); // Hide loader in case of error
    }
  }



  function adjustDetectionCoordinates(detection, fabricCanvas) {
    if (!detection.tlbr || detection.tlbr.length < 4) {
      console.error("Invalid detection.tlbr:", detection.tlbr);
      return null;
    }

    let scaleX = fabricCanvas.backgroundImage.scaleX;
    let scaleY = fabricCanvas.backgroundImage.scaleY;
    let offsetX = 0;
    let offsetY = 0;

    const canvasWidth = fabricCanvas.width;
    const bgImgWidth = fabricCanvas.backgroundImage.width * scaleX;
    const canvasHeight = fabricCanvas.height;
    const bgImgHeight = fabricCanvas.backgroundImage.height * scaleX;


    // Center horizontally if the background image is narrower than the canvas
    if (bgImgWidth < canvasWidth) {
      offsetX = (canvasWidth - bgImgWidth) / 2;
    }
    if (bgImgWidth < canvasWidth) {
      offsetY = (canvasHeight - bgImgHeight) / 2;
    }

    // Adjust coordinates based on scaleX and apply offsetX if needed
    const adjustedCoords = {
      left: detection.tlbr[0] * scaleX + offsetX,
      top: detection.tlbr[1] * scaleY, // We use scaleY for vertical adjustments
      width: (detection.tlbr[2] - detection.tlbr[0]) * scaleX,
      height: (detection.tlbr[3] - detection.tlbr[1]) * scaleY, // We use scaleY for vertical size adjustments
      scaleX, // Return scale factors for further usage
      scaleY,
      offsetX, // Offset in case you need horizontal adjustments
      offsetY,

    };

    return adjustedCoords;
  }



  function addDetectedWallAndTexture(canvas, detection) {
    // Adjust the detection coordinates based on the canvas and background image
    const adjustedCoords = adjustDetectionCoordinates(detection, canvas);

    if (!adjustedCoords) {
      console.error("Invalid detection coordinates:", detection);
      return;
    }

    // Convert rectangle bounding box to polygon points
    const points = [
      { x: adjustedCoords.left, y: adjustedCoords.top },
      { x: adjustedCoords.left + adjustedCoords.width, y: adjustedCoords.top },
      { x: adjustedCoords.left + adjustedCoords.width, y: adjustedCoords.top + adjustedCoords.height },
      { x: adjustedCoords.left, y: adjustedCoords.top + adjustedCoords.height }
    ];

    const polygon = new fabric.Polygon(points, {
      fill: detection.class === 'bricks' ? 'rgba(0, 0, 255, 0.3)' : 'rgba(255, 0, 0, 0.3)',
      stroke: 'blue',
      strokeWidth: 1,
      selectable: true,
      objectCaching: false,
      hasBorders: true,
      hasControls: true,
      lockScalingFlip: true,
      perPixelTargetFind: true,
      cornerStyle: 'circle',
      cornerColor: 'red',
    });

    // Add controls to each point and enable editing
    function updatePolygonControls() {
      polygon.controls = polygon.points.reduce((acc, point, index) => {
        acc[`p${index}`] = new fabric.Control({
          positionHandler: (dim, finalMatrix, fabricObject) => {
            return fabric.util.transformPoint(
              {
                x: fabricObject.points[index].x - fabricObject.pathOffset.x,
                y: fabricObject.points[index].y - fabricObject.pathOffset.y,
              },
              fabricObject.calcTransformMatrix()
            );
          },
          actionHandler: (eventData, transform, x, y) => {
            const polygon = transform.target;
            const currentControl = polygon.controls[polygon.__corner];
            const mouseLocalPosition = polygon.toLocalPoint(new fabric.Point(x, y), 'center', 'center');
            polygon.points[currentControl.pointIndex] = {
              x: mouseLocalPosition.x + polygon.pathOffset.x,
              y: mouseLocalPosition.y + polygon.pathOffset.y
            };
            polygon.dirty = true;
            canvas.requestRenderAll();
            return true;
          },
          render: fabric.controlsUtils.renderCircleControl,
          cornerSize: 8,
          pointIndex: index
        });
        return acc;
      }, {});
      canvas.renderAll();
    }

    // Function to add a new point to the polygon
    function addPoint() {
      // Find the midpoint of the first edge as an example
      const newPoint = {
        x: (polygon.points[0].x + polygon.points[1].x) / 2,
        y: (polygon.points[0].y + polygon.points[1].y) / 2
      };

      // Insert new point between points[0] and points[1]
      polygon.points.splice(1, 0, newPoint);

      // Update controls after adding a new point
      updatePolygonControls();
    }

    // Function to remove a selected point
    function removePoint(index) {
      if (polygon.points.length > 3) {  // Ensure the polygon has at least 3 points
        polygon.points.splice(index, 1);
        updatePolygonControls();
      } else {
        console.warn("A polygon must have at least 3 points.");
      }
    }

    // Add click event listeners for adding/removing points
    canvas.on('mouse:dblclick', function (event) {
      if (event.target === polygon) {
        addPoint();
      }
    });

    canvas.on('mouse:down', function (event) {
      if (event.target && event.target === polygon && event.e.button === 2) { // Right-click to remove point
        const activeControl = polygon.controls[polygon.__corner];
        if (activeControl && polygon.points.length > 3) {
          removePoint(activeControl.pointIndex);
        }
      }
    });

    // Add the polygon to the canvas
    canvas.add(polygon);

    // Initialize polygon controls
    updatePolygonControls();

    // Render the updated canvas
    canvas.renderAll();
  }



  const triggerAIDetectionWithAnalytics = () => {
    // Log the event
    handleAnalyticsEvent('AIDetectionClick', 'AI Detection', 'AI Detection Triggered');

    // Call the original AI detection function
    triggerAIDetectionForOpenedProject();
  };




  async function triggerAIDetectionForOpenedProject(predictions, options = {}) {
    const { skipAutoSave = false, throwOnError = false } = options;
    handleShowLoader();
    const imageURL = getActiveProjectDetectionImageUrl();
    setDetectionImage(imageURL);

    // ✅ Ensure we have valid detections (prefer state but fallback to new predictions)
    const finalDetections = roboflowFoundDetections.length > 0
      ? roboflowFoundDetections
      : (Array.isArray(predictions) ? predictions : []);

    // console.log("🟢 Using detections for AI placement:", finalDetections);

    try {
      if (!imageURL) {
        throw new Error("Missing source image for AI detection");
      }

      if (finalDetections.length === 0) {
        throw new Error("No valid detections found for AI placement.");
      }

      // ✅ First ensure canvas background is set, then run AI detection
      await canvasBackground(imageURL); // Set background image on canvas first
      await waitForCanvasRender();
      
      // ✅ Now run AI detection after canvas is ready
      await triggerDetection(
        addItem,
        setTypeName,
        setWindowURL,
        canvas,
        finalDetections,  // ✅ Ensures only valid detections are used
        projectScaleFactor,
        setProjectScaleFactor,
        false  // AI evaluation removed - no longer evaluating
      );

      setIsDetectionTriggered(true);
      
      canvas.renderAll();
      await waitForCanvasRender();
      
      // ✅ Update all dimensions after detection to ensure consistency
      updateAllDimensions(canvas);
      await waitForCanvasRender();
      await waitForAnimationFrames(2);
      
      setHasCanvasChanged(true);
      
      const isGuestUser = currentUser && currentUser.email.startsWith("guest_");
      if (!isGuestUser && !skipAutoSave) {
        try {
          await waitForAnimationFrames(2);
          await saveUpdate();
        } catch (error) {
          console.error("❌ Error saving project after detection:", error);
        }
      } else if (isGuestUser) {
        console.log("🚫 Skipping project save after detection for guest user");
      }
      
    } catch (error) {
      console.error("❌ Error setting up the canvas background:", error);
      if (throwOnError) throw error;
      toast.error(t("assistant.detectionFailed"));
    } finally {
      handleHideLoader();
    }
  }



  const applyColorsToCanvasItems = async (proposedColors) => {
    handleShowLoader();
    const objects = canvas.getObjects();

    if (objects.length === 0) {
      console.error("No objects detected on the canvas.");
      return;
    }

    // Normalize `proposedColors` keys for consistent matching
    const normalizedProposedColors = {};
    Object.keys(proposedColors).forEach(key => {
      const normalizedKey = normalizeItemKey(key); // Use a helper function for consistent normalization
      normalizedProposedColors[normalizedKey] = proposedColors[key];
    });


    const perspectiveTargets = [];

    const getRenderableGroup = (obj) => {
      if (!obj) return null;
      if (obj.type === 'group') return obj;
      if (obj.type === 'polygon' && obj.originObject?.type === 'group') {
        return obj.originObject;
      }
      return null;
    };

    const applyBlendColor = (subObj, rgbValue) => {
      if (!hasLoadedFabricImage(subObj)) {
        throw new Error(`Cannot apply color to an unloaded image: ${subObj.windowImageURL || subObj.getSrc?.() || subObj.itemType}`);
      }
      const existingFilters = subObj.filters || [];
      const existingColor = existingFilters.find(
        (filter) => filter.type === 'BlendColor' && filter.color === rgbValue
      );

      if (existingColor) {
        return;
      }

      const filter = new fabric.Image.filters.BlendColor({
        color: rgbValue,
        mode: "multiply",
        alpha: 0.95,
      });

      subObj.filters = [];
      subObj.filters.push(filter);
      subObj.applyFilters();
    };

    // Iterate through canvas objects and apply the colors based on `itemType`
    objects.forEach(obj => {
      const renderableGroup = getRenderableGroup(obj);
      if (!renderableGroup?._objects) {
        return;
      }

      if (obj.type === 'polygon' && obj.usePerspective) {
        perspectiveTargets.push(obj);
      }

      renderableGroup._objects.forEach(subObj => {
        const itemType = subObj.itemType ? normalizeItemKey(subObj.itemType) : null;

        if (!itemType) {
          return;
        }

        const colorArray = normalizedProposedColors[itemType];
        if (!colorArray || colorArray.length === 0) {
          return;
        }

        const colorName = colorArray[0];
        const rgbValue = getColorByName(colorName);

        if (!rgbValue) {
          console.error(`RGB value not found for color: ${colorName}`);
          return;
        }

        applyBlendColor(subObj, rgbValue);
        renderableGroup.itemColor = rgbValue;
      });
    });

    await Promise.all(
      perspectiveTargets.map((obj) =>
        setObjectPerspective(canvas, obj).catch((error) => {
          console.warn("Failed to refresh perspective object after color update:", error);
        })
      )
    );

    // Render the canvas to reflect the changes
    canvas.renderAll();

    // Deselect any active objects and re-render
    canvas.discardActiveObject();
    canvas.renderAll();
    await waitForAnimationFrames(2);

    // Mark the canvas as changed and save its state
    setHasCanvasChanged(true);
    saveCanvasState(canvas, hasCanvasChanged);
    handleHideLoader()
  };



  const normalizeItemKey = (key) => {
    return key
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '') // Remove spaces
      .normalize("NFD")    // Normalize diacritics
      .replace(/[\u0300-\u036f]/g, ""); // Remove accents
  };


  function applyColorToSpecificItems(itemType, rgbColor) {
    // ✅ Add comprehensive null checks
    if (!canvas) {
      console.warn("Canvas not available yet");
      return;
    }

    const objects = canvas.getObjects();
    setItemColor(rgbColor);

    if (!objects || objects.length === 0) {
      console.warn("No objects detected on the canvas yet - this is normal during initial loading.");
      return;
    }

    // Deselect the currently active object
    canvas.discardActiveObject();
    batchRender(); // ✅ Use batch rendering instead of immediate render

    objects.forEach((obj) => {
      // console.log("Checking object:", obj);

      if (obj.type === 'group' && obj.itemType === itemType) {
        // console.log(`Group Object Found for ${itemType}:`, obj);

        if (itemType === "doors") {
          // Dynamically calculate the index for the door image (-2 from the top of the stack)
          const totalObjects = obj._objects.length;
          const doorImageIndex = totalObjects - 3;

          const doorImage = obj._objects[doorImageIndex];
          if (doorImage && doorImage.type === 'image') {
            // console.log(`Door Image Found at Index ${doorImageIndex}:`, doorImage);

            // Update the filter for the door image
            applyOrUpdateColorFilter(doorImage, rgbColor);
          } else {
            console.log(`No door image found at index ${doorImageIndex}`);
          }
        } else if (itemType === "window") {
          // Handle window logic - apply color ONLY to the window frame (last element)
          // Window group structure: [backgroundImage, optionImage, windowImage]
          // Index 0: background (should NOT be colored)
          // Index 1: grid/glass (should be colored if it has windowGridType)
          // Index 2 (last): window frame (should ALWAYS be colored)
          
          const totalObjects = obj._objects.length;
          const windowFrameElement = obj._objects[totalObjects - 1]; // Last element is the window frame
          
          if (windowFrameElement && windowFrameElement.type === 'image') {
            // Update the filter for the window frame element
            applyOrUpdateColorFilter(windowFrameElement, rgbColor);
          }
          
          // Also update grid at index 1 if it exists and has windowGridType
          const gridElement = obj._objects[1];
          if (gridElement && gridElement.type === 'image' && gridElement.windowGridType) {
            applyOrUpdateColorFilter(gridElement, rgbColor);
          }
        }
      } else {
        // console.log("Skipping non-group or mismatched object:", obj);
      }
    });

    // ✅ Use batch rendering to prevent performance issues
    batchRender();
  }








  function applyOrUpdateColorFilter(imageObj, rgbColor, alpha = 0.95) {
    // console.log("Applying filter to object:", imageObj);

    const existingFilter = imageObj.filters.find(
      (filter) => filter.type === 'BlendColor'
    );

    if (existingFilter) {
      // console.log("Existing filter found. Updating color:", rgbColor);
      existingFilter.color = rgbColor;
      existingFilter.alpha = alpha;
    } else {
      // console.log("No existing filter found. Adding new filter with color:", rgbColor);
      const colorFilter = new fabric.Image.filters.BlendColor({
        color: rgbColor,
        mode: 'multiply',
        alpha: alpha,
      });
      imageObj.filters.push(colorFilter);
    }

    imageObj.applyFilters(); // Reapply filters to update
  }





  function applyRgbColorToObject(object, rgbColor) {
    const filter = new fabric.Image.filters.BlendColor({
      color: rgbColor,
      mode: "multiply",
      alpha: 0.95,
    });

    object.filters = [];
    object.filters.push(filter);
    object.applyFilters();
    setHasCanvasChanged(true);
    saveCanvasState(canvas, hasCanvasChanged);


  }














  function handleImageUploadSuccess(url, projectNameFromUpload = "") {
    // ✅ Reset AI states and go directly to Designer
    console.time("NewProject.totalCreationFlow");
    console.time("NewProject.saveNewProject");
    setIsSettingProjectThumbnail(true);
    resetAIStates();
    saveNewProject(url, projectNameFromUpload);
  }

  async function triggerRoboflowDetections(imageUrl) {
    const maxRetries = 2;
    let lastError = null;
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        console.log(`🔍 Starting RoboFlow detection attempt ${attempt}/${maxRetries} with URL:`, imageUrl);
        
        // ✅ Optimize the request with timeout and better error handling
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 20000); // 20 second timeout

        const response = await fetch('/.netlify/functions/roboflowDetections', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            // ✅ Add cache control to potentially speed up repeated requests
            'Cache-Control': 'no-cache'
          },
          body: JSON.stringify({ imageUrl }),
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        console.log("🔍 RoboFlow response status:", response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error(`❌ RoboFlow error response (attempt ${attempt}):`, errorText);
          
          // If it's a server error (5xx), retry. If client error (4xx), don't retry
          if (response.status >= 500 && attempt < maxRetries) {
            console.log(`🔄 Retrying in 2 seconds... (attempt ${attempt + 1}/${maxRetries})`);
            await new Promise(resolve => setTimeout(resolve, 2000));
            continue;
          }
          
          throw new Error(`Failed to fetch detections: ${response.status} - ${errorText}`);
        }

        const result = await response.json();
        console.log("🔍 RoboFlow result:", result);
        console.log("🔍 Raw predictions array:", result.predictions);
        console.log("🔍 First prediction sample:", result.predictions?.[0]);

        if (!result.predictions || !Array.isArray(result.predictions)) {
          console.error('❌ Invalid API response format:', result);
          return [];
        }

        // ✅ Process predictions using polygon points for more accurate placement
        const processedPredictions = result.predictions
          .filter(prediction => {
            console.log(`🔍 Checking prediction: class="${prediction.class}", confidence=${prediction.confidence}`);
            // New model uses capitalized class names: Door, Window
            const isValidType = prediction.class === 'Door' || prediction.class === 'Window';
            const hasValidConfidence = prediction.confidence > 0.88; // Balanced to catch doors (~88%) and full windows (>90%)
            const isValid = isValidType && hasValidConfidence;
            if (!isValid) {
              console.log(`❌ Filtered out: class="${prediction.class}" (isValidType=${isValidType}, confidence=${prediction.confidence})`);
            }
            return isValid;
          })
          .map(prediction => {
            // Normalize class name to lowercase
            const normalizedClass = prediction.class.toLowerCase();
            
            // ✅ Extract 4 corner points from polygon for perspective
            let perspectivePoints = null;
            let top, left, bottom, right;
            
            if (prediction.points && Array.isArray(prediction.points) && prediction.points.length >= 4) {
              const points = prediction.points;
              
              // Find the 4 corners: top-left, top-right, bottom-right, bottom-left
              const xCoords = points.map(p => p.x);
              const yCoords = points.map(p => p.y);
              
              left = Math.min(...xCoords);
              right = Math.max(...xCoords);
              top = Math.min(...yCoords);
              bottom = Math.max(...yCoords);
              
              // Find points closest to each corner
              const topLeft = points.reduce((closest, p) => {
                const dist = Math.sqrt(Math.pow(p.x - left, 2) + Math.pow(p.y - top, 2));
                const closestDist = Math.sqrt(Math.pow(closest.x - left, 2) + Math.pow(closest.y - top, 2));
                return dist < closestDist ? p : closest;
              });
              
              const topRight = points.reduce((closest, p) => {
                const dist = Math.sqrt(Math.pow(p.x - right, 2) + Math.pow(p.y - top, 2));
                const closestDist = Math.sqrt(Math.pow(closest.x - right, 2) + Math.pow(closest.y - top, 2));
                return dist < closestDist ? p : closest;
              });
              
              const bottomRight = points.reduce((closest, p) => {
                const dist = Math.sqrt(Math.pow(p.x - right, 2) + Math.pow(p.y - bottom, 2));
                const closestDist = Math.sqrt(Math.pow(closest.x - right, 2) + Math.pow(closest.y - bottom, 2));
                return dist < closestDist ? p : closest;
              });
              
              const bottomLeft = points.reduce((closest, p) => {
                const dist = Math.sqrt(Math.pow(p.x - left, 2) + Math.pow(p.y - bottom, 2));
                const closestDist = Math.sqrt(Math.pow(closest.x - left, 2) + Math.pow(closest.y - bottom, 2));
                return dist < closestDist ? p : closest;
              });
              
              perspectivePoints = [topLeft, topRight, bottomRight, bottomLeft];
              
              console.log(`📐 Using polygon corners for ${normalizedClass}:`, perspectivePoints);
            } else {
              // Fallback to bounding box calculation
              top = prediction.y - prediction.height / 2;
              left = prediction.x - prediction.width / 2;
              bottom = prediction.y + prediction.height / 2;
              right = prediction.x + prediction.width / 2;
              
              console.log(`📦 Using bounding box for ${normalizedClass}:`, { left, right, top, bottom });
            }
            
            return {
              class: normalizedClass,
              confidence: prediction.confidence,
              tlbr: [top, left, bottom, right],
              detection_id: prediction.detection_id,
              hasPolygon: !!(prediction.points && prediction.points.length > 0),
              polygonPoints: prediction.points || null,
              perspectiveCorners: perspectivePoints // ✅ 4 corner points for automatic perspective
            };
          });

        // ✅ Filter overlapping detections - keep only largest items in same area
        const filteredPredictions = processedPredictions.filter((pred, index, arr) => {
          const [top1, left1, bottom1, right1] = pred.tlbr;
          const area1 = (right1 - left1) * (bottom1 - top1);
          
          // Check if this prediction overlaps with any larger prediction
          for (let i = 0; i < arr.length; i++) {
            if (i === index) continue; // Skip self
            
            const other = arr[i];
            const [top2, left2, bottom2, right2] = other.tlbr;
            const area2 = (right2 - left2) * (bottom2 - top2);
            
            // Calculate intersection
            const intersectLeft = Math.max(left1, left2);
            const intersectTop = Math.max(top1, top2);
            const intersectRight = Math.min(right1, right2);
            const intersectBottom = Math.min(bottom1, bottom2);
            
            if (intersectLeft < intersectRight && intersectTop < intersectBottom) {
              // There is overlap
              const intersectArea = (intersectRight - intersectLeft) * (intersectBottom - intersectTop);
              const overlapRatio = intersectArea / Math.min(area1, area2);
              
              // If >50% overlap and the other is larger, filter this one out
              if (overlapRatio > 0.5 && area2 > area1) {
                console.log(`🗑️ Filtering overlapping ${pred.class}: area=${area1.toFixed(0)}, overlapped by larger ${other.class}: area=${area2.toFixed(0)}, overlap=${(overlapRatio*100).toFixed(1)}%`);
                return false;
              }
            }
          }
          
          return true; // Keep this prediction
        });
        
        console.log(`✅ Processed predictions: ${processedPredictions.length} → ${filteredPredictions.length} after overlap filtering`);
        return filteredPredictions;
        
      } catch (error) {
        console.error(`❌ Error triggering RoboFlow detections (attempt ${attempt}):`, error);
        lastError = error;
        
        if (attempt < maxRetries && !error.name === 'AbortError') {
          console.log(`🔄 Retrying in 2 seconds... (attempt ${attempt + 1}/${maxRetries})`);
          await new Promise(resolve => setTimeout(resolve, 2000));
          continue;
        }
        
        break;
      }
    }
    
    console.error('❌ All RoboFlow detection attempts failed:', lastError);
    return [];
  }

  const runFullAIDetectionFlow = async () => {
    try {
      console.log("🚀 Starting full AI detection process...");

      const backgroundImage = canvas.backgroundImage;
      const imageUrlFromCanvas = backgroundImage?.getSrc();
      const chosenImageUrl = newProjectImage || imageUrlFromCanvas;

      if (!chosenImageUrl) {
        console.error("❌ No valid image found for detection.");
        toast.error(t('assistant.noImageFound'));
        return;
      }

      // ✅ Use Promise.resolve to make this non-blocking
      updateProgress("detecting");
      
      const predictions = await triggerRoboflowDetections(chosenImageUrl);
      
      if (!predictions || predictions.length === 0) {
        console.warn("⚠️ No valid predictions found or no doors/windows detected - continuing without detections");
        toast.warning(t("assistant.noDetections"));
        
        // ✅ Continue without detections instead of returning early
        // This allows the color evaluation to still work even without object detection
        setRoboflowFoundDetections([]);
        return;
      }

      // 🔹 Save predictions to state and trigger AI detection immediately
      setRoboflowFoundDetections(predictions);
      
      // ✅ Use setTimeout to make AI detection non-blocking
      setTimeout(() => {
        triggerAIDetectionForOpenedProject(predictions);
      }, 0);

    } catch (error) {
      console.error("❌ Error in AI detection flow:", error);
      toast.error(t("assistant.detectionFailed"));
      
      // ✅ Continue without detections instead of completely failing
      setRoboflowFoundDetections([]);
    }
  };





  async function saveNewProject(url, projectNameOverride = "") {
    // ✅ Skip Firebase project creation for guest users
    const isGuestUser = currentUser && currentUser.email.startsWith("guest_");
    if (isGuestUser) {
      console.log("🚫 Skipping Firebase project creation for guest user");
      
      // ✅ Still set up project state for guest to use the app
      setNewProjectImage(url);
      
      // ✅ Generate a temporary projectId for guest session
      const tempProjectId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      setProjectId(tempProjectId);
      
      // ✅ Load canvas background for guest
      await canvasBackground(url);
      setHasActiveProjectLoaded(true);
      
      // ✅ Scroll to top after canvas background loads
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      const backgroundImage = canvas.backgroundImage;
      const imageUrl = backgroundImage?.getSrc();
      
      if (imageUrl) {
        setBackgroundImageUrl(imageUrl);
        setGeneratedProjectImages([{ url: imageUrl, source: 'original', createdAt: null }]);
        setActiveGeneratedImageUrl(imageUrl);
      }
      
      setHasCanvasChanged(true);
      setUploadComplete(true);
      setIsCreatingNewProject(false);
      
      // ✅ Signal project change to initialize FacadeDesigner for guest
      setProjectChangeKey((prevKey) => prevKey + 1);
      console.timeEnd("NewProject.saveNewProject");
      console.timeEnd("NewProject.totalCreationFlow");
      
      return; // Exit early for guests
    }
    
    // ✅ Regular user logic - proceed with Firebase operations
    let imageUrls;
    try {
      // ✅ Ensure background is set before generating images
      const resolvedProjectName = (projectNameOverride || newProjectCreationName || "").trim() || `project_${Date.now()}`;
      await canvasBackground(url);
      imageUrls = await toJson(resolvedProjectName);
      
      console.log("✅ Image URLs generated:", imageUrls);
      
      // Verify imageUrls has required fields
      if (!imageUrls || !imageUrls.resized) {
        console.error("❌ imageUrls is missing or incomplete:", imageUrls);
        throw new Error("Failed to generate image URLs - resized URL is missing");
      }
    } catch (error) {
      console.error("❌ Error generating images:", error);
      alert(`Failed to upload project images: ${error.message}`);
      setIsSettingProjectThumbnail(false);
      setIsCreatingNewProject(false);
      console.timeEnd("NewProject.saveNewProject");
      console.timeEnd("NewProject.totalCreationFlow");
      return;
    }

    // ✅ Scroll to top after canvas background loads
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setNewProjectImage(url);

    const collectionRef = collection(db, "Projects");
    const resolvedProjectName = (projectNameOverride || newProjectCreationName || "").trim() || `project_${Date.now()}`;
    const payload = {
      projectName: resolvedProjectName.replaceAll(" ", "_"),
      userId: currentUser.uid,
      imageUrls: {
        ...imageUrls,
        originalSource: url,
      },
      imageURL: imageUrls.resized, // Keep a PNG URL for legacy consumers during initial project creation
      generatedImages: [],
      imageName: `${resolvedProjectName.replaceAll(" ", "_") + "_" + currentUser.uid}`,
      projectJson: JSON.stringify(canvas.toJSON()),
      scaleFactor: scaleFactor,
      projectScaleFactor: projectScaleFactor,
      savedTimestamp: null,
      creationDate: Timestamp.now(),
    };
    
    try {
      const docRef = await addDoc(collectionRef, payload);
      const projectId = docRef.id;
      const createdProjectRecord = {
        ...payload,
        id: projectId,
      };

      setProjects((prevProjects) => {
        const withoutDuplicate = prevProjects.filter((project) => project.id !== projectId);
        return [createdProjectRecord, ...withoutDuplicate];
      });

      const backgroundImage = canvas.backgroundImage;
      const imageUrl = backgroundImage?.getSrc();

      if (imageUrl) {
        setBackgroundImageUrl(imageUrl);
      }

      setGeneratedProjectImages(
        url
          ? [{ url, source: 'original', createdAt: null }]
          : []
      );
      setActiveGeneratedImageUrl(url || '');

      // ✅ Set the projectId state so FacadeDesigner can work with it
      setProjectId(projectId);
      setHasActiveProjectLoaded(true);
      
      // ✅ Save the new project directly to Firebase first
      try {
        // Create project document directly for new projects
        const projectRef = doc(db, "usersProjects", projectId);
        const projectData = {
          userId: currentUser.uid,
          projectName: projectName,
          projectJson: JSON.stringify({
            canvas: canvasProject,
            backgroundImage: canvasProjectImage,
            scaleFactor: scaleFactor,
            projectScaleFactor: projectScaleFactor,
            lastModified: new Date(),
            userId: currentUser.uid
          })
        };
        
        await setDoc(projectRef, projectData);
        
        // Small delay to ensure Firebase write is complete
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        console.error("❌ Error saving new project:", error);
      }
      
      // Signal project change to reset FacadeDesigner AFTER saving
      setProjectChangeKey((prevKey) => prevKey + 1);

      // ✅ Update user's projectIds array
      await updateDoc(doc(db, "users", currentUser.uid), {
        projectIds: arrayUnion(projectId),
      });

      setHasCanvasChanged(true);

      // ✅ Add small delay to ensure Firestore has indexed the new document
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // ✅ Trigger project list refetch AFTER all operations complete
      setUploadComplete(true);
      handleAnalyticsEvent('project_created', 'project', 'own_project');
      await recordAdminJourneyEvent(db, {
        eventName: 'project_created', userId: currentUser.uid, email: currentUser.email,
        source: userAccessProfile?.standardTrialSource || userAccessProfile?.signupSource || 'unknown',
        projectId, projectName: resolvedProjectName,
        details: { accountType: hasActiveStandardTrial ? 'standard_trial' : (userAccessProfile?.planName || 'free') },
      });
      if (hasActiveStandardTrial) handleAnalyticsEvent('trial_project_created', 'trial', 'own_project');
      if (hasActiveStandardTrial) {
        await recordAdminJourneyEvent(db, {
          eventName: 'trial_project_created', userId: currentUser.uid, email: currentUser.email,
          source: userAccessProfile?.standardTrialSource || 'unknown', projectId, projectName: resolvedProjectName,
        });
      }

    } catch (error) {
      console.error("Error creating new project:", error);
      setIsSettingProjectThumbnail(false);
    } finally {
      console.timeEnd("NewProject.saveNewProject");
      console.timeEnd("NewProject.totalCreationFlow");
      // ✅ Reset the creating new project flag after successful creation
      setIsCreatingNewProject(false);
    }
  }









  const resetNewProjectImage = () => {
    setNewProjectImage('');
  };

  const normalizeImageUrlValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && typeof value.src === 'string') return value.src;
    if (typeof value === 'object' && typeof value.url === 'string') return value.url;
    return '';
  };

  const getProjectOriginalSourceImageUrl = (project) => {
    if (!project) return '';

    const imageFromUrls = normalizeImageUrlValue(project?.imageUrls?.originalSource);
    if (imageFromUrls) return imageFromUrls;

    const imageFromProjectJson = (() => {
      try {
        const projectJson = typeof project?.projectJson === 'string'
          ? JSON.parse(project.projectJson)
          : project?.projectJson;

        return normalizeImageUrlValue(projectJson?.backgroundImageProps?.src);
      } catch (error) {
        return '';
      }
    })();

    if (imageFromProjectJson && imageFromProjectJson !== 'MISSING_IMAGE_URL') {
      return imageFromProjectJson;
    }

    return '';
  };

  const getSavedProjectImageUrl = (project) => {
    if (!project) return '';

    const resizedImageFromUrls = normalizeImageUrlValue(project?.imageUrls?.resized);
    if (resizedImageFromUrls) return resizedImageFromUrls;

    const imageFromLegacy = normalizeImageUrlValue(project?.imageURL);
    if (imageFromLegacy && imageFromLegacy !== 'MISSING_IMAGE_URL') {
      if (imageFromLegacy.startsWith('data:image/')) {
        return imageFromLegacy;
      }
      const resizedFromLegacy = imageFromLegacy.replace(/\.png$/i, '_resized.png');
      if (resizedFromLegacy === imageFromLegacy) {
        return imageFromLegacy;
      }
      return resizedFromLegacy.replace('/canvasImages/', '/canvasImages/canvasImagesResized/');
    }

    try {
      const projectJson = typeof project?.projectJson === 'string'
        ? JSON.parse(project.projectJson)
        : project?.projectJson;

      const canvasProjectImage = normalizeImageUrlValue(projectJson?.canvasProjectImage);
      if (canvasProjectImage && canvasProjectImage !== 'MISSING_IMAGE_URL') {
        if (canvasProjectImage.startsWith('data:image/')) {
          return canvasProjectImage;
        }
        const resizedFromProjectJson = canvasProjectImage.replace(/\.png$/i, '_resized.png');
        if (resizedFromProjectJson === canvasProjectImage) {
          return canvasProjectImage;
        }
        return resizedFromProjectJson.replace('/canvasImages/', '/canvasImages/canvasImagesResized/');
      }
    } catch (error) {
      // Ignore JSON parse failures and continue with legacy image sources below.
    }

    const imageFromUrls = normalizeImageUrlValue(project?.imageUrls?.originalTreated);
    if (imageFromUrls) return imageFromUrls;

    const originalSourceUrl = getProjectOriginalSourceImageUrl(project);
    if (originalSourceUrl) return originalSourceUrl;

    return '';
  };

  const getSavedProjectImageFallbackUrl = (project) => {
    if (!project) return '';

    const originalTreatedUrl = normalizeImageUrlValue(project?.imageUrls?.originalTreated);
    if (originalTreatedUrl) return originalTreatedUrl;

    const legacyImageUrl = normalizeImageUrlValue(project?.imageURL);
    if (legacyImageUrl && legacyImageUrl !== 'MISSING_IMAGE_URL') {
      return legacyImageUrl;
    }

    try {
      const projectJson = typeof project?.projectJson === 'string'
        ? JSON.parse(project.projectJson)
        : project?.projectJson;

      const canvasProjectImage = normalizeImageUrlValue(projectJson?.canvasProjectImage);
      if (canvasProjectImage && canvasProjectImage !== 'MISSING_IMAGE_URL') {
        return canvasProjectImage;
      }
    } catch (error) {
      // Ignore JSON parse failures and continue to original source fallback.
    }

    return getProjectOriginalSourceImageUrl(project);
  };

  const getActiveProjectDetectionImageUrl = () => {
    const activeProject = projects.find((project) => project.id === projectId);
    return getDetectionImageUrl({
      originalSourceUrl: getProjectOriginalSourceImageUrl(activeProject),
      newProjectImageUrl: normalizeImageUrlValue(newProjectImage),
      userId: currentUser?.uid,
      projectName,
      savedFallbackUrl: getSavedProjectImageFallbackUrl(activeProject),
    });
  };

  const normalizeGeneratedEntries = (entries) => {
    if (!Array.isArray(entries)) return [];

    return entries
      .map((entry) => {
        if (typeof entry === 'string') {
          return { url: entry, source: 'generated', createdAt: null };
        }

        const normalizedUrl = normalizeImageUrlValue(entry?.url || entry?.src || entry);
        if (!normalizedUrl) return null;

        return {
          ...entry,
          url: normalizedUrl,
          source: entry?.source || 'generated',
        };
      })
      .filter((entry) => !!entry?.url);
  };

  const getImageCanonicalKey = (urlValue) => {
    const normalizedUrl = normalizeImageUrlValue(urlValue);
    if (!normalizedUrl) return '';

    if (normalizedUrl.startsWith('data:image/')) {
      return normalizedUrl;
    }

    try {
      const parsed = new URL(normalizedUrl);
      return `${parsed.origin}${parsed.pathname}`;
    } catch (error) {
      return normalizedUrl.split('?')[0].split('#')[0];
    }
  };

  const buildProjectImageHistory = (project) => {
    const originalUrl = getProjectOriginalSourceImageUrl(project);
    const originalKey = getImageCanonicalKey(originalUrl);
    const savedUrl = getSavedProjectImageUrl(project);
    const savedKey = getImageCanonicalKey(savedUrl);
    const generatedEntries = normalizeGeneratedEntries(project?.generatedImages);
    const seen = new Set();
    const history = [];

    if (originalUrl) {
      history.push({
        url: originalUrl,
        source: 'original',
        createdAt: null,
      });
      seen.add(originalKey || originalUrl);
    }

    if (project?.savedTimestamp && savedUrl && (!savedKey || !seen.has(savedKey))) {
      history.push({
        url: savedUrl,
        source: 'saved',
        createdAt: project.savedTimestamp || null,
      });
      seen.add(savedKey || savedUrl);
    }

    generatedEntries.forEach((entry) => {
      if (!entry?.url) return;

      const entryKey = getImageCanonicalKey(entry.url) || entry.url;
      if (!entryKey || seen.has(entryKey)) return;

      seen.add(entryKey);

      const isEntryOriginal = !!originalKey && entryKey === originalKey;
      const isEntrySaved = !!savedKey && entryKey === savedKey;
      history.push({
        ...entry,
        source: isEntryOriginal ? 'original' : (isEntrySaved ? 'saved' : 'generated'),
      });
    });

    return history;
  };

  const getImageEntryByUrl = (entries, urlValue) => {
    const targetKey = getImageCanonicalKey(urlValue) || normalizeImageUrlValue(urlValue);
    if (!targetKey) return null;

    return (entries || []).find((entry) => {
      const entryKey = getImageCanonicalKey(entry?.url) || normalizeImageUrlValue(entry?.url);
      return entryKey === targetKey;
    }) || null;
  };

  const activeGeneratedImageEntry = getImageEntryByUrl(generatedProjectImages, activeGeneratedImageUrl);
  const currentCanvasImageEntry = getImageEntryByUrl(
    generatedProjectImages,
    canvas?.backgroundImage?.getSrc?.() || backgroundImageUrl
  );
  const isGeneratedImageActiveOnCanvas =
    activeGeneratedImageEntry?.source === 'generated' ||
    currentCanvasImageEntry?.source === 'generated';
  const shouldPreserveEditableProjectOnSave = isGeneratedImageActiveOnCanvas;
  const isOriginalProjectBaseActive = !activeGeneratedImageUrl ||
    activeGeneratedImageEntry?.source === 'original' ||
    activeGeneratedImageEntry?.source === 'saved';
  const activeProjectForImageHistory = projects.find((project) => project.id === projectId) || null;
  const projectHistoryEntries = generatedProjectImages.filter((image) => image?.source !== 'generated');
  const aiGeneratedHistoryEntries = generatedProjectImages.filter((image) => image?.source === 'generated');
  const originalProjectImageUrl = generatedProjectImages.find((image) => image?.source === 'original')?.url || '';

  const captureCurrentProjectStateForNewProjectFlow = useCallback(() => {
    preNewProjectStateRef.current = {
      projectName,
      projectId,
      hasActiveProjectLoaded,
      hasCanvasChanged,
      canvasProject: canvasProject || canvas?.toJSON?.() || null,
      canvasProjectImage,
      generatedProjectImages,
      activeGeneratedImageUrl,
      backgroundImageUrl,
      backgroundImageStorageUrl,
      canvasImageName,
      newProjectImage,
      scaleFactor,
      projectScaleFactor,
      fileId,
    };
  }, [
    activeGeneratedImageUrl,
    backgroundImageUrl,
    backgroundImageStorageUrl,
    canvas,
    canvasImageName,
    canvasProject,
    canvasProjectImage,
    generatedProjectImages,
    hasActiveProjectLoaded,
    hasCanvasChanged,
    fileId,
    newProjectImage,
    projectId,
    projectName,
    projectScaleFactor,
    scaleFactor,
  ]);

  function restoreCapturedProjectStateAfterNewProjectCancel() {
    const snapshot = preNewProjectStateRef.current;
    preNewProjectStateRef.current = null;

    if (!snapshot) {
      return;
    }

    setProjectName(snapshot.projectName || "");
    setProjectId(snapshot.projectId || null);
    setHasActiveProjectLoaded(Boolean(snapshot.hasActiveProjectLoaded));
    setHasCanvasChanged(Boolean(snapshot.hasCanvasChanged));
    setCanvasProject(snapshot.canvasProject || "");
    setCanvasProjectImage(snapshot.canvasProjectImage || "");
    setGeneratedProjectImages(snapshot.generatedProjectImages || []);
    setActiveGeneratedImageUrl(snapshot.activeGeneratedImageUrl || "");
    setBackgroundImageUrl(snapshot.backgroundImageUrl || "");
    setBackgroundImageStorageUrl(snapshot.backgroundImageStorageUrl || "");
    setCanvasImageName(snapshot.canvasImageName || "");
    setNewProjectImage(snapshot.newProjectImage || "");
    setScaleFactor(snapshot.scaleFactor ?? 1);
    setProjectScaleFactor(snapshot.projectScaleFactor ?? null);
    setFileId(snapshot.fileId ?? null);
    setIsCreatingNewProject(false);

    if (snapshot.canvasProject) {
      setTimeout(() => {
        loadProject(snapshot.canvasProject, snapshot.scaleFactor ?? 1);
      }, 0);
    }
  }

  function closeCurrentProjectForNewProjectFlow() {
    captureCurrentProjectStateForNewProjectFlow();

    setAccount(false);
    setIsAccountModalOpen(false);
    setIsProjectList(false);
    setDesignerModalOpen(false);
    setShowUnsavedChangesModal(false);
    setHasActiveProjectLoaded(false);
    setHasCanvasChanged(false);
    setProjectName("");
    setProjectId(null);
    setNewProjectCreationName("");
    setUploadImageUrl(null);
    setCanvasProject("");
    setCanvasProjectImage("");
    setBackgroundImageStorageUrl("");
    setCanvasImageName("");
    setBackgroundImageUrl("");
    setNewProjectImage("");
    setGeneratedProjectImages([]);
    setActiveGeneratedImageUrl("");
    setGeneratedImageModalUrl("");
    setIsGeneratedImageModalOpen(false);
    setGeneratedImageModalPosition({ x: 0, y: 0 });
    if (generatedImagePreviewFrameRef.current) {
      cancelAnimationFrame(generatedImagePreviewFrameRef.current);
      generatedImagePreviewFrameRef.current = null;
    }
    if (generatedImageLensRef.current) {
      generatedImageLensRef.current.style.opacity = '0';
    }
    setScaleFactor(1);
    setProjectScaleFactor(null);

    if (canvas) {
      clearCanvas();
    }

    resetAIStates();
  }

  // ✅ Function to reset states when starting a new project
  function resetAIStates() {
    // ✅ Set flag to indicate we're creating a new project (prevents CanvasPopup from showing)
    setIsCreatingNewProject(true);
    
    // Reset detection states
    setRoboflowFoundDetections([]);
    setIsDetectionTriggered(false);
    
    // Reset progress states
    setCurrentStep("uploading");
    
    // Reset project image states
    setNewProjectImage('');
    setBackgroundImageUrl('');
    setGeneratedProjectImages([]);
    setActiveGeneratedImageUrl('');
    
    // Reset file ID
    setFileId(null);
    
    // ✅ Reset default item color to black (default state)
    setItemColor("rgba(0, 0, 0, 1)");
    setSelectedItemColor(null);
    
    // ✅ Signal project change to reset FacadeDesigner states
    setProjectChangeKey((prevKey) => prevKey + 1);
  }

  const resetAIDetectionPipeline = useCallback(() => {
    setRoboflowFoundDetections([]);
    setIsDetectionTriggered(false);
    setCurrentStep("uploading");
  }, []);



  function loadProject(proj, scaleFact, fallbackBackgroundSrc = '') {
    if (proj) {
      setHasActiveProjectLoaded(true);
      setIsLoaderFinish(false);
      setCanvasProject(proj);
      setIsSameType(true);

      try {

        // Load project JSON onto the canvas
        canvas.loadFromJSON(proj, async () => {
          let objects = canvas.getObjects();
          const perspectiveRefreshJobs = [];

          objects.forEach((obj) => {
            if (obj.type === "polygon" && obj.usePerspective) {
              obj.originObject = getRelatedObject(canvas, obj);
              obj.objectCaching = false;
              perspectiveRefreshJobs.push(
                setObjectPerspective(canvas, obj).catch((error) => {
                  console.warn("Failed to restore perspective object while loading project:", error);
                })
              );
            }
          });

          if (perspectiveRefreshJobs.length > 0) {
            await Promise.all(perspectiveRefreshJobs);
          }

          const existingBackgroundImage = canvas.backgroundImage;

          // Check and apply the background image properties
          if (existingBackgroundImage) {
            if (proj.backgroundImageProps) {
              canvas['backgroundImageProps'] = proj.backgroundImageProps;
            }
            canvas.renderAll();
            toggleDimensionVisibilityOnCanvas(canvas, isDimensionsVisible);
          } else if (proj.backgroundImageProps) {
            const { x, y, newWidth, newHeight, src } = proj.backgroundImageProps;
            fabric.Image.fromURL(src, (img) => {
              img.set({
                left: x,
                top: y,
                width: newWidth,
                height: newHeight,
                selectable: false,
              });
              canvas.setBackgroundImage(img);
              canvas.renderAll();

              // Toggle dimensions visibility after the background image is set
              toggleDimensionVisibilityOnCanvas(canvas, isDimensionsVisible);
            });
          } else if (fallbackBackgroundSrc || proj?.backgroundImage?.src) {
            const restoredBackgroundSrc = fallbackBackgroundSrc || proj.backgroundImage.src;
            fabric.Image.fromURL(restoredBackgroundSrc, (img) => {
              if (!img) {
                canvas.renderAll();
                toggleDimensionVisibilityOnCanvas(canvas, isDimensionsVisible);
                return;
              }

              const scale_factor = Math.min(
                canvas.width / img.width,
                canvas.height / img.height
              );
              const newWidth = img.width * scale_factor;
              const newHeight = img.height * scale_factor;
              const x = canvas.width / 2 - newWidth / 2;
              const y = 0;

              canvas['backgroundImageProps'] = {
                src: restoredBackgroundSrc,
                x,
                y,
                newWidth,
                newHeight,
                scaleX: scale_factor,
                scaleY: scale_factor,
                left: x,
                top: y,
              };

              img.set({
                scaleX: scale_factor,
                scaleY: scale_factor,
                left: x,
                top: y,
                originX: "left",
                originY: "top",
                selectable: false,
              });
              canvas.setBackgroundImage(img);
              canvas.renderAll();
              toggleDimensionVisibilityOnCanvas(canvas, isDimensionsVisible);
            }, { crossOrigin: "Anonymous" });
          } else {
            canvas.renderAll();

            // Toggle dimensions visibility if no background image is set
            toggleDimensionVisibilityOnCanvas(canvas, isDimensionsVisible);
          }
        });
      } catch (error) {
        console.error("Failed to load project:", error);
      }

      // Load scale factor
      if (scaleFact !== undefined) {
        setScaleFactor(scaleFact);
      }

      setHasCanvasChanged(false);
    } else {
      console.error("Invalid proj object:", proj);
    }
  }

  useEffect(() => {
    const isGuestUser = currentUser && currentUser.email.startsWith('guest_');

    if (!isGuestUser) {
      lastGuestOpenedProjectIdRef.current = null;
      guestSessionGeneratedImageKeysRef.current = new Map();
      return;
    }

    if (!projectId || projectId.toString().startsWith('guest_')) {
      return;
    }

    if (lastGuestOpenedProjectIdRef.current !== projectId) {
      guestSessionGeneratedImageKeysRef.current.set(projectId, new Set());
      lastGuestOpenedProjectIdRef.current = projectId;
    }
  }, [projectId, currentUser]);

  useEffect(() => {
    if (!projectId) {
      setGeneratedProjectImages([]);
      setActiveGeneratedImageUrl('');
      return;
    }

    if (projectId.toString().startsWith('guest_')) {
      if (!newProjectImage) {
        setGeneratedProjectImages([]);
        setActiveGeneratedImageUrl('');
        return;
      }

      setGeneratedProjectImages([{ 
        url: newProjectImage,
        source: 'original',
        createdAt: null,
      }]);

      setActiveGeneratedImageUrl(newProjectImage);
      return;
    }

    const activeProject = projects.find((project) => project.id === projectId);
    if (!activeProject) {
      setGeneratedProjectImages([]);
      setActiveGeneratedImageUrl('');
      return;
    }

    const isGuestUser = Boolean(currentUser?.email?.startsWith('guest_'));
    const isProjectOwnedByCurrentUser = Boolean(currentUser?.uid && activeProject?.userId === currentUser.uid);
    if (isGuestUser && isProjectOwnedByCurrentUser) {
      const originalUrl =
        generatedProjectImagesRef.current.find((entry) => entry?.source === 'original')?.url ||
        originalProjectImageUrl ||
        getProjectOriginalSourceImageUrl(activeProject);
      const originalKey = getImageCanonicalKey(originalUrl);
      const savedUrl = getSavedProjectImageUrl(activeProject);
      const localSavedEntry = generatedProjectImagesRef.current.find((entry) => entry?.source === 'saved');
      const generatedEntries = normalizeGeneratedEntries(activeProject?.generatedImages);
      const sessionGeneratedKeys = guestSessionGeneratedImageKeysRef.current.get(projectId) || new Set();
      const staleGeneratedEntries = generatedEntries.filter((entry) => {
        const entryKey = getImageCanonicalKey(entry?.url) || normalizeImageUrlValue(entry?.url);
        if (!entryKey) return false;
        if (entry?.source === 'original') return false;
        if (entry?.source === 'saved') return false;
        if (originalKey && entryKey === originalKey) return false;
        if (sessionGeneratedKeys.has(entryKey)) return false;
        return true;
      });

      const guestHistory = [];

      if (originalUrl) {
        guestHistory.push({ url: originalUrl, source: 'original', createdAt: null });
      }

      if (localSavedEntry?.url) {
        const localSavedKey = getImageCanonicalKey(localSavedEntry.url) || normalizeImageUrlValue(localSavedEntry.url);
        if (localSavedKey && (!originalKey || localSavedKey !== originalKey)) {
          guestHistory.push({
            ...localSavedEntry,
            url: normalizeImageUrlValue(localSavedEntry.url),
            source: 'saved',
          });
        }
      } else if (savedUrl) {
        const savedKey = getImageCanonicalKey(savedUrl) || savedUrl;
        if (savedKey && (!originalKey || savedKey !== originalKey)) {
          guestHistory.push({ url: savedUrl, source: 'saved', createdAt: activeProject?.savedTimestamp || null });
        }
      }

      generatedEntries.forEach((entry) => {
        const entryUrl = normalizeImageUrlValue(entry?.url);
        const entryKey = getImageCanonicalKey(entryUrl) || entryUrl;
        if (!entryUrl || !entryKey) return;
        if (entry?.source === 'original') return;
        if (originalKey && entryKey === originalKey) return;
        if (!sessionGeneratedKeys.has(entryKey)) return;

        const alreadyAdded = guestHistory.some((image) => {
          const imageKey = getImageCanonicalKey(image?.url) || normalizeImageUrlValue(image?.url);
          return imageKey === entryKey;
        });

        if (!alreadyAdded) {
          guestHistory.push({
            ...entry,
            url: entryUrl,
            source: 'generated',
          });
        }
      });

      setGeneratedProjectImages(guestHistory);

      const activeInHistory = guestHistory.some((image) => image.url === activeGeneratedImageUrl);
      if (!activeInHistory) {
        const preferredGenerated = guestHistory.find((image) => image.source === 'generated');
        setActiveGeneratedImageUrl(preferredGenerated?.url || originalUrl || '');
      }

      if (staleGeneratedEntries.length > 0) {
        const sanitizedGeneratedImages = guestHistory;

        Promise.allSettled(
          staleGeneratedEntries.map(async (entry) => {
            const staleUrl = normalizeImageUrlValue(entry?.url);
            if (!staleUrl || staleUrl.startsWith('data:image/')) return;

            try {
              const staleImageRef = ref(storage, staleUrl);
              await deleteObject(staleImageRef);
            } catch (storageError) {
              if (storageError?.code !== 'storage/object-not-found') {
                console.warn('Failed to delete stale guest generated image from storage:', storageError);
              }
            }
          })
        ).then(async () => {
          try {
            await updateDoc(doc(db, 'Projects', projectId), {
              generatedImages: sanitizedGeneratedImages,
            });
          } catch (firestoreError) {
            console.warn('Failed to sanitize guest project generated images in Firestore:', firestoreError);
          }

          setProjects((prevProjects) => prevProjects.map((project) => {
            if (project.id !== projectId) return project;
            return {
              ...project,
              generatedImages: sanitizedGeneratedImages,
            };
          }));
        });
      }

      return;
    }

    const imageHistory = buildProjectImageHistory(activeProject);
    setGeneratedProjectImages(imageHistory);

    if (!activeGeneratedImageUrl || !imageHistory.some((image) => image.url === activeGeneratedImageUrl)) {
      setActiveGeneratedImageUrl(imageHistory[0]?.url || '');
    }
  }, [projectId, projects, newProjectImage, currentUser, activeGeneratedImageUrl]);

  const applyImageToCanvasBackground = async (imageUrl) => {
    if (!canvas || !imageUrl) return;

    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(
        imageUrl,
        (oImg) => {
          if (!oImg) {
            reject(new Error('Failed to load background image'));
            return;
          }

          oImg.set({
            objectCaching: false,
            crossOrigin: 'anonymous',
          });

          scaleAndPositionImage(oImg);
          batchRender();
          resolve();
        },
        {
          crossOrigin: 'anonymous',
          objectCaching: false,
          statefullCache: false,
          selectable: false,
        }
      );
    });
  };

  const clearCanvasObjects = () => {
    if (!canvas) return;

    const canvasObjects = canvas.getObjects ? [...canvas.getObjects()] : [];
    canvasObjects.forEach((obj) => {
      if (obj) {
        canvas.remove(obj);
      }
    });

    if (typeof canvas.discardActiveObject === 'function') {
      canvas.discardActiveObject();
    }
  };

  const openGeneratedImageModal = (imageUrl) => {
    const normalizedUrl = normalizeImageUrlValue(imageUrl);
    if (!normalizedUrl) return;

    setGeneratedImageModalUrl(normalizedUrl);
    setIsGeneratedImageModalOpen(true);
  };

  const hideGeneratedImageLens = useCallback(() => {
    if (generatedImagePreviewFrameRef.current) {
      cancelAnimationFrame(generatedImagePreviewFrameRef.current);
      generatedImagePreviewFrameRef.current = null;
    }

    if (generatedImageLensRef.current) {
      generatedImageLensRef.current.style.opacity = '0';
    }
  }, []);

  const closeGeneratedImageModal = () => {
    setIsGeneratedImageModalOpen(false);
    setGeneratedImageModalUrl("");
    setGeneratedImageModalPosition({ x: 0, y: 0 });
    hideGeneratedImageLens();
  };

  const applyImageEntryAsBase = async (imageEntry) => {
    const imageUrl = normalizeImageUrlValue(imageEntry?.url || imageEntry);
    if (!imageUrl) return false;

    const isSavedEntry = imageEntry?.source === 'saved';

    if (isSavedEntry) {
      const parseProjectJson = (value) => {
        if (!value) return null;
        if (typeof value === 'object') return value;

        if (typeof value === 'string') {
          try {
            return JSON.parse(value);
          } catch (error) {
            return null;
          }
        }

        return null;
      };

      const currentProject = projects.find((project) => project.id === projectId);
      const projectJsonFromState = parseProjectJson(canvasProject);
      const projectJsonFromProjectDoc = parseProjectJson(currentProject?.projectJson);
      const projectToRestore = projectJsonFromState || projectJsonFromProjectDoc;

      if (projectToRestore && canvas) {
        try {
          loadProject(projectToRestore, currentProject?.scaleFactor ?? scaleFactor);
          setBackgroundImageUrl(imageUrl);
          setActiveGeneratedImageUrl(imageUrl);
          return true;
        } catch (restoreError) {
          console.error('Error restoring editable project from thumbnail:', restoreError);
        }
      }
    }

    try {
      clearCanvasObjects();
      await applyImageToCanvasBackground(imageUrl);
      setBackgroundImageUrl(imageUrl);
      setActiveGeneratedImageUrl(imageUrl);
      return true;
    } catch (error) {
      console.error('Error applying image as base:', error);
      toast.error(t('assistant.failedToApplyBaseImage', { defaultValue: 'Failed to apply image.' }));
      return false;
    }
  };

  const handleUseGeneratedImageAsBase = async (imageEntryOrUrl) => {
    const imageEntry = typeof imageEntryOrUrl === 'string'
      ? getImageEntryByUrl(generatedProjectImages, imageEntryOrUrl) || { url: imageEntryOrUrl, source: 'generated' }
      : imageEntryOrUrl;

    const didApply = await applyImageEntryAsBase(imageEntry);
    if (!didApply) return;

    closeGeneratedImageModal();
    toast.success(t('assistant.generatedImageSetAsBase', { defaultValue: 'Base image updated.' }));
  };

  const handleGeneratedImageModalDragStart = (event) => {
    if (event.target.closest('button')) return;

    generatedImageModalDragRef.current = {
      isDragging: true,
      startX: event.clientX,
      startY: event.clientY,
      originX: generatedImageModalPosition.x,
      originY: generatedImageModalPosition.y,
    };
  };

  const handleGeneratedImagePreviewMove = (event) => {
    const container = generatedImagePreviewRef.current;
    const image = generatedImagePreviewImgRef.current;
    const lens = generatedImageLensRef.current;
    if (!container || !image || !lens || !generatedImageModalUrl) return;

    const containerRect = container.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    const pointerX = event.clientX - containerRect.left;
    const pointerY = event.clientY - containerRect.top;
    const imageRelativeX = event.clientX - imageRect.left;
    const imageRelativeY = event.clientY - imageRect.top;

    if (
      imageRelativeX < 0 ||
      imageRelativeY < 0 ||
      imageRelativeX > imageRect.width ||
      imageRelativeY > imageRect.height
    ) {
      hideGeneratedImageLens();
      return;
    }

    if (generatedImagePreviewFrameRef.current) {
      cancelAnimationFrame(generatedImagePreviewFrameRef.current);
    }

    generatedImagePreviewFrameRef.current = requestAnimationFrame(() => {
      const zoomFactor = 2.5;
      const lensSize = 180;
      const backgroundX = -(imageRelativeX * zoomFactor - lensSize / 2);
      const backgroundY = -(imageRelativeY * zoomFactor - lensSize / 2);

      lens.style.opacity = '1';
      lens.style.left = `${pointerX}px`;
      lens.style.top = `${pointerY}px`;
      lens.style.backgroundImage = `url(${generatedImageModalUrl})`;
      lens.style.backgroundRepeat = 'no-repeat';
      lens.style.backgroundSize = `${imageRect.width * zoomFactor}px ${imageRect.height * zoomFactor}px`;
      lens.style.backgroundPosition = `${backgroundX}px ${backgroundY}px`;
    });
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (!generatedImageModalDragRef.current.isDragging) return;

      const deltaX = event.clientX - generatedImageModalDragRef.current.startX;
      const deltaY = event.clientY - generatedImageModalDragRef.current.startY;

      setGeneratedImageModalPosition({
        x: generatedImageModalDragRef.current.originX + deltaX,
        y: generatedImageModalDragRef.current.originY + deltaY,
      });
    };

    const handleMouseUp = () => {
      generatedImageModalDragRef.current.isDragging = false;
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  useEffect(() => () => {
    if (generatedImagePreviewFrameRef.current) {
      cancelAnimationFrame(generatedImagePreviewFrameRef.current);
    }
  }, []);

  const handleGeneratedThumbnailClick = async (imageEntry) => {
    const imageUrl = normalizeImageUrlValue(imageEntry?.url || imageEntry);
    if (!imageUrl) return;

    if (imageEntry?.source === 'generated') {
      openGeneratedImageModal(imageUrl);
      return;
    }
    await applyImageEntryAsBase(imageEntry);
  };

  const handleDeleteGeneratedImage = async (imageEntry, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const imageUrl = normalizeImageUrlValue(imageEntry?.url || imageEntry);
    if (!imageUrl) return;

    const isOriginalEntry = imageEntry?.source === 'original';
    if (isOriginalEntry) return;

    const imageKeyToDelete = getImageCanonicalKey(imageUrl) || imageUrl;
    const updatedImages = generatedProjectImages.filter((entry) => {
      const entryKey = getImageCanonicalKey(entry?.url) || normalizeImageUrlValue(entry?.url);
      return entryKey !== imageKeyToDelete;
    });
    if (!updatedImages.length) {
      return;
    }

    setGeneratedProjectImages(updatedImages);

    const deletedWasActive = (getImageCanonicalKey(activeGeneratedImageUrl) || activeGeneratedImageUrl) === imageKeyToDelete;
    if (deletedWasActive) {
      const fallbackEntry = updatedImages.find((entry) => entry?.source === 'original') || updatedImages[0];
      if (fallbackEntry) {
        await handleGeneratedThumbnailClick(fallbackEntry);
      } else {
        setActiveGeneratedImageUrl('');
      }
    }

    const isDataUrl = typeof imageUrl === 'string' && imageUrl.startsWith('data:image/');
    if (!isDataUrl) {
      try {
        const generatedImageRef = ref(storage, imageUrl);
        await deleteObject(generatedImageRef);
      } catch (storageError) {
        if (storageError?.code !== 'storage/object-not-found') {
          console.error('Error deleting generated image from storage:', storageError);
          toast.error('Image removed from project, but storage delete failed');
        }
      }
    }

    if (!projectId || projectId.toString().startsWith('guest_')) {
      return;
    }

    try {
      const persistedGeneratedImages = updatedImages
        .map((entry) => {
          const url = normalizeImageUrlValue(entry?.url || entry);
          if (!url) return null;
          return {
            url,
            source: entry?.source || 'generated',
            createdAt: entry?.createdAt || null,
          };
        })
        .filter(Boolean);

      await updateDoc(doc(db, 'Projects', projectId), {
        generatedImages: persistedGeneratedImages,
      });

      setProjects((prevProjects) => prevProjects.map((project) => {
        if (project.id !== projectId) return project;
        return {
          ...project,
          generatedImages: persistedGeneratedImages,
        };
      }));
    } catch (error) {
      console.error('Error deleting generated image from project history:', error);
      toast.error('Failed to delete generated image');
    }
  };

  const shouldWatermarkDownloadsForUser = async () => {
    if (!currentUser?.uid || currentUser.email?.startsWith('guest_')) {
      return true;
    }

    if (userRole === 'mainAdmin' || userRole === 'admin') {
      return false;
    }

    try {
      const userDocSnapshot = await getDoc(doc(db, 'users', currentUser.uid));
      const data = userDocSnapshot.exists() ? userDocSnapshot.data() : {};
      const planName = data?.planName || data?.planType || data?.currentPlan;
      const hasPaidPlan = ['my_project_plan', 'standard_plan', 'pro_plan', 'My Project', 'Standard', 'Pro'].includes(planName);
      const hasPurchasedProject = Number(data?.extraProjectPurchased || 0) > 0;
      const hasActiveSubscription = data?.isSubscription && ['active', 'cancel_at_period_end'].includes(data?.subscriptionStatus);

      return !(hasPaidPlan || hasPurchasedProject || hasActiveSubscription);
    } catch (error) {
      console.error('Error checking download watermark entitlement:', error);
      return true;
    }
  };

  const getCurrentProjectImageBoundsForDownload = () => {
    const backgroundImage = canvas?.backgroundImage;

    if (!backgroundImage) {
      return null;
    }

    const rect = typeof backgroundImage.getBoundingRect === 'function'
      ? backgroundImage.getBoundingRect(true, true)
      : {
          left: backgroundImage.left || 0,
          top: backgroundImage.top || 0,
          width: (backgroundImage.width || 0) * (backgroundImage.scaleX || 1),
          height: (backgroundImage.height || 0) * (backgroundImage.scaleY || 1),
        };

    if (!rect.width || !rect.height) {
      return null;
    }

    return rect;
  };

  const addDownloadWatermark = (sourceUrl, fileName, imageBounds = null) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      const watermarkCanvas = document.createElement('canvas');
      watermarkCanvas.width = image.naturalWidth || image.width;
      watermarkCanvas.height = image.naturalHeight || image.height;

      const context = watermarkCanvas.getContext('2d');
      context.drawImage(image, 0, 0);

      const shortestSide = Math.max(1, Math.min(watermarkCanvas.width, watermarkCanvas.height));
      const fontSize = Math.max(22, Math.round(shortestSide * 0.05));
      const label = 'Facade Web App - Free Trial';

      context.save();
      context.font = `800 ${fontSize}px Arial, sans-serif`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.strokeStyle = 'rgba(255, 255, 255, 0.42)';
      context.lineWidth = Math.max(2, Math.round(fontSize * 0.06));
      context.lineJoin = 'round';
      context.fillStyle = 'rgba(15, 23, 42, 0.34)';

      const bounds = imageBounds && imageBounds.width && imageBounds.height
        ? imageBounds
        : null;
      const centerX = bounds
        ? bounds.left + bounds.width / 2
        : watermarkCanvas.width / 2;
      const bottomInset = bounds
        ? Math.max(24, Math.min(64, bounds.height * 0.08))
        : watermarkCanvas.height * 0.08;
      const watermarkLift = bounds
        ? Math.max(52, Math.min(140, bounds.height * 0.16))
        : shortestSide * 0.14;
      const centerY = bounds
        ? bounds.top + bounds.height - bottomInset - watermarkLift
        : watermarkCanvas.height * 0.64;

      context.translate(centerX, centerY);
      context.rotate(-18 * (Math.PI / 180));
      context.strokeText(label, 0, 0);
      context.fillText(label, 0, 0);
      context.restore();

      watermarkCanvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Could not create watermarked image'));
          return;
        }

        resolve({
          url: URL.createObjectURL(blob),
          fileName: fileName.replace(/\.(jpg|jpeg|png)$/i, '_watermarked.png'),
        });
      }, 'image/png');
    };

    image.onerror = reject;
    image.src = sourceUrl;
  });

  const handleDownloadGeneratedImage = async (imageEntry, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const imageUrl = normalizeImageUrlValue(imageEntry?.url || imageEntry);
    if (!imageUrl) {
      toast.error('No image available to download');
      return;
    }

    const isDataUrl = imageUrl.startsWith('data:image/');
    const sourceLabel = imageEntry?.source === 'original' ? 'original' : 'generated';
    const safeProjectName = (projectName || 'project').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '');
    const extension = imageUrl.includes('.png') || imageUrl.includes('image/png') ? 'png' : 'jpg';
    const fileName = `${safeProjectName}_${sourceLabel}_${Date.now()}.${extension}`;

    try {
      const link = document.createElement('a');
      link.setAttribute('download', fileName);

      let downloadUrl = imageUrl;
      let downloadFileName = fileName;
      let shouldRevokeDownloadUrl = false;

      if (!isDataUrl) {
        const response = await fetch(imageUrl, { mode: 'cors' });
        if (!response.ok) {
          throw new Error(`Failed to fetch image (${response.status})`);
        }

        const blob = await response.blob();
        downloadUrl = URL.createObjectURL(blob);
        shouldRevokeDownloadUrl = true;
      }

      if (await shouldWatermarkDownloadsForUser()) {
        const watermarked = await addDownloadWatermark(downloadUrl, fileName);
        if (shouldRevokeDownloadUrl) {
          URL.revokeObjectURL(downloadUrl);
        }
        downloadUrl = watermarked.url;
        downloadFileName = watermarked.fileName;
        shouldRevokeDownloadUrl = true;
        toast.info(t('assistant.watermarkedDownloadNotice', {
          defaultValue: 'Free trial downloads include a watermark. Buy My Project or subscribe to download clean images.'
        }));
      }

      link.setAttribute('download', downloadFileName);
      link.href = downloadUrl;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      if (shouldRevokeDownloadUrl && downloadUrl.startsWith('blob:')) {
        URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error('Error downloading generated image:', error);
      toast.error('Failed to download image');
    }
  };

  const handleDownloadProjectImage = async (url, name) => {
    const imageUrl = normalizeImageUrlValue(url);
    if (!imageUrl) {
      toast.error('No image available to download');
      return;
    }

    const safeName = (name || 'project').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '');
    let downloadUrl = imageUrl;
    let shouldRevokeDownloadUrl = false;
    let fileName = `${safeName}.png`;

    try {
      if (!imageUrl.startsWith('data:image/')) {
        const response = await fetch(imageUrl, { mode: 'cors' });
        if (!response.ok) {
          throw new Error(`Failed to fetch image (${response.status})`);
        }

        const blob = await response.blob();
        downloadUrl = URL.createObjectURL(blob);
        shouldRevokeDownloadUrl = true;
      }

      if (await shouldWatermarkDownloadsForUser()) {
        const watermarked = await addDownloadWatermark(
          downloadUrl,
          fileName,
          getCurrentProjectImageBoundsForDownload()
        );
        if (shouldRevokeDownloadUrl) {
          URL.revokeObjectURL(downloadUrl);
        }
        downloadUrl = watermarked.url;
        fileName = watermarked.fileName;
        shouldRevokeDownloadUrl = true;
        toast.info(t('assistant.watermarkedDownloadNotice', {
          defaultValue: 'Free trial downloads include a watermark. Buy My Project or subscribe to download clean images.'
        }));
      }

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      if (shouldRevokeDownloadUrl && downloadUrl.startsWith('blob:')) {
        URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error('Error downloading project image:', error);
      toast.error('Failed to download image');
    }
  };

  const getPersistableGeneratedImageUrl = async (generatedImageUrl) => {
    if (!generatedImageUrl) return '';

    const isDataUrl = typeof generatedImageUrl === 'string' && generatedImageUrl.startsWith('data:image/');
    if (!isDataUrl || !currentUser?.uid || !projectId || projectId.toString().startsWith('guest_')) {
      return generatedImageUrl;
    }

    const extension = generatedImageUrl.includes('image/png') ? 'png' : 'jpg';
    const generatedImageName = `${projectId}_${Date.now()}_generated.${extension}`;
    const generatedImageRef = ref(
      storage,
      `usersProjectsImages/${currentUser.uid}/generatedImages/${generatedImageName}`
    );

    await uploadString(generatedImageRef, generatedImageUrl, 'data_url');
    return getDownloadURL(generatedImageRef);
  };

  const handleFacadeAIGeneratedImage = async (generatedImageUrl) => {
    const normalizedGeneratedUrl = normalizeImageUrlValue(generatedImageUrl);
    if (!normalizedGeneratedUrl) return;

    let persistedImageUrl = normalizedGeneratedUrl;

    try {
      persistedImageUrl = await getPersistableGeneratedImageUrl(normalizedGeneratedUrl);
    } catch (uploadError) {
      console.error('Error uploading generated image to storage:', uploadError);
    }

    const nowIso = new Date().toISOString();
    const isGuestProject = !projectId || projectId.toString().startsWith('guest_');
    const isGuestUser = currentUser && currentUser.email.startsWith('guest_');

    if (isGuestUser && projectId && !projectId.toString().startsWith('guest_')) {
      const generatedKey = getImageCanonicalKey(persistedImageUrl) || persistedImageUrl;
      if (generatedKey) {
        const existingProjectKeys = guestSessionGeneratedImageKeysRef.current.get(projectId) || new Set();
        existingProjectKeys.add(generatedKey);
        guestSessionGeneratedImageKeysRef.current.set(projectId, existingProjectKeys);
      }
    }

    if (isGuestProject) {
      setGeneratedProjectImages((prev) => {
        const guestOriginalUrl = normalizeImageUrlValue(newProjectImage) || normalizeImageUrlValue(backgroundImageUrl);
        const next = [];
        const seen = new Set();

        const pushIfUnique = (entry) => {
          const normalizedUrl = normalizeImageUrlValue(entry?.url);
          if (!normalizedUrl) return;
          const entryKey = getImageCanonicalKey(normalizedUrl) || normalizedUrl;
          if (seen.has(entryKey)) return;
          seen.add(entryKey);
          next.push({
            ...entry,
            url: normalizedUrl,
          });
        };

        const originalEntry = prev.find((entry) => entry?.source === 'original');
        const savedEntry = prev.find((entry) => entry?.source === 'saved');

        pushIfUnique(originalEntry || (guestOriginalUrl ? {
          url: guestOriginalUrl,
          source: 'original',
          createdAt: null,
        } : null));

        pushIfUnique(savedEntry);

        prev.forEach((entry) => {
          if (entry?.source !== 'generated') return;
          if (normalizeImageUrlValue(entry?.url) === persistedImageUrl) return;
          pushIfUnique({
            ...entry,
            source: 'generated',
          });
        });

        pushIfUnique({
          url: persistedImageUrl,
          source: 'generated',
          createdAt: nowIso,
        });

        console.log('[guest-thumb] guest generated image merged into history', {
          projectId,
          previousEntries: prev.map((entry) => entry?.source),
          nextEntries: next.map((entry) => entry?.source),
        });

        return next;
      });
      openGeneratedImageModal(persistedImageUrl);
      return;
    }

    setGeneratedProjectImages((prev) => {
      const currentProject = projects.find((project) => project.id === projectId);
      const originalUrlFromProject = getProjectOriginalSourceImageUrl(currentProject);
      const originalEntry = prev.find((image) => image.source === 'original') ||
        (originalUrlFromProject ? { url: originalUrlFromProject, source: 'original', createdAt: null } : null);

      const seen = new Set();
      const next = [];

      if (originalEntry?.url) {
        next.push(originalEntry);
        seen.add(originalEntry.url);
      }

      prev.forEach((entry) => {
        if (!entry?.url || seen.has(entry.url)) return;
        if (entry.url === persistedImageUrl) return;
        seen.add(entry.url);
        next.push(entry);
      });

      if (!seen.has(persistedImageUrl)) {
        next.push({
          url: persistedImageUrl,
          source: 'generated',
          createdAt: nowIso,
        });
      }

      return next;
    });

    try {
      const currentProject = projects.find((project) => project.id === projectId);
      const originalUrl = getProjectOriginalSourceImageUrl(currentProject);
      const existingGenerated = normalizeGeneratedEntries(currentProject?.generatedImages)
        .filter((entry) => entry.url !== originalUrl);

      const withoutDuplicateNew = existingGenerated.filter((entry) => entry.url !== persistedImageUrl);
      const updatedGeneratedImages = [];

      if (originalUrl) {
        updatedGeneratedImages.push({
          url: originalUrl,
          source: 'original',
          createdAt: null,
        });
      }

      updatedGeneratedImages.push(...withoutDuplicateNew);
      updatedGeneratedImages.push({
        url: persistedImageUrl,
        source: 'generated',
        createdAt: nowIso,
      });

      await updateDoc(doc(db, 'Projects', projectId), {
        generatedImages: updatedGeneratedImages,
      });

      setProjects((prevProjects) => prevProjects.map((project) => {
        if (project.id !== projectId) return project;
        return {
          ...project,
          generatedImages: updatedGeneratedImages,
        };
      }));
    } catch (error) {
      console.error('Error saving generated images to project:', error);
    }

    openGeneratedImageModal(persistedImageUrl);
  };


  function clearCanvas() {
    if (!hasSerializableCanvas()) {
      return;
    }

    canvas.clear();
    resetAIDetectionPipeline();
    setCalibrationDisplay(false)
    // ✅ Use batch rendering instead of immediate render
    batchRender();
  }

  // clear canvas
  function deleteAll() {
    if (canvas.getObjects().length === 0) {
      toast.warn(t("app-noobjectoncanvas"));
      return;
    }

    if (window.confirm(t("app-deleteallmessage"))) {
      //saveCanvasState(canvas);
      canvas.remove(...canvas.getObjects());
      resetAIDetectionPipeline();
      optionUrl = "";
      setIsSelectedItem(false);
      setIsSelectedShape(false);
      setIsOptionsPanelVisible(false);
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setIsOptionsPanelVisible(false);
      setIsAvaillableDoorsPanelVisible(false);
      setIsPanelVisible(false);
      setIsItemAdded(false);
      setIsSelectedItem(false);
    }
  }

  function selectAll() {
    setIsSelectAll(true);
    setIsOptionsPanelVisible(false);

    // Filter to select only objects that are visible, not dimension objects, and have a windowType including 'Window'
    const objectsToSelect = canvas.getObjects().filter(obj =>
      obj.visible && !obj.isDimension && obj.itemUrl && obj.itemUrl.includes("Window")
    );

    if (objectsToSelect.length > 0) {
      setIsSelectedItem(true);
      canvas.discardActiveObject();
      var sel = new fabric.ActiveSelection(objectsToSelect, {
        canvas: canvas,
      });

      canvas.setActiveObject(sel);
      canvas.requestRenderAll();
    } else {
      // Optionally handle the case where no objects meet the criteria
      console.log("No 'Window' type objects found or selected.");
      setIsSelectAll(true);
      return
    }
  }


  const deselectAllItems = () => {
    if (canvas) {
      canvas.discardActiveObject().renderAll();
    }
  };

  function removeObjects() {
    setIsSelectedItem(false);
    setIsAvaillableDoorsPanelVisible(false);
    removeAllObjects(canvas);
    if (canvas.getActiveObject() < 1) setIsItemAdded(false);
  }

  function updateObjectSelected() {
    var aObj = canvas.getActiveObject();
    if (aObj) {
      setIsObjSelected(true);
    } else {
      setIsObjSelected(false);
    }
  }

  function updateSkew() {
    var aObj = canvas.getActiveObject();
    if (aObj && aObj.type != "activeSelection") {
      setIsSkewVisible(true);
      setSkewX(aObj.get("skewX"));
      setSkewY(aObj.get("skewY"));
      // var absCoords = aObj.calcTransformMatrix();
      // aObj.setCoords();
      // setSkewSliderLeft(aObj.left + 'px');
      // setSkewSliderTop(aObj.top + 'px');
    } else {
      setIsSkewVisible(false);
    }
  }

  function handlePanel(itemToSearch) {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    if (itemToSearch === "Accessories") {
      handleAccessoriesPanel()
    } else {

      setItemToSearch(itemToSearch);
      setIsAvaillableDoorsPanelVisible(false);
      setIsOptionsPanelVisible(false);
      setIsPanelVisible(true);
    }
  }

  function handleAccessoriesPanel() {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setIsAvaillableDoorsPanelVisible(false);
    setIsOptionsPanelVisible(false);
    setIsPanelVisible(false);
    setIsAccessoriesPanelVisible(true)

  }

  function handleAccessoriesSelectionPanel() {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setIsAvaillableDoorsPanelVisible(false);
    setIsOptionsPanelVisible(false);
    setIsPanelVisible(false);
    setIsAccessoriesSelectionPanelVisible(true)

  }

  function handleOptionsPanel(itemToSearch) {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setIsPanelVisible(false);
    if (itemToSearch === "transum") {
      setIsTransum(true);
      setIsOptionsPanelVisible(true);
      setIsAvaillableDoorsPanelVisible(false);
    } else setIsTransumPanelVisible(false);
    setIsOptionsPanelVisible(true);
    // setIsAvaillableDoorsPanelVisible(false);
  }

  function handleDoorsView(itemToSearch, URLToSave) {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setTypeName(itemToSearch);

    setWindowURL(URLToSave);

    setIsAvaillableDoorsPanelVisible(false);
    setIsPanelVisible(false);
    setIsTransumPanelVisible(false);
    setIsOptionsPanelVisible(false);
    setIsAvaillableDoorsPanelVisible(true);
  }

  useEffect(() => {
    const cleanupKeyboardEvents = initKeyboardEvents();

    // Cleanup on unmount
    return () => {
      cleanupKeyboardEvents();
    };
  }, []);


  useEffect(() => {
    const activeAuthUser = auth.currentUser || currentUser;

    if (!activeAuthUser?.uid) {
      setProjects([]);
      return undefined;
    }

    const projectsQuery = query(
      collection(db, "Projects"),
      where("userId", "==", activeAuthUser.uid)
    );

    const unsubscribe = onSnapshot(projectsQuery, (projectsQuerySnapshot) => {
      const projectsData = projectsQuerySnapshot.docs.map((docSnapshot) => ({
        ...docSnapshot.data(),
        id: docSnapshot.id,
      }));

      setProjects(projectsData);

      if (uploadComplete) {
        setUploadComplete(false);
        setIsSettingProjectThumbnail(false);
      }
    }, (error) => {
      console.error("Error subscribing to Projects:", error);
    });

    return () => unsubscribe();
  }, [currentUser, uploadComplete, editComplete, isUpdateMode]);

  const handleProjectUpdate = async (projectName, canvasProject, scaleFactor, projectScaleFactor) => {
    const normalizedProjectName = (projectName || "").replaceAll(" ", "_");
    let projectRecord = projects.find((na) =>
      (projectId && na.id === projectId) || na.projectName === normalizedProjectName
    );

    if (!projectRecord && projectId) {
      try {
        const projectSnapshot = await getDoc(doc(db, "Projects", projectId));
        if (projectSnapshot.exists()) {
          projectRecord = {
            id: projectSnapshot.id,
            ...projectSnapshot.data(),
          };
        }
      } catch (lookupError) {
        console.error("Failed to fetch project for save:", lookupError);
      }
    }

    if (!projectRecord && currentUser?.email?.includes('guest') && projectId?.toString().startsWith('guest_')) {
      projectRecord = {
        id: projectId,
        projectName: normalizedProjectName || projectName || `guest_project_${projectId}`,
      };
      console.log('[guest-thumb] created local guest project record fallback', {
        projectId,
        projectName: projectRecord.projectName,
      });
    }

    if (!projectRecord) {
      console.error("Project not found:", projectName);
      toast.update(toastId, {
        render: "Project not found!",
        type: toast.TYPE.ERROR,
        autoClose: 5000
      });
      setIsUpdateMode(false);
      toast.dismiss(toastId);
      return false;
    }

    const id = projectRecord.id;

    try {
      // Check if the current user is a guest
      const isGuest = currentUser.email.includes('guest');
      const preserveOriginalProjectImage = shouldPreserveEditableProjectOnSave || !isOriginalProjectBaseActive;
      const persistedProjectName = projectRecord.projectName || normalizedProjectName || `project_${id}`;

      // Set initial project JSON and background properties
      let latestBgProps = null;
      if (canvas['backgroundImageProps']) {
        latestBgProps = canvas['backgroundImageProps'];
      }

      // Generate image data URL from canvas only when saving the original editable base
      let dataURL = null;
      if (!preserveOriginalProjectImage) {
        if (latestBgProps) {
          const { x, y, newWidth, newHeight } = latestBgProps;
          dataURL = canvas.toDataURL({
            format: 'png',
            left: x,
            top: y,
            width: newWidth,
            height: newHeight,
            multiplier: 1,
          });
        } else {
          dataURL = canvas.toDataURL({
            format: 'png',
            multiplier: 1,
          });
        }
      }

      console.log('[guest-thumb] handleProjectUpdate prepared snapshot data', {
        projectId: id,
        isGuest,
        preserveOriginalProjectImage,
        shouldPreserveEditableProjectOnSave,
        hasDataUrl: Boolean(dataURL),
      });

      if (!isGuest) {
        const existingImageUrls = projectRecord.imageUrls || {};
        let nextImageUrls = existingImageUrls;
        let nextImageURL = projectRecord.imageURL;
        const serializedCanvasProject = canvas.toJSON([...customProps, 'backgroundImageProps']);
        if (!serializedCanvasProject.backgroundImageProps && canvas['backgroundImageProps']) {
          serializedCanvasProject.backgroundImageProps = canvas['backgroundImageProps'];
        }
        let nextProjectJson = JSON.stringify(serializedCanvasProject);
        const preservedOriginalSource = normalizeImageUrlValue(existingImageUrls?.originalSource) ||
          (preserveOriginalProjectImage ? '' : normalizeImageUrlValue(backgroundImageUrl));

        if (!preserveOriginalProjectImage) {
          // Generate a unique filename for the original image
          const userId = currentUser.uid;
          const originalFilename = `${persistedProjectName}_${userId}.png`;

          // Upload canvas image to Firebase Storage in canvasImagesTreated
          const storage = getStorage();
          const treatedStorageRef = ref(
            storage,
            `usersProjectsImages/${userId}/canvasImages/canvasImagesTreated/${originalFilename}`
          );
          await uploadString(treatedStorageRef, dataURL, 'data_url');
          const downloadURL = await getDownloadURL(treatedStorageRef);

          // Resize the image using react-image-file-resizer
          const dataURItoBlob = (dataURI) => {
            const byteString = atob(dataURI.split(',')[1]);
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: mimeString });
          };
          const file = dataURItoBlob(dataURL);

          let resizedDataURL = await new Promise((resolve, reject) => {
            Resizer.imageFileResizer(
              file,
              800,
              800,
              'PNG',
              100,
              0,
              (uri) => {
                resolve(uri);
              },
              'base64'
            );
          });

          const resizedFilename = `${persistedProjectName}_${userId}_resized.png`;

          const resizedStorageRef = ref(
            storage,
            `usersProjectsImages/${userId}/canvasImages/canvasImagesResized/${resizedFilename}`
          );
          await uploadString(resizedStorageRef, resizedDataURL, 'data_url');
          const resizedDownloadURL = await getDownloadURL(resizedStorageRef);

          // Update the project JSON with the image URL and background image properties
          const updatedProjectJson = {
            ...serializedCanvasProject,
            backgroundImageProps: serializedCanvasProject.backgroundImageProps || canvas['backgroundImageProps'],
          };
          updatedProjectJson.canvasProjectImage = downloadURL ? downloadURL : "MISSING_IMAGE_URL";

          setCanvasProject(updatedProjectJson);
          nextProjectJson = JSON.stringify(updatedProjectJson);
          nextImageURL = downloadURL;
          nextImageUrls = {
            ...existingImageUrls,
            originalSource: preservedOriginalSource || normalizeImageUrlValue(backgroundImageUrl),
            originalTreated: downloadURL,
            resized: resizedDownloadURL
          };
        }

        const nextSavedTimestamp = new Date().toISOString();
        const updatedProjectPayload = {
          projectName: persistedProjectName,
          userId: currentUser?.uid,
          imageURL: nextImageURL,
          imageUrls: nextImageUrls,
          projectJson: nextProjectJson,
          scaleFactor: scaleFactor,
          projectScaleFactor: projectScaleFactor,
          savedTimestamp: nextSavedTimestamp,
        };

        await updateDoc(doc(db, "Projects", id), updatedProjectPayload);

        const updatedProjectForHistory = {
          ...projectRecord,
          ...updatedProjectPayload,
        };
        const updatedImageHistory = buildProjectImageHistory(updatedProjectForHistory);
        const savedEntry = updatedImageHistory.find((entry) => entry?.source === 'saved');

        setGeneratedProjectImages(updatedImageHistory);
        setActiveGeneratedImageUrl(savedEntry?.url || updatedImageHistory[0]?.url || '');
        setProjectName(persistedProjectName.replaceAll("_", " "));
        setProjects((prevProjects) => prevProjects.map((project) => (
          project.id === id
            ? { ...project, ...updatedProjectPayload }
            : project
        )));

        toast.update(toastId, {
          render: preserveOriginalProjectImage
            ? "Project saved without replacing the original image."
            : "Project updated successfully!",
          type: toast.TYPE.SUCCESS,
          autoClose: 5000
        });
        updateAppState({ projectSaved: true });
      } else {
        // ✅ For guest users, only update local state - NO Firebase saving
        const updatedProjectJson = canvas.toJSON([...customProps, 'backgroundImageProps']);
        updatedProjectJson.canvasProjectImage = "GUEST_SESSION_NO_IMAGE";

        setCanvasProject(updatedProjectJson);

        if (!preserveOriginalProjectImage && dataURL) {
          const nextSavedTimestamp = new Date().toISOString();

          setGeneratedProjectImages((prev) => {
            const seen = new Set();
            const next = [];
            const originalFallbackUrl =
              prev.find((entry) => entry?.source === 'original')?.url ||
              generatedProjectImagesRef.current.find((entry) => entry?.source === 'original')?.url ||
              originalProjectImageUrl ||
              getProjectOriginalSourceImageUrl(projects.find((project) => project.id === id)) ||
              normalizeImageUrlValue(newProjectImage) ||
              normalizeImageUrlValue(backgroundImageUrl);

            if (originalFallbackUrl) {
              seen.add(originalFallbackUrl);
              next.push({
                url: originalFallbackUrl,
                source: 'original',
                createdAt: null,
              });
            }

            prev.forEach((entry) => {
              if (!entry?.url) return;
              if (entry.source === 'original') return;
              if (entry.source === 'saved') return;
              if (entry.url === dataURL) return;
              if (seen.has(entry.url)) return;
              seen.add(entry.url);
              next.push(entry);
            });

            next.push({
              url: dataURL,
              source: 'saved',
              createdAt: nextSavedTimestamp,
            });

            console.log('[guest-thumb] guest snapshot thumbnail history updated', {
              projectId: id,
              previousEntries: prev.map((entry) => entry?.source),
              nextEntries: next.map((entry) => entry?.source),
            });

            return next;
          });

          setActiveGeneratedImageUrl(dataURL);
          console.log('[guest-thumb] guest snapshot set as active base', {
            projectId: id,
          });
        } else {
          console.log('[guest-thumb] guest snapshot skipped', {
            projectId: id,
            preserveOriginalProjectImage,
            hasDataUrl: Boolean(dataURL),
          });
        }

        // ✅ Show guest-specific message without saving to Firebase
        toast.update(toastId, {
          render: "Project changes saved locally for guest session (not persisted)!",
          type: toast.TYPE.INFO,
          autoClose: 5000
        });
      }

      // ✅ Save conversation data when project is saved (skip for guest users)
      if (!isGuest && saveConversationFunction && typeof saveConversationFunction === 'function') {
        try {
          await saveConversationFunction();
        } catch (conversationError) {
          console.error("❌ Error saving conversation data:", conversationError);
          // Don't fail the entire save operation if conversation save fails
        }
      }

      return true;

    } catch (error) {
      toast.update(toastId, {
        render: "Project update failed!",
        type: toast.TYPE.ERROR,
        autoClose: 5000
      });
      console.error("Error updating project:", error);
      return false;
    } finally {
      setIsUpdateMode(true);
      toast.dismiss(toastId);
      setToastId(null);
    }
  };


  const handleGuestLogin = async (options = {}) => {
    const { allowAdminTest = false } = options;
    const signedInUser = auth.currentUser;
    const isSignedInWithRealAccount = Boolean(signedInUser && !signedInUser.email?.startsWith('guest_'));
    const isAdminUser = userRole === 'mainAdmin' || userRole === 'admin';

    setShowAuthModal(false);
    setIsLoginOut(false);

    if (isSignedInWithRealAccount && !(allowAdminTest && isAdminUser)) {
      toast.info(
        t('guestModeUseAccountMessage', {
          defaultValue: 'You are already signed in. Guest mode is only available when signed out.'
        }),
        { position: 'top-center', autoClose: 5000 }
      );
      return;
    }

    let hasKnownAccount = false;
    try {
      hasKnownAccount = localStorage.getItem('facade_known_account') === 'true';
    } catch (storageError) {
      hasKnownAccount = false;
    }

    if (hasKnownAccount && !(allowAdminTest && isAdminUser)) {
      toast.info(
        t('guestModeKnownAccountMessage', {
          defaultValue: 'It looks like you already have an account. Please sign in to continue.'
        }),
        { position: 'top-center', autoClose: 5000 }
      );

      setLogin(true);
      setIsLoginOut(false);
      setShowAuthModal(true);
      return;
    }

    try {
      handleAnalyticsEvent("guestCliked", "TryAsGuest", "Try as a guest Triggered");

      if (allowAdminTest && isAdminUser && signedInUser && !signedInUser.email?.startsWith('guest_')) {
        try {
          sessionStorage.setItem('adminGuestMode', 'true');
          sessionStorage.setItem('adminGuestSourceRole', userRole || 'admin');
        } catch (storageError) {
          console.warn('Unable to set admin guest testing flag:', storageError);
        }

        setShowAuthModal(false);
        await signOut(auth);
      }

      const email = "guest_20240827T173821059Z@facadewebapp.com";
      const password = "TempPassword!123"; // Predefined guest credentials

      await signInWithEmailAndPassword(auth, email, password);

      // **✅ Save guest session flag**
      sessionStorage.setItem("wasGuest", "true");

      navigate(getLocalizedAppPath(''), { replace: true });

      setShowAuthModal(false);
      setAccount(true); // Ensure this is passed from the parent App component
      setIsProjectList(true); // Open the project list for guest onboarding
      setOnboardingStartRequest({
        flow: 'guest',
        startStep: 'project-selection',
        token: `guest-${Date.now()}`
      });
      
      // The new distributed onboarding will start automatically from within components
      console.log('Guest login - onboarding will start when Account component mounts');
      
    } catch (error) {
      console.error("Guest Login Error:", error);
      alert(t("auth-loginError"));
    }
  };

  const openPurchaseAuthModal = (mode = 'login', context = null) => {
    setLogin(mode === 'signup' ? false : true);
    setIsLoginOut(false);
    setAuthModalContext(context);
    setShowAuthModal(true);
  };

  const getLocalizedAppPath = useCallback((targetPath) => {
    const localePrefixes = ['/fr-CA', '/fr', '/en-US', '/en'];
    const localePrefix = localePrefixes.find((prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)) || '';
    return `${localePrefix}/${targetPath}`.replace(/\/+/g, '/');
  }, [location.pathname]);

  const getLocalizedPricingPath = useCallback(() => `${getLocalizedAppPath('pricing')}#pricing`, [getLocalizedAppPath]);

  const openPricingForGuestChoice = useCallback(() => {
    navigate(getLocalizedPricingPath());
  }, [getLocalizedPricingPath, navigate]);

  // Function to update app state for onboarding
  const updateAppState = (updates) => {
    setAppState(prev => ({ ...prev, ...updates }));
  };

  // Track app state changes for onboarding
  useEffect(() => {
    updateAppState({
      projectName: projectName,
      projectId: projectId,
      projectSetupStarted: upload || (account && isProjectList),
      hasActiveProjectLoaded: hasActiveProjectLoaded,
      editorVisible: !upload && !isProjectList && hasActiveProjectLoaded,
      projectLoading: hasActiveProjectLoaded && isLoaderFinish === false,
      accountModalOpen: account && isProjectList
    });
  }, [projectName, projectId, account, upload, isProjectList, isLoaderFinish, hasActiveProjectLoaded]);

  // Additional state tracking for project opening
  useEffect(() => {
    // When isProjectList changes from true to false, project is opening
    if (!isProjectList && hasActiveProjectLoaded && projectName !== "") {
      updateAppState({ projectOpening: true });
      
      // Scroll to top of the page when project loads
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Clear this flag after a short delay
      setTimeout(() => {
        updateAppState({ projectOpening: false });
      }, 1000);
    }
  }, [isProjectList, projectName, hasActiveProjectLoaded]);

  useEffect(() => {
    updateAppState({
      canvasReady: canvas && canvas._objects && canvas._objects.length >= 0,
      editorReady: canvas && !showLoader && hasActiveProjectLoaded
    });
  }, [canvas, showLoader, hasActiveProjectLoaded]);

  useEffect(() => {
    if (!projectName && !projectId) {
      setHasActiveProjectLoaded(false);
    }
  }, [projectName, projectId]);

  useEffect(() => {
    if (upload || hasCanvasChanged || !projectId) {
      updateAppState({ projectSaved: false });
    }
  }, [upload, hasCanvasChanged, projectId]);

  const shouldWarnAboutUnsavedChanges = Boolean(
    hasActiveProjectLoaded &&
    hasCanvasChanged &&
    !isGuestUser &&
    !upload &&
    projectName &&
    projectId
  );

  const normalizePendingNavigationPath = useCallback((rawPath) => {
    if (!rawPath) {
      return rawPath;
    }

    const appBasename = '/app';
    if (rawPath === appBasename) {
      return '/';
    }

    if (rawPath.startsWith(`${appBasename}#`) || rawPath.startsWith(`${appBasename}?`)) {
      return `/${rawPath.slice(appBasename.length)}`;
    }

    if (rawPath.startsWith(`${appBasename}/`)) {
      return rawPath.slice(appBasename.length);
    }

    return rawPath;
  }, []);

  const requestEditorExitConfirmation = useCallback(({ path = null, onProceed = null, historyAction = 'push' } = {}) => {
    if (!shouldWarnAboutUnsavedChanges) {
      if (typeof onProceed === 'function') {
        onProceed();
      }

      if (path) {
        navigate(path);
      }

      return false;
    }

    pendingHistoryActionRef.current = historyAction;
    pendingNavigationPathRef.current = normalizePendingNavigationPath(path);
    pendingNavigationCallbackRef.current = typeof onProceed === 'function' ? onProceed : null;
    setShowUnsavedChangesModal(true);
    logUnsavedGuard('explicit-exit-blocked-show-modal', {
      path,
      historyAction,
      hasCallback: typeof onProceed === 'function',
    });
    return true;
  }, [navigate, normalizePendingNavigationPath, shouldWarnAboutUnsavedChanges]);

  const openOnboardingPricing = useCallback(() => {
    requestEditorExitConfirmation({ path: getLocalizedPricingPath() });
  }, [getLocalizedPricingPath, requestEditorExitConfirmation]);

  const getTrialTimeRemainingLabel = useCallback(() => {
    if (!trialEndsAtDate) {
      return null;
    }

    const millisecondsRemaining = trialEndsAtDate.getTime() - trialStatusNow;
    if (millisecondsRemaining <= 0) {
      return t('pricing.trialExpiredNow', { defaultValue: 'Trial expired' });
    }

    const totalHoursRemaining = Math.ceil(millisecondsRemaining / (1000 * 60 * 60));
    if (totalHoursRemaining <= 24) {
      return t('pricing.trialHoursRemaining', {
        count: totalHoursRemaining,
        defaultValue: '{{count}} hour left',
      });
    }

    const totalDaysRemaining = Math.ceil(millisecondsRemaining / (1000 * 60 * 60 * 24));
    return t('pricing.trialDaysRemaining', {
      count: totalDaysRemaining,
      defaultValue: '{{count}} days left',
    });
  }, [t, trialEndsAtDate, trialStatusNow]);

  useEffect(() => {
    const debugState = {
      shouldWarnAboutUnsavedChanges,
      hasActiveProjectLoaded,
      hasCanvasChanged,
      upload,
      isProjectList,
      projectName,
      projectId,
      pathname: location.pathname,
      historyTrapArmed: historyTrapArmedRef.current,
    };

    currentRoutePathRef.current = `${location.pathname}${location.search}${location.hash}`;

    logUnsavedGuard('state-update', debugState);

    if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
      window.__UNSAVED_GUARD_STATE__ = debugState;
    }
  }, [
    shouldWarnAboutUnsavedChanges,
    hasActiveProjectLoaded,
    hasCanvasChanged,
    upload,
    isProjectList,
    projectName,
    projectId,
    location.pathname,
  ]);

  const saveUpdate = async () => {
    if (!projectId) {
      console.log('[guest-thumb] saveUpdate blocked: missing projectId');
      logUnsavedGuard('save-blocked-missing-project', { projectId });
      setHasCanvasChanged(false);
      return false;
    }

    if (isGeneratedImageActiveOnCanvas) {
      const fallbackEntry = generatedProjectImages.find((image) => image?.source === 'saved') ||
        generatedProjectImages.find((image) => image?.source === 'original') ||
        null;

      toast.warn(
        t('assistant.generatedImagesCannotReplaceEditableProject', {
          defaultValue: 'Generated images cannot replace the editable project. Switching back to the saved project design.'
        })
      );

      if (fallbackEntry) {
        try {
          await handleGeneratedThumbnailClick(fallbackEntry);
        } catch (error) {
          console.error("Failed to restore editable project state before save:", error);
        }
      }

      return false;
    }

    const id = toast.info(<LoadingToast />, { autoClose: false });
    setToastId(id);

    let didSaveSucceed = false;

    try {
      console.log('[guest-thumb] saveUpdate starting', {
        projectId,
        isGuestUser,
        projectName,
        hasCanvasChanged,
        imageSources: generatedProjectImages.map((entry) => entry?.source),
      });
      didSaveSucceed = await handleProjectUpdate(
        projectName,
        canvasProject,
        scaleFactor,
        projectScaleFactor
      );
      console.log('[guest-thumb] saveUpdate finished', {
        projectId,
        didSaveSucceed,
      });

      // console.log("project name :", projectName)

    } catch (error) {
      toast.update(id, {
        render: "Project update failed!",
        type: toast.TYPE.ERROR,
        autoClose: 5000
      });
      console.error("Error updating project:", error);
    } finally {
      if (didSaveSucceed) {
        setHasCanvasChanged(false);
      }

      setIsAccountModalOpen(false);
      setIsUpdateMode(false);
      setUploadComplete(false);
      setEditComplete((prev) => !prev);
      toast.dismiss(toastId);
      setToastId(null);
    }

    return didSaveSucceed;
  };

  const handleStayOnPage = () => {
    logUnsavedGuard('action-stay');
    const pendingHistoryAction = pendingHistoryActionRef.current;
    pendingHistoryActionRef.current = null;
    pendingNavigationPathRef.current = null;
    pendingNavigationCallbackRef.current = null;
    setShowUnsavedChangesModal(false);

    if (pendingHistoryAction === 'back') {
      bypassUnsavedWarningRef.current = true;
      window.history.forward();
      setTimeout(() => {
        bypassUnsavedWarningRef.current = false;
      }, 50);
    }
  };

  const handleLeaveWithoutSaving = () => {
    const pendingHistoryAction = pendingHistoryActionRef.current;
    pendingHistoryActionRef.current = null;
    const pendingPath = normalizePendingNavigationPath(pendingNavigationPathRef.current);
    pendingNavigationPathRef.current = null;
    const pendingCallback = pendingNavigationCallbackRef.current;
    pendingNavigationCallbackRef.current = null;
    setShowUnsavedChangesModal(false);

    logUnsavedGuard('action-leave-without-saving', { pendingPath, pendingHistoryAction });

    if (pendingHistoryAction === 'back') {
      bypassUnsavedWarningRef.current = true;
      window.history.back();
      setTimeout(() => {
        bypassUnsavedWarningRef.current = false;
      }, 50);
      return;
    }

    if (!pendingPath) {
      if (typeof pendingCallback === 'function') {
        pendingCallback();
      }
      return;
    }

    bypassUnsavedWarningRef.current = true;
    if (typeof pendingCallback === 'function') {
      pendingCallback();
    }
    navigate(pendingPath);
    setTimeout(() => {
      bypassUnsavedWarningRef.current = false;
    }, 0);
  };

  const handleSaveAndLeave = async () => {
    if (isUnsavedActionLoading) {
      return;
    }

    if (!hasCanvasChanged) {
      logUnsavedGuard('action-save-and-leave-skip-save-no-dirty-state');
      handleLeaveWithoutSaving();
      return;
    }

    if (isGuestUser || !projectId || projectId.toString().startsWith('guest_')) {
      logUnsavedGuard('action-save-and-leave-guest-bypass');
      handleLeaveWithoutSaving();
      return;
    }

    logUnsavedGuard('action-save-and-leave-start');
    setIsUnsavedActionLoading(true);
    const didSaveSucceed = await saveUpdate();
    setIsUnsavedActionLoading(false);
    logUnsavedGuard('action-save-and-leave-result', { didSaveSucceed });

    if (!didSaveSucceed) {
      return;
    }

    const pendingHistoryAction = pendingHistoryActionRef.current;
    pendingHistoryActionRef.current = null;
    const pendingPath = normalizePendingNavigationPath(pendingNavigationPathRef.current);
    pendingNavigationPathRef.current = null;
    const pendingCallback = pendingNavigationCallbackRef.current;
    pendingNavigationCallbackRef.current = null;
    setShowUnsavedChangesModal(false);

    if (pendingHistoryAction === 'back') {
      bypassUnsavedWarningRef.current = true;
      window.history.back();
      setTimeout(() => {
        bypassUnsavedWarningRef.current = false;
      }, 50);
      return;
    }

    if (!pendingPath) {
      logUnsavedGuard('action-save-and-leave-no-pending-path');
      if (typeof pendingCallback === 'function') {
        pendingCallback();
      }
      return;
    }

    bypassUnsavedWarningRef.current = true;
    if (typeof pendingCallback === 'function') {
      pendingCallback();
    }
    navigate(pendingPath);
    setTimeout(() => {
      bypassUnsavedWarningRef.current = false;
    }, 0);
  };

  useEffect(() => {
    if (!isGuestUser) {
      return;
    }

    if (showUnsavedChangesModal) {
      setShowUnsavedChangesModal(false);
    }

    pendingHistoryActionRef.current = null;
    pendingNavigationPathRef.current = null;
    pendingNavigationCallbackRef.current = null;
    bypassUnsavedWarningRef.current = false;
  }, [isGuestUser, showUnsavedChangesModal]);





  async function handleLogOut() {
    setHasActiveProjectLoaded(false);
    setProjectName("");
    try {
      const canPersistCurrentProject = Boolean(
        currentUser?.uid &&
        !currentUser?.email?.startsWith('guest_') &&
        projectName &&
        hasSerializableCanvas()
      );

      if (canPersistCurrentProject) {
        await toJson();
      }

      await logout();
      setIsLoginOut(true)
      setShowAuthModal(false);
      setIsAccountModalOpen(false); // Close the modal on successful logout
    } catch {
      alert(t("auth-error"));
    }
    setUserRole("")
    clearCanvas();
  }

  const resetActiveProjectAfterAuth = () => {
    setHasActiveProjectLoaded(false);
    setHasCanvasChanged(false);
    setProjectName("");
    setProjectId(null);
    setNewProjectCreationName("");
    setUploadImageUrl(null);
    setCanvasProject("");
    setCanvasProjectImage("");
    setBackgroundImageStorageUrl("");
    setCanvasImageName("");
    setBackgroundImageUrl("");
    setNewProjectImage("");
    setGeneratedProjectImages([]);
    setActiveGeneratedImageUrl("");
    setShowUnsavedChangesModal(false);
    setAccount(false);
    setIsAccountModalOpen(false);
    setIsProjectList(false);
    pendingHistoryActionRef.current = null;
    pendingNavigationPathRef.current = null;
    pendingNavigationCallbackRef.current = null;
    bypassUnsavedWarningRef.current = false;
    clearCanvas();
  };

  function toDefault() {
    setHasActiveProjectLoaded(false);
    setUploadImageUrl("");
    deleteAll();
    canvasBackground();
    setShowAuthModal(true);
    setProjectName("");
  }

  function cutobjs() {
    setIsSelectedItem(false);
    setIsAvaillableDoorsPanelVisible(false);
    setIsPanelVisible(false);
    setIsOptionsPanelVisible(false);
    cutItem(canvas);
    if (canvas.getActiveObject() < 1) {
      setIsItemAdded(false);
    }
  }

  const handleRedo = () => {
    console.log("Inside handleRedo function");
    setHasCanvasChanged(true);
    redo(canvas, true);
  };

  // Example event for undo
  const handleUndo = () => {
    console.log("Inside handleUndo function");
    setHasCanvasChanged(true);
    undo(canvas, true);
  };

  const [perspective, setPerspective] = useState(false);

  const changePerspective = () => {
    canvas.isPerspective = !perspective;
    setPerspective(!perspective);
    setObjectPerspective(canvas, null, true);
  }

  //deselect for eraser mode
  function deselectItem() {
    if (canvas && canvas.getActiveObject()) {
      canvas.getActiveObject().set({ opacity: 1 });
      canvas.discardActiveObject();
      canvas.renderAll();
    }
  }

  const handleColorChange = (newColor) => {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    enableDraw(canvas, brushWidth, newColor);  // Pass the new color to your function
  };

  const handleFadeObjects = () => {


    // Change the button class to indicate that something is happening
    setButtonClass('before-after-button btn btn-warning');

    fadeObjects(canvas, () => {

      // Restore the original button class after fade operation
      setButtonClass('before-after-button btn btn-light');
    });


  };
  //calibration button
  const handleDropdownChange = (eventKey) => {
    if (eventKey === "removeDisplay") {
      setCalibrationDisplay(!calibrationDisplay)
      setShowCalibrationOverlay(false);
    }
    if (eventKey === 'toggleCalibration') {
      setShowCalibrationOverlay(!showCalibrationOverlay);
      setIsCalibrating(true)
      setCalibrationDisplay(false)
      if (!hasCalibration) {
        toggleCalibrationMode()
      }
    }
  };

  const toggleCalibrationMode = () => {
    setCalibrationMode(!isCalibrationMode);

    if (!isCalibrationMode) {
      // Create a square shape
      let rect = new fabric.Rect({
        height: 150,
        width: 150,
        fill: 'transparent',
        stroke: 'yellow',
        strokeWidth: 3,
        originX: 'center',
        originY: 'center',  // centering for group
      });

      // Create a text shape
      let text = new fabric.Text('Calibration', {
        fontSize: 20,
        originX: 'center',
        originY: 'center', // centering for group
        fill: "#4caf50",
      });

      // Create a group and add the square and text shapes to it
      let calibrationGroup = new fabric.Group([rect, text], {
        left: canvas.width / 2,
        top: 100,
        typeName: "calibration",
      });

      setCalibrationGroup(calibrationGroup);

      canvas.add(calibrationGroup);
      canvas.bringToFront(calibrationGroup);
      canvas.requestRenderAll();
    }
  };

  const deselectActiveObject = () => {
    if (canvas) { // Assuming fabricCanvas is the variable that holds your Fabric.js canvas instance in App
      canvas.discardActiveObject().requestRenderAll();
    }
  };


  // Function to set pixel length (called from Calibration component)

  const handlePixelLengthSet = (pixelLength) => {

    if (scaleFactor === 1) {
      const newScaleFactor = knownLengthRef.current / pixelLength;
      setScaleFactor(newScaleFactor);

      const newRealDimensions = {
        width: (pixelLength * newScaleFactor).toFixed(2),
        height: (pixelLength * newScaleFactor).toFixed(2), // or whatever calculation is appropriate
      };

      setRealDimensions(newRealDimensions);

    }
  };

  // Set cookies using the native browser API

  const handleAccept = () => {
    ;
    document.cookie = "user_consent_beta=true; path=/; max-age=2592000";
    document.cookie = "user_consent=true; path=/; max-age=2592000";
    setModalOpen(false);
    toast.dismiss("consent-toast");
    setTermsAccepted(true)
    setShowConsentBanner(false);  // Hide the banner
  };

  const handleDecline = () => {

    document.cookie = "user_consent_beta=false; path=/; max-age=2592000";
    document.cookie = "user_consent=false; path=/; max-age=2592000";
    setModalOpen(false);
    toast.dismiss("consent-toast");
    setShowConsentBanner(false);  // Hide the banner
  };

  function showConnectionRequiredToast(t) {
    toast.warning(t("assistant.toastMessage.connectionRequired"), {
      position: "top-center",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const showTrialEditingLockedToast = useCallback(() => {
    toast.info(t('pricing.trialEditingLocked', {
      defaultValue: 'Your 7-day free trial has ended. Purchase a package to continue editing. You can still download your project images with a watermark.'
    }), {
      toastId: 'trial-editing-locked',
      position: 'top-center',
      autoClose: 4500,
    });
  }, [t]);

  const shouldBlockExpiredTrialEditing = useCallback(() => {
    if (!isExpiredStandardTrial) {
      return false;
    }

    showTrialEditingLockedToast();
    return true;
  }, [isExpiredStandardTrial, showTrialEditingLockedToast]);

  // Function to set all objects to be non-selectable
  function setObjectsSelectable(selectable) {
    canvas.forEachObject(function (obj) {
      obj.selectable = selectable;
    });
    canvas.discardActiveObject(); // Deselect any selected objects
    canvas.requestRenderAll();
  }

  useEffect(() => {
    if (!canvas) {
      return undefined;
    }

    const shouldLockEditing = isExpiredStandardTrial;

    if (shouldLockEditing) {
      if (typeof canvas.__trialLockPrevSelection === 'undefined') {
        canvas.__trialLockPrevSelection = canvas.selection;
      }
      canvas.selection = false;
    } else if (typeof canvas.__trialLockPrevSelection !== 'undefined') {
      canvas.selection = canvas.__trialLockPrevSelection;
      delete canvas.__trialLockPrevSelection;
    }

    canvas.forEachObject((obj) => {
      if (shouldLockEditing) {
        if (typeof obj.__trialLockPrevSelectable === 'undefined') {
          obj.__trialLockPrevSelectable = Boolean(obj.selectable);
        }
        if (typeof obj.__trialLockPrevEvented === 'undefined') {
          obj.__trialLockPrevEvented = Boolean(obj.evented);
        }

        obj.selectable = false;
        obj.evented = false;
        return;
      }

      if (typeof obj.__trialLockPrevSelectable !== 'undefined') {
        obj.selectable = obj.__trialLockPrevSelectable;
        delete obj.__trialLockPrevSelectable;
      }

      if (typeof obj.__trialLockPrevEvented !== 'undefined') {
        obj.evented = obj.__trialLockPrevEvented;
        delete obj.__trialLockPrevEvented;
      }
    });

    canvas.discardActiveObject();
    canvas.requestRenderAll();

    return undefined;
  }, [canvas, isExpiredStandardTrial]);

  useEffect(() => {
    if (!isExpiredStandardTrial) {
      return;
    }

    setIsPanelVisible(false);
    setIsAccessoriesPanelVisible(false);
    setIsAccessoriesSelectionPanelVisible(false);
    setIsOptionsPanelVisible(false);
    setIsTransumPanelVisible(false);
    setIsAvaillableDoorsPanelVisible(false);
    setIsAccessoryTypeSelected(false);
    setIsCalibrating(false);
    setShowCalibrationOverlay(false);
    setEraseMode(false);
    setDrawMode(false);
    setCurrentAction('select');
  }, [isExpiredStandardTrial]);


  function drawGrid(canvas, cellSize) {
    // Clear any existing grid and text first
    const existingLines = canvas.getObjects('line');
    const existingTexts = canvas.getObjects('text');
    canvas.remove(...existingLines, ...existingTexts);

    for (let i = 0; i <= (canvas.width / cellSize); i++) {
      // Vertical lines
      const verticalLine = new fabric.Line([i * cellSize, 0, i * cellSize, canvas.height], {
        stroke: '#ccc',
        selectable: false,
        evented: false,
        type: 'line'
      });
      canvas.add(verticalLine);

      // Horizontal lines
      const horizontalLine = new fabric.Line([0, i * cellSize, canvas.width, i * cellSize], {
        stroke: '#ccc',
        selectable: false,
        evented: false,
        type: 'line'
      });
      canvas.add(horizontalLine);

      // Coordinate labels
      const xLabel = new fabric.Text(i * cellSize + '', {
        left: i * cellSize,
        top: 0,
        fontSize: 24,
        fill: 'yellow',
        selectable: false,
        evented: false,
      });
      canvas.add(xLabel);

      const yLabel = new fabric.Text(i * cellSize + '', {
        left: 0,
        top: i * cellSize,
        fontSize: 24,
        fill: 'yellow',
        selectable: false,
        evented: false,
      });
      canvas.add(yLabel);
    }

    canvas.renderAll();
  }

  function rgbaToHex(rgba) {
    var parts = rgba.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+)\)$/);
    delete (parts[0]);
    for (var i = 1; i <= 3; ++i) {
      parts[i] = parseInt(parts[i]).toString(16);
      if (parts[i].length === 1) parts[i] = '0' + parts[i];
    }
    return '#' + parts.join('').toUpperCase(); // "#RRGGBB"
  }

  const onEyedropperColorChange = (color) => {
    setEyePickerActiveColor(color); // Assuming this is your state update function
    // Any other logic you need when the color changes
  };

  const handleOpenContactForm = () => {
    setShowContactForm(true);
  };

  const startEditorTour = () => {
    setOnboardingStartRequest({
      flow: 'editorTour',
      startStep: 'editor-tour-welcome',
      force: true,
      token: `editor-tour-${Date.now()}`
    });
  };

  const toggleNewsVisibility = () => {
    setIsNewsVisible(!isNewsVisible);
  };

  const handleAddAccessory = (accessory, props) => {
    if (shouldBlockExpiredTrialEditing()) {
      return;
    }

    setIsAccessoryTypeSelected(false)

    console.log("handleAddAccessory called")


    addAccessoryImage(accessory, { ...props, canvas }, itemColor);
  };

  const isProjectEditorVisible = Boolean(projectName && hasActiveProjectLoaded);

  return (
    <OnboardingProvider>
      <div className="container-fluid p-0">
      <OnboardingFlowController
        currentUser={currentUser}
        appState={appState}
        startRequest={onboardingStartRequest}
      />

      <HelmetProvider>
        <Helmet>

          <title>{t('title')}</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
          <meta name="description" content={t('description')} />

          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'SoftwareApplication',
              name: 'Facade Web App by RenoTrend',
              alternateName: 'Facade Web App',
              applicationCategory: 'DesignApplication',
              operatingSystem: 'Web Browser',
              url: canonicalUrl,
              description: t('description'),
              brand: {
                '@type': 'Brand',
                name: 'RenoTrend',
                url: 'https://renotrend.com/'
              },
              provider: {
                '@type': 'Organization',
                name: 'Applications RenoTrend Inc.',
                url: 'https://renotrend.com/'
              }
            })}
          </script>

          <link rel="alternate" hreflang="en" href={alternateEnUrl} />

          <link rel="alternate" hreflang="fr" href={alternateFrUrl} />

          <link rel="alternate" hreflang="x-default" href={alternateDefaultUrl} />

        </Helmet>
      </HelmetProvider>

      <div className="App siteMainBackgroundColor">
        <header className="header">
          <ToastContainer position="bottom-left" />

          {showAuthModal && authStateResolved && !(currentUser?.uid && !currentUser?.email?.startsWith('guest_')) && (
            <Auth
              closeSignup={setShowAuthModal}
              currentUser={currentUser}
              toJson={toJson}
              clearCanvas={clearCanvas}
              loginSet={login}
              setLogin={setLogin}
              isLoginOut={isLoginOut}
              setIsLoginOut={setIsLoginOut}
              setProjectName={setProjectName}
              setCloseAccount={setAccount}
              closeUpload={setUpload}
              setUserRole={setUserRole}
              termsAccepted={termsAccepted}
              handleAccept={handleAccept}
              handleDecline={handleDecline}
              sendWelcomeEmail={sendWelcomeEmail}
              handleLogOut={handleLogOut}
              setIsGoogleProcessing={setIsGoogleProcessing}
              showEmailVerificationPendingModal={showEmailVerificationPendingModal}
              resetActiveProjectAfterAuth={resetActiveProjectAfterAuth}
              authContext={authModalContext}
            />
          )}

          {/* Google Processing Modal - App Level */}
          {isGoogleProcessing && (
            <Modal
              show={true}
              backdrop="static"
              keyboard={false}
              centered
              size="sm"
              dialogClassName="auth-modal"
              contentClassName="auth-modal-content"
            >
              <Modal.Body className="text-center p-4">
                <div className="d-flex flex-column align-items-center">
                  <Spinner animation="border" variant="primary" className="mb-3" />
                  <h5 className="mb-2">{t("auth-processingAccount") || "Setting up your account..."}</h5>
                  <p className="text-muted mb-0 small" style={{maxWidth: '250px', lineHeight: '1.4'}}>
                    {t("auth-processingMessage") || "Please wait while we create your account and send your welcome email."}
                  </p>
                </div>
              </Modal.Body>
            </Modal>
          )}
          {account && (
            <Account
              currentUser={currentUser}
              closeAccount={setAccount}
              imageURL={setUploadImageUrl}
              canvasProjectImage={canvasProjectImage}
              canvasProject={canvasProject}
              loadProject={loadProject}
              handleProjectName={handleProjectName}
              projectName={projectName}
              setProjectName={setProjectName}
              newProjectCreationName={newProjectCreationName}
              setNewProjectCreationName={setNewProjectCreationName}
              setIsProjectList={setIsProjectList}
              isProjectList={isProjectList}
              downloadpng={handleDownloadProjectImage}
              canvas={canvas}
              uploadImageUrl={uploadImageUrl}
              backgroundImageStorageUrl={backgroundImageStorageUrl} // url to storage
              canvasImageName={canvasImageName}
              setBackgroundImageStorageUrl={setBackgroundImageStorageUrl}
              toJson={toJson}
              onShowLoader={handleShowLoader}
              onHideLoader={handleHideLoader}
              saveNewProject={saveNewProject}
              isLoaderFinish={isLoaderFinish}
              setIsLoaderFinish={setIsLoaderFinish}
              clearCanvas={clearCanvas}
              scaleFactor={scaleFactor}
              setScaleFactor={setScaleFactor}
              projectScaleFactor={projectScaleFactor}
              setProjectId={setProjectId}
              isUpdateMode={isUpdateMode}
              setIsUpdateMode={setIsUpdateMode}
              toastId={toastId}
              projects={projects} // Pass projects to Account
              setEditComplete={setEditComplete}
              setProjectChangeKey={setProjectChangeKey}
              resetAIStates={resetAIStates} // ✅ Pass the reset function
            />
          )}
          {upload && (
            <UploadImage
              imageURL={setUploadImageUrl}
              setProjectName={setProjectName}
              closeUpload={setUpload}
              closeAccount={setAccount}
              setNewProjectCreationName={setNewProjectCreationName}
              setBackgroundImageStorageUrl={setBackgroundImageStorageUrl}
              setCanvasImageName={setCanvasImageName}
              clearCanvas={clearCanvas}
              showLoader={handleShowLoader}
              hideLoader={handleHideLoader}
              toJson={toJson}
              onImageUploadSuccess={handleImageUploadSuccess}
              setImageName={setImageName}
              updateProgress={updateProgress}
              projects={projects} // ✅ Pass projects for duplicate checking
              resetAIStates={resetAIStates} // ✅ Pass reset function
              setIsCreatingNewProject={setIsCreatingNewProject} // ✅ Pass the function
              onCancelNewProject={restoreCapturedProjectStateAfterNewProjectCancel}
            />
          )}
          <SiteNav
            currentUser={currentUser}
            closeUpload={setUpload}
            closeSignup={setShowAuthModal}
            setLogin={setLogin}
            setIsLoginOut={setIsLoginOut}
            closeAccount={setAccount}
            toJson={toJson}
            setIsProjectList={setIsProjectList}
            projectName={projectName}
            upload={upload}
            account={account}
            showCanvasPopupModal={showCanvasPopupModal}
            userRole={userRole}
            setShowModal={setShowModal}
            handleClose={handleClose}
            showConnectionRequiredToast={showConnectionRequiredToast}
            // termsAccepted={termsAccepted}
            handleOpenContactForm={handleOpenContactForm}
            triggerAIDetectionForOpenedProject={triggerAIDetectionForOpenedProject}
            isDimensionsVisible={isDimensionsVisible}
            toggleDimensionsVisibility={toggleDimensionsVisibility}
            handleLogOut={handleLogOut}
            setIsAccountModalOpen={setIsAccountModalOpen}
            isAccountModalOpen={isAccountModalOpen}
            setDesignerModalOpen={setDesignerModalOpen}
            handleAnalyticsEvent={handleAnalyticsEvent} // Pass the analytics function
            handleGuestLogin={handleGuestLogin}
            resetAIStates={resetAIStates} // ✅ Pass the reset function
            requestEditorExitConfirmation={requestEditorExitConfirmation}
            captureCurrentProjectStateForNewProjectFlow={captureCurrentProjectStateForNewProjectFlow}
            closeCurrentProjectForNewProjectFlow={closeCurrentProjectForNewProjectFlow}


          />

          {/* Old UserNoticeModal replaced by WhatsNewButton in SiteNav */}
          {/* <UserNoticeModal show={showNotice} handleCloseNotice={handleCloseNotice} /> */}

          {/* <EditItems canvas={canvas} targetObject={selectedObject} /> */}
          <SecondaryNav />
          <HorizontalOnboarding
            hasActiveStandardTrial={hasActiveStandardTrial}
            onCreateProject={() => setAccount(true)}
            onOpenSignup={() => {
              setLogin(false);
              setIsLoginOut(false);
              setShowAuthModal(true);
            }}
            onViewPricing={openOnboardingPricing}
            handleLogOut={handleLogOut}
          />
          <EditorTourHighlighter />
        </header>
        <div>



          {/* Routes moved to bottom to avoid duplication */}

          {isDetailModalOpen && (
            <ItemDetailsModal
              isOpen={isDetailModalOpen}
              details={modalDetails.details || {}}
              imageUrl={modalDetails.imageUrl || ""}
              itemColor={modalDetails.itemColor || ""}
              onClose={closeDetailModal}
              isDoor={isDoor}
              selectedObject={selectedObject}
              onSetAsReference={(targetObject) => openReferenceDimensionModal(targetObject, true)}
              onEditReference={(targetObject) => openReferenceDimensionModal(targetObject, false)}
              onUseAsReferenceImage={handleUseSelectedItemAsReferenceImage}
            // cutItem={cutItem(canvas)}
            />
          )}

          {isReferenceDimensionModalOpen && (
            <ReferenceDimensionModal
              isOpen={isReferenceDimensionModalOpen}
              onClose={() => setIsReferenceDimensionModalOpen(false)}
              onSave={handleSaveReferenceDimensions}
              currentWidth={referenceDimensionModalData?.currentWidth}
              currentHeight={referenceDimensionModalData?.currentHeight}
              itemType={referenceDimensionModalData?.itemType}
              isNewReference={referenceDimensionModalData?.isNewReference}
            />
          )}

          <ContentModal
            show={isModalOpen}
            title={modalTitle}
            content={modalContent}
            setModalOpen={setModalOpen}
            handleAccept={handleAccept}
            handleDecline={handleDecline}
          />

          <EmailConfirmationSuccessModal
            show={showConfirmationModal}
            onClose={() => setShowConfirmationModal(false)}
            setShowCanvasPopupModal={setShowCanvasPopupModal}
            setShowAuthModal={setShowAuthModal}
            setLogin={setLogin}
          />

          <EmailVerificationPendingModal
            show={showEmailVerificationPending}
            onClose={handleDismissPendingVerificationToLogin}
            userEmail={pendingVerificationEmail}
            userName={pendingVerificationUserName}
          />

          <Modal
            show={showUnsavedChangesModal}
            onHide={handleStayOnPage}
            backdrop="static"
            backdropClassName="unsaved-changes-backdrop"
            keyboard={false}
            centered
            size="sm"
            className="unsaved-changes-modal-root"
            dialogClassName="unsaved-changes-modal"
          >
            <Modal.Header className="border-0">
              <div className="unsaved-changes-header-content">
                <div className="unsaved-changes-kicker">
                  {t('app-unsavedChangesKicker', { defaultValue: 'Before you leave' })}
                </div>
                <Modal.Title className="unsaved-changes-title">
                  {t('app-unsavedChangesTitle', { defaultValue: 'Unsaved Changes' })}
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="unsaved-changes-body">
              <p className="unsaved-changes-message">
                {t('app-unsavedChangesBody', {
                  defaultValue: 'You have unsaved project changes. Save your project before leaving this page?',
                })}
              </p>
              <div className="unsaved-changes-note">
                {t('app-unsavedChangesNote', {
                  defaultValue: 'Save now to keep your latest edits in this project.',
                })}
              </div>
            </Modal.Body>
            <Modal.Footer className="unsaved-changes-footer">
              <Button
                variant="secondary"
                className="unsaved-changes-btn unsaved-changes-btn-secondary"
                onClick={handleStayOnPage}
                disabled={isUnsavedActionLoading}
              >
                {t('app-stayOnPage', { defaultValue: 'Stay' })}
              </Button>
              <Button
                variant="outline-danger"
                className="unsaved-changes-btn unsaved-changes-btn-danger"
                onClick={handleLeaveWithoutSaving}
                disabled={isUnsavedActionLoading}
              >
                {t('app-leaveWithoutSaving', { defaultValue: 'Leave without saving' })}
              </Button>
              <Button
                variant="primary"
                className="unsaved-changes-btn unsaved-changes-btn-primary"
                onClick={handleSaveAndLeave}
                disabled={isUnsavedActionLoading}
              >
                {isUnsavedActionLoading
                  ? t('app-saving', { defaultValue: 'Saving...' })
                  : t('app-saveAndLeave', { defaultValue: 'Save and leave' })}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Your main app contents */}
          {showConsentBanner && (
            <CookieConsent
              location="bottom"
              buttonText={t("consent.accept")}
              cookieName="user_consent_beta"
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              onAccept={handleAccept}
            >
              {t("consent.betaConsentText")}
              <span className="legalLinks">
                <Link to="/cookies">{t("consent.betaConsent")}</Link>
                <Link to="/terms">{t("consent.betaTerms")}</Link>
              </span>
            </CookieConsent>
          )}


          {/* Rest of your main app contents */}

          {/* {!currentUser && <Home closeSignup={setShowAuthModal} />} */}

          <div className={`mainContainer ${isProjectEditorVisible ? 'mainContainer--editorVisible' : 'mainContainer--empty'}`}>


            {<div className="mainContainerLeft">
              {/* {projectName && <div className="news-banner-container">
                <h2 className="news-title" onClick={toggleNewsVisibility}>
                  <img src={process.env.PUBLIC_URL + '/svg-and-icons/megaphoneIcon.svg'} alt="Megaphone Icon" className="icon" />
                  {t("betanews")}
                </h2>
                <div className="news-banner">
                  {isNewsVisible && projectName && <NewsBanner />}
                </div>
              </div>} */}
              {currentUser && isProjectEditorVisible && !isCalibrating && (
                <div ref={topBarRef} className="topBar">


                  {/* <button
                    className="openProject btn btn-primary border-6 border-dark"
                    type="button"
                    size="sm"
                    title={t("save-project")}
                    name="saveProject"
                    // disabled={currentUser.email.startsWith("guest_")}  // Disable for guest users
                    onClick={saveUpdate}
                  >
                    <SaveIcon />
                    <span className="button-text p-1">
                      {!projectName ? "" : t("app-saveThisProject")}
                      {projectName.replaceAll("_", " ") ||
                        t("app-startOrOpenProject")}
                    </span>
                  </button> */}

                  <div className="topBarSaveAction" data-onboarding="save-project">
                    <Tooltip
                      title={tooltipMessage}
                      position="top"
                      trigger="mouseenter"
                      disabled={!isGuestUser}
                    >
                      <button
                        className="openProject btn btn-primary border-6 border-dark"
                        type="button"
                        size="sm"
                        title={t("save-project")}
                        name="saveProject"
                        disabled={currentUser.email.startsWith("guest_")}  // Disable for guest users
                        onClick={saveUpdate}
                      >
                        <SaveIcon />
                        <span className="button-text p-1">
                          {!projectName ? "" : t("app-saveThisProject")}
                          {projectName.replaceAll("_", " ") ||
                            t("app-startOrOpenProject")}
                        </span>
                      </button>
                    </Tooltip>
                  </div>

                  {isProjectEditorVisible && (
                    <button
                      type="button"
                      className="btn btn-outline-primary border-6 border-dark editorTourTrigger"
                      onClick={startEditorTour}
                    >
                      <span className="editorTourTrigger-full">
                        {t('onboarding.buttons.startEditorTour', 'Start editor tour')}
                      </span>
                      <span className="editorTourTrigger-short">
                        {t('onboarding.buttons.startEditorTourShort', 'Editor tour')}
                      </span>
                    </button>
                  )}


                  {/* <span style={{ padding: "7px 10px" }}>
                    <CustomTooltip content="Hover me!" videoSrc="/gifs_app/perspective-tool.webm">
                      <Form.Check
                        checked={perspective}
                        type={'checkbox'}
                        label={`Perspective`}
                        id={`check-perspective`}
                        onChange={changePerspective}
                      />
                    </CustomTooltip>
                  </span> */}

                  <div className="undoRedoSmall">
                    <button
                      title={t("app-undo")}
                      className="actionBtn"
                      onClick={handleUndo}
                    >
                      <div className="undoIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
                        </svg>
                      </div>
                    </button>
                    <button
                      title={t("app-redo")}
                      className="actionBtn"
                      onClick={handleRedo}
                    >
                      <div className="redoIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
                        </svg>
                      </div>
                    </button>
                  </div>

                  {isProjectEditorVisible && (
                    <div className="undoRedoWrapper">
                      <div className="undoRedo ms-auto">
                        <button
                          title={t("app-undo")}
                          className="btn btn-primary me-3 border-6 border-dark"
                          onClick={handleUndo}
                        >
                          <UndoIcon />
                          <span className="button-text p-1">{t("app-undo")}</span>
                        </button>
                        <button
                          title={t("app-redo")}
                          className="btn btn-primary me-3 border-6 border-dark"
                          onClick={handleRedo}
                        >
                          <RedoIcon />
                          <span className="button-text p-1">{t("app-redo")}</span>
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Zoom controls in topBar - always visible */}
                  {isProjectEditorVisible && canvas && (
                    <FloatingZoomControls 
                      canvas={canvas}
                      onZoomChange={(zoomLevel) => {
                        // Handle zoom level changes if needed
                      }}
                    />
                  )}
                </div>

              )}
              {isGuestUser && (
                <div className="guestContainer">
                  {t("app-guestMode")}
                </div>
              )}



              {showCalibrationOverlay && (<div className="calibrationContainer">
                <Calibration
                  onKnownLengthChange={setKnownLength}
                  onDimensionToggle={setDimension}
                  onUnitToggle={setUnit}
                  setIsCalibrating={setIsCalibrating}
                  setCalibrationDisplay={setCalibrationDisplay}
                  setCalibrationMode={setCalibrationMode}
                  deselectActiveObject={deselectActiveObject} // to deselect the Calibration Tool
                  setShowCalibrationOverlay={setShowCalibrationOverlay}
                />

              </div>)}

              {(currentAction === 'erase' || currentAction === 'draw') && !isCalibrating && currentAction !== "null" && (
                <div className="eraserDrawContainer">
                  <EraserDraw handleColorChange={handleColorChange} onWidthChange={handleWidthChange} currentWidth={brushWidth} handleActionChange={handleActionChange} mode={modeType} />
                </div>
              )}



              {/* <div className="selectionView">
                {isPanelVisible && (
                  <div className="itemSelectionView">
                    <ItemSelectionView
                      itemToSearch={itemToSearch}
                      addItem={addItem}
                      typeName={typeName}
                      setIsPanelVisible={setIsPanelVisible}
                      handleDoorsView={handleDoorsView}
                      canvasHeight={canvasHeight}
                    />
                  </div>
                )}

                {isAccessoriesPanelVisible && (
                  <div className="itemSelectionView">
                    <AccessoriesSelectionView
                      setIsAccessoryTypeSelected={setIsAccessoryTypeSelected}
                      setIsPanelVisible={setIsPanelVisible}
                      setAccessoryType={setAccessoryType}
                      setIsAccessoriesPanelVisible={setIsAccessoriesPanelVisible}
                    />
                  </div>
                )}

                {isAccessoryTypeSelected && (
                  <div className="itemSelectionView">
                    <AccessoriesSelection
                      accessoryType={accessoryType}
                      addItem={handleAddAccessory}
                      setIsAccessoriesSelectionPanelVisible={setIsAccessoriesSelectionPanelVisible}
                      setIsAccessoriesPanelVisible={setIsAccessoriesPanelVisible}
                      setIsAccessoryTypeSelected={setIsAccessoryTypeSelected}
                    />
                  </div>
                )}

                {isOptionsPanelVisible && (
                  <div className="optionsSelectionView">
                    <OptionsSelectionView
                      isTransum={isTransum}
                      setIsTransum={setIsTransum}
                      addOption={addOption}
                      addTransum={addTransum}
                      windowURL={windowURL}
                      typeName={typeName}
                      setGlassToSearch={setGlassToSearch}
                      setStringToSearch={setStringToSearch}
                      setStringToSearchSide={setStringToSearchSide}
                      setIsOptionsPanelVisible={setIsOptionsPanelVisible}
                    />
                  </div>
                )}
                {isTransumPanelVisible && (
                  <div className="transumSelectionView">
                    <TransumSelectionView
                      addOption={addOption}
                      windowURL={windowURL}
                      typeName={typeName}
                      setGlassToSearch={setGlassToSearch}
                      setIsOptionsPanelVisible={setIsOptionsPanelVisible}
                    />
                  </div>
                )}

                {isAvaillableDoorsPanelVisible && (
                  <div className="doorsSelectionView">
                    <DoorsSelectionView
                      addItem={addItem}
                      windowURL={windowURL}
                      typeName={typeName}
                      itemToSearch={itemToSearch}
                      setIsOptionsPanelVisible={setIsOptionsPanelVisible}
                      setIsPanelVisible={setIsPanelVisible}
                      setIsAvaillableDoorsPanelVisible={
                        setIsAvaillableDoorsPanelVisible
                      }
                      setIsAccessoriesPanelVisible={setIsAccessoriesPanelVisible}
                    />
                  </div>
                )}
              </div> */}

              {showLoader && (
                loaderConfig.variant === 'facadeai' ? (
                  <div className="app-loader-overlay">
                    <div className="app-loader-card app-loader-card-facadeai">
                      <Spinner animation="border" role="status" />
                      <div className="app-loader-title">
                        {loaderConfig.title || t('assistant.generatingFacadeAiTitle', {
                          defaultValue: 'Generating your realistic facade image'
                        })}
                      </div>
                      <div className="app-loader-text">
                        {loaderConfig.message || t('assistant.generatingFacadeAiMessage', {
                          defaultValue: 'This usually takes about 30 to 60 seconds. Your new image will be applied automatically when it is ready.'
                        })}
                      </div>
                      <div className="app-loader-phase">
                        {loaderElapsedSeconds >= 25
                          ? t('assistant.generatingFacadeAiPhaseLate', {
                              defaultValue: 'Still working. Finalizing realism, glass, materials, and lighting.'
                            })
                          : t('assistant.generatingFacadeAiPhaseEarly', {
                              defaultValue: 'Preparing your source image and matching the requested references.'
                            })}
                      </div>
                      <div className="app-loader-elapsed">
                        {t('assistant.generatingFacadeAiElapsed', {
                          defaultValue: 'Elapsed time: {{count}}s',
                          count: loaderElapsedSeconds,
                        })}
                      </div>
                      <div className="app-loader-note">
                        {loaderConfig.note || t('assistant.generatingFacadeAiNote', {
                          defaultValue: 'Please keep this tab open while generation finishes.'
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="pre-loader"></div>
                )
              )}
              {isSettingProjectThumbnail && !showLoader && (
                <div className="project-thumbnail-spinner-overlay">
                  <div className="project-thumbnail-spinner-card">
                    <Spinner animation="border" role="status" />
                    <div className="project-thumbnail-spinner-text">
                      {t("app-setting-project-thumbnail", {
                        defaultValue: "Setting project thumbnail..."
                      })}
                    </div>
                  </div>
                </div>
              )}

              <div className="canvasAndBannersParent" style={{ display: isProjectEditorVisible ? 'block' : 'none' }}>

                {currentUser && (
                  <>




                    <div className="canvasWithGeneratedRail">
                      <div className="generatedImagesRail">
                        <div className="generatedDesignerTriggerSlot" />
                        {projectHistoryEntries.length > 0 && (
                          <div className="generatedThumbSection">
                            <div className="generatedThumbSectionTitle">
                              {t('assistant.projectImagesSection', { defaultValue: 'Project images' })}
                            </div>
                            {projectHistoryEntries.map((image, index) => {
                              const isOriginal = image?.source === 'original';
                              const isActive = activeGeneratedImageUrl === image.url;

                              return (
                                <div
                                  key={`${image.url}-${index}`}
                                  className={`generatedThumbCard ${isActive ? 'active' : ''}`}
                                >
                                  <div className="generatedThumbLabelTop">
                                    {isOriginal
                                      ? t('assistant.originalProject', { defaultValue: 'Original project' })
                                      : t('assistant.savedProjectLabel', { defaultValue: 'Saved project' })}
                                  </div>

                                  <button
                                    type="button"
                                    className={`generatedThumbButton ${isActive ? 'active' : ''}`}
                                    onClick={() => handleGeneratedThumbnailClick(image)}
                                    title={isActive
                                      ? t('assistant.selectedBaseImage')
                                      : (isOriginal
                                        ? t('assistant.originalImage', { defaultValue: 'Original image' })
                                        : t('assistant.savedProjectLabel', { defaultValue: 'Saved project' }))}
                                  >
                                    <img
                                      src={image.url}
                                      alt={isOriginal
                                        ? t('assistant.originalProject', { defaultValue: 'Original project' })
                                        : t('assistant.savedProjectLabel', { defaultValue: 'Saved project' })}
                                      className="generatedThumbImage"
                                      onError={(event) => {
                                        const fallbackUrl = image?.source === 'saved'
                                          ? getSavedProjectImageFallbackUrl(activeProjectForImageHistory)
                                          : getProjectOriginalSourceImageUrl(activeProjectForImageHistory);

                                        if (fallbackUrl && event.currentTarget.src !== fallbackUrl) {
                                          event.currentTarget.src = fallbackUrl;
                                        }
                                      }}
                                    />
                                    {hasActiveStandardTrial && <span className="generatedThumbTrialBadge">{t('pricing.trialBadge', { defaultValue: 'Trial watermark' })}</span>}
                                    {isActive && <span className="generatedThumbBaseBadge">{t('assistant.baseBadge')}</span>}
                                  </button>

                                  <div className="generatedThumbMetaRow">
                                    <div className="generatedThumbActions">
                                      <button
                                        type="button"
                                        className="generatedThumbDownloadBtn"
                                        onClick={(event) => handleDownloadGeneratedImage(image, event)}
                                        aria-label={t('assistant.downloadImage', { defaultValue: 'Download' })}
                                        title={t('assistant.downloadImage', { defaultValue: 'Download' })}
                                      >
                                        {t('assistant.downloadImage', { defaultValue: 'Download' })}
                                      </button>
                                    </div>
                                    <span className="generatedThumbLabelBottom">
                                      {isOriginal
                                        ? t('assistant.openOriginalPhoto', { defaultValue: 'Open the project photo with no edits' })
                                        : t('assistant.openEditableProject', { defaultValue: 'Open the editable saved project' })}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {aiGeneratedHistoryEntries.length > 0 && (
                          <div className="generatedThumbSection generatedThumbSectionSeparated">
                            <div className="generatedThumbSectionTitle">
                              {t('assistant.aiGeneratedSection', { defaultValue: 'AI generated images' })}
                            </div>
                            {aiGeneratedHistoryEntries.map((image, index) => {
                              const generatedIndex = index + 1;
                              const isActive = activeGeneratedImageUrl === image.url;

                              return (
                                <div
                                  key={`${image.url}-${generatedIndex}`}
                                  className={`generatedThumbCard ${isActive ? 'active' : ''}`}
                                >
                                  <div className="generatedThumbLabelTop">
                                    {t('assistant.generatedImageLabel', { count: generatedIndex, defaultValue: 'Generated image {{count}}' })}
                                  </div>

                                  <button
                                    type="button"
                                    className={`generatedThumbButton ${isActive ? 'active' : ''}`}
                                    onClick={() => handleGeneratedThumbnailClick(image)}
                                    title={isActive
                                      ? t('assistant.selectedBaseImage')
                                      : t('assistant.generatedImage', { defaultValue: 'Generated image' })}
                                  >
                                    <img
                                      src={image.url}
                                      alt={t('assistant.generatedImageAlt', { count: generatedIndex, defaultValue: 'Generated image {{count}}' })}
                                      className="generatedThumbImage"
                                      onError={(event) => {
                                        const fallbackUrl = normalizeImageUrlValue(image?.fallbackUrl);
                                        if (fallbackUrl && event.currentTarget.src !== fallbackUrl) {
                                          event.currentTarget.src = fallbackUrl;
                                        }
                                      }}
                                    />
                                    {hasActiveStandardTrial && <span className="generatedThumbTrialBadge">{t('pricing.trialBadge', { defaultValue: 'Trial watermark' })}</span>}
                                    {isActive && <span className="generatedThumbBaseBadge">{t('assistant.baseBadge')}</span>}
                                  </button>

                                  <div className="generatedThumbMetaRow">
                                    <div className="generatedThumbActions">
                                      <button
                                        type="button"
                                        className="generatedThumbDownloadBtn"
                                        onClick={(event) => handleDownloadGeneratedImage(image, event)}
                                        aria-label={t('assistant.downloadImage', { defaultValue: 'Download' })}
                                        title={t('assistant.downloadImage', { defaultValue: 'Download' })}
                                      >
                                        {t('assistant.downloadImage', { defaultValue: 'Download' })}
                                      </button>
                                      <button
                                        type="button"
                                        className="generatedThumbDeleteBtn"
                                        onClick={(event) => handleDeleteGeneratedImage(image, event)}
                                        aria-label={t('assistant.deleteGeneratedImage', { defaultValue: 'Delete generated image' })}
                                        title={t('assistant.deleteGeneratedImage', { defaultValue: 'Delete generated image' })}
                                      >
                                        {t('common.delete', { defaultValue: 'Delete' })}
                                      </button>
                                    </div>
                                    <span className="generatedThumbLabelBottom">
                                      {t('assistant.clickToUseAsBase', { defaultValue: 'Click to use as base' })}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div className="canvasMainArea">
                      {hasActiveStandardTrial && projectName && (
                        <div className="editorTrialStatusBanner">
                          <div className="editorTrialStatusCopy">
                            <strong>{t('pricing.trialBannerTitle', { defaultValue: 'Standard free trial active' })}</strong>
                            <span>
                              {t('pricing.trialBannerCopy', {
                                defaultValue: 'You can keep editing during the trial. Downloads stay watermarked, and free-trial projects may be deleted after 30 days as described in the Terms of Use.'
                              })}
                            </span>
                          </div>
                          <div className="editorTrialStatusMeta">
                            <span className="editorTrialCountdown">{getTrialTimeRemainingLabel()}</span>
                            <button
                              type="button"
                              className="editorTrialPurchaseButton"
                              onClick={openOnboardingPricing}
                            >
                              {t('pricing.purchasePackageCta', { defaultValue: 'Purchase a package' })}
                            </button>
                          </div>
                        </div>
                      )}
                      {isExpiredStandardTrial && projectName && (
                        <div className="editorTrialStatusBanner editorTrialStatusBannerExpired">
                          <div className="editorTrialStatusCopy">
                            <strong>{t('pricing.trialExpiredBannerTitle', { defaultValue: 'Free trial ended' })}</strong>
                            <span>
                              {t('pricing.trialExpiredBannerCopy', {
                                defaultValue: 'Editing is locked until you purchase a package. You can still download your project images with the free-trial watermark.'
                              })}
                            </span>
                          </div>
                          <div className="editorTrialStatusMeta">
                            <span className="editorTrialCountdown">{t('pricing.trialExpiredNow', { defaultValue: 'Trial expired' })}</span>
                            <button
                              type="button"
                              className="editorTrialPurchaseButton"
                              onClick={openOnboardingPricing}
                            >
                              {t('pricing.purchasePackageCta', { defaultValue: 'Purchase a package' })}
                            </button>
                          </div>
                        </div>
                      )}
                      {isGuestUser && projectName && (
                        <div className="editorGuestTrialCta">
                          <div className="editorGuestTrialCtaCopy">
                            <strong>{t('pricing.startTrialFromGuestTitle', { defaultValue: 'Ready to use your own house?' })}</strong>
                            <span>{t('pricing.startTrialFromGuestCopy', { defaultValue: 'Create an account to start your 7-day free trial with no credit card, upload your own project, or choose a paid package when you are ready.' })}</span>
                          </div>
                          <div className="editorGuestTrialCtaActions">
                            <button
                              type="button"
                              className="editorGuestTrialPrimary"
                              onClick={() => {
                                handleAnalyticsEvent('trial_cta_clicked', 'trial', 'guest_editor');
                                openPurchaseAuthModal('signup', { intent: 'trial', planName: 'standard_plan', source: 'guest_editor_cta' });
                              }}
                            >
                              {t('pricing.startFreeTrial', { defaultValue: 'Start 7-day free trial' })}
                            </button>
                            <button
                              type="button"
                              className="editorGuestTrialSecondary"
                              onClick={openPricingForGuestChoice}
                            >
                              {t('pricing.viewPlans', { defaultValue: 'View plans' })}
                            </button>
                          </div>
                        </div>
                      )}
                      <div ref={canvasContainerRef} className={showCalibrationOverlay ? "canvasContainer showCalibrationOverlay" : "canvasContainer"}>

                      <CanvasTutorialBadge visible={Boolean(canvas)} />
                      <EditorTrialWatermarkOverlay
                        visible={Boolean(shouldShowEditorWatermark)}
                        fabricCanvas={canvas}
                        label={t('pricing.editorTrialWatermark', { defaultValue: 'Facade Web App - Free Trial' })}
                      />
                      <canvas ref={mainCanvasRef} id="canv" />
                      {/* <CanvasTooltip typeName={typeName} /> */}

                      {/* AI evaluation features removed - EvaluationProgress and DesignVariationCarousel no longer needed */}

                      {/* New SelectionComponent above Menu */}
                      <SelectionComponent
                        isFixed={isFixed} // Now controls fixed positioning
                        isPanelVisible={isPanelVisible}
                        isAccessoriesPanelVisible={isAccessoriesPanelVisible}
                        isAccessoryTypeSelected={isAccessoryTypeSelected}
                        isOptionsPanelVisible={isOptionsPanelVisible}
                        isTransumPanelVisible={isTransumPanelVisible}
                        isAvaillableDoorsPanelVisible={isAvaillableDoorsPanelVisible}
                        itemToSearch={itemToSearch}
                        addItem={addItem}
                        typeName={typeName}
                        accessoryType={accessoryType}
                        setIsPanelVisible={setIsPanelVisible}
                        handleDoorsView={handleDoorsView}
                        canvasHeight={canvasHeight}
                        setIsAccessoryTypeSelected={setIsAccessoryTypeSelected}
                        setAccessoryType={setAccessoryType}
                        setIsAccessoriesPanelVisible={setIsAccessoriesPanelVisible}
                        handleAddAccessory={handleAddAccessory}
                        addOption={addOption}
                        addTransum={addTransum}
                        windowURL={windowURL}
                        setGlassToSearch={setGlassToSearch}
                        setStringToSearch={setStringToSearch}
                        setStringToSearchSide={setStringToSearchSide}
                        setIsOptionsPanelVisible={setIsOptionsPanelVisible}
                        setIsAvaillableDoorsPanelVisible={setIsAvaillableDoorsPanelVisible}
                        setIsTransumPanelVisible={setIsTransumPanelVisible}
                      />

                      {/* MenuComponent that will position at the bottom of the screen or canvas */}
                      <MenuComponent
                        isFixed={isFixed}
                        handlePanel={handlePanel}
                        addOption={addOption}
                        addItem={addItem}
                        handleAddAccessory={handleAddAccessory}
                        handleDoorsView={handleDoorsView}
                        canvasHeight={canvasHeight}
                        typeName={typeName}
                        projectName={projectName}
                        isSelectedItem={isSelectedItem}
                        updateColor={updateColor}
                        handleColorChange={handleColorChange}
                        handleOptionsPanel={handleOptionsPanel}
                        eyePickerActiveColor={eyePickerActiveColor}
                        applyColorToSpecificItems={applyColorToSpecificItems}
                        setIsOptionsPanelVisible={setIsOptionsPanelVisible}
                        itemColor={itemColor}
                        setIsItemAdded={setIsItemAdded}
                        isCalibrating={isCalibrating}
                        windowURL={windowURL}
                        addTransum={addTransum}
                        setGlassToSearch={setGlassToSearch}
                        setStringToSearch={setStringToSearch}
                        setStringToSearchSide={setStringToSearchSide}
                        isTransum={isTransum}
                        setIsTransum={setIsTransum}
                        isSameType={isSameType}
                        isMixMatched={isMixMatched}
                        checkForSeletedItems={checkForSeletedItems}
                        checkSelectedObjectType={checkSelectedObjectType}
                        toggleOptionsPanel={toggleOptionsPanel}
                        getSelectedItemType={getSelectedItemType}
                        activeObjectDetails={activeObjectDetails}
                        canvas={canvas}
                        handleActionChange={handleActionChange}
                        copyItem={copyItem}
                        selectAll={selectAll}
                        cutItem={cutItem}
                        removeAllObjects2={removeAllObjects2}
                        pasteItem={pasteItem}
                        copyAndPasteItem={copyAndPasteItem}
                        objectfliphorizontal={objectfliphorizontal}
                        objectflipvertical={objectflipvertical}
                        drawGrid={drawGrid}
                        unGroupItems={unGroupItems}
                        setModeType={setModeType}
                        setEraseMode={setEraseMode}
                        setDrawMode={setDrawMode}
                        changePerspective={changePerspective}
                        calibrationDisplay={calibrationDisplay}
                        t={t}
                        scaleFactor={scaleFactor}
                        showCalibrationOverlay={showCalibrationOverlay}
                        handleDropdownChange={handleDropdownChange}
                        selectedObject={selectedObject}
                        onUseSelectedItemAsReferenceImage={handleUseSelectedItemAsReferenceImage}
                        onUseColorSwatchAsReferenceImage={handleUseColorSwatchAsReferenceImage}
                        onMakeItReal={handleGenerateRealisticImageFromMenu}
                        isMakingItReal={isFacadeAIGeneratingFromMenu}
                        makeItRealElapsedSeconds={facadeAIGenerationElapsedFromMenu}
                      />

                      <ContactFormModal show={showContactForm} handleClose={() => setShowContactForm(false)} />
                      <Modal
                        show={isGeneratedImageModalOpen}
                        onHide={closeGeneratedImageModal}
                        centered
                        size={generatedImageModalUrl ? "xl" : "lg"}
                        className="generated-image-preview-modal-root"
                        dialogClassName="generated-image-preview-modal-dialog"
                        backdropClassName="generated-image-preview-backdrop"
                        style={{
                          '--generated-modal-offset-x': `${generatedImageModalPosition.x}px`,
                          '--generated-modal-offset-y': `${generatedImageModalPosition.y}px`,
                        }}
                      >
                        <Modal.Header closeButton onMouseDown={handleGeneratedImageModalDragStart}>
                          <Modal.Title>
                            {generatedImageModalUrl
                              ? t('assistant.generatedImage', { defaultValue: 'Generated image' })
                              : t('assistant.generatingFacadeAiTitle', { defaultValue: 'Generating your realistic facade image' })}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {generatedImageModalUrl ? (
                            <div className="generated-image-preview-view">
                              <div
                                ref={generatedImagePreviewRef}
                                className="generated-image-preview-stage"
                                onMouseMove={handleGeneratedImagePreviewMove}
                                onMouseLeave={hideGeneratedImageLens}
                              >
                                <img
                                  ref={generatedImagePreviewImgRef}
                                  src={generatedImageModalUrl}
                                  alt={t('assistant.generatedImage', { defaultValue: 'Generated image' })}
                                  className="generated-image-preview-main"
                                />
                                <div
                                  ref={generatedImageLensRef}
                                  className="generated-image-preview-lens"
                                >
                              <div className="generated-image-preview-zoom-label">
                                    {t('assistant.zoomedDetails', { defaultValue: 'Zoomed details' })}
                                  </div>
                                </div>
                                <div className="generated-image-preview-hint">
                                  {t('assistant.zoomedDetails', { defaultValue: 'Zoomed details' })}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="designer-generation-status-card generated-image-preview-loading">
                              <div className="designer-generation-status-spinner">
                                <Spinner animation="border" role="status" />
                              </div>
                              <div className="designer-generation-status-title">
                                {t('assistant.generatingFacadeAiTitle', { defaultValue: 'Generating your realistic facade image' })}
                              </div>
                              <div className="designer-generation-status-text">
                                {t('assistant.generatingFacadeAiMessage', { defaultValue: 'This usually takes about 30 to 60 seconds. Your new image will be applied automatically when it is ready.' })}
                              </div>
                              <div className="designer-generation-status-phase">
                                {facadeAIGenerationElapsedFromMenu >= 25
                                  ? t('assistant.generatingFacadeAiPhaseLate', {
                                      defaultValue: 'Still working. Finalizing realism, glass, materials, and lighting.'
                                    })
                                  : t('assistant.generatingFacadeAiPhaseEarly', {
                                      defaultValue: 'Preparing your source image and matching the requested references.'
                                    })}
                              </div>
                              <div className="designer-generation-status-elapsed">
                                {t('assistant.generatingFacadeAiElapsed', {
                                  defaultValue: 'Elapsed time: {{count}}s',
                                  count: facadeAIGenerationElapsedFromMenu,
                                })}
                              </div>
                              <div className="designer-generation-status-note">
                                {t('assistant.generatingFacadeAiNote', { defaultValue: 'Please keep this tab open while generation finishes.' })}
                              </div>
                            </div>
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={closeGeneratedImageModal}>
                            {t('assistant.close', { defaultValue: 'Close' })}
                          </Button>
                          {generatedImageModalUrl ? (
                            <Button
                              variant="outline-primary"
                              onClick={() => handleUseGeneratedImageAsBase(generatedImageModalUrl)}
                            >
                              {t('assistant.useAsBase', { defaultValue: 'Use as base' })}
                            </Button>
                          ) : null}
                          {generatedImageModalUrl ? (
                            <Button
                              variant="primary"
                              onClick={(event) => handleDownloadGeneratedImage(generatedImageModalUrl, event)}
                            >
                              {t('assistant.downloadImage', { defaultValue: 'Download' })}
                            </Button>
                          ) : null}
                        </Modal.Footer>
                      </Modal>
                      {/* {projectName && <button className={buttonClass} title={t("app-beforeAfter")}
                        onClick={handleFadeObjects}><CompareArrowsIcon className="d-md-none" /><span className="before-after-label">{t("app-beforeAfter")}</span> </button>} */}
                      {/* {isGuestUser && (
                      <div className="guest-mode-title">
                        {t("app-guestMode")}
                      </div>
                    )} */}

                      {projectName && (
                        <div>
                          {/* <button onClick={triggerWallsAndTexturesDetection}>Detect Walls and Textures</button> */}
                          {/* <button className="ai-Detect-button-AI btn btn-light" onClick={triggerAIDetectionWithAnalytics}>{t("ai-detect")}</button>
                        <div className="ai-Measurement-button">
                          <input
                            type="checkbox"
                            id="toggleDimensions"
                            checked={isDimensionsVisible}
                            onChange={toggleDimensionsVisibility}
                          />
                          <label htmlFor="toggleDimensions"> Dimensions</label>
                        </div> */}

                          <FacadeDesigner
                            projects={projects}
                            projectId={projectId}
                            hasCanvasChanged={hasCanvasChanged}
                            generatedProjectImages={generatedProjectImages}
                            newProjectImage={newProjectImage}
                            resetNewProjectImage={resetNewProjectImage}
                            userRole={userRole}
                            isDesignerModalOpen={isDesignerModalOpen}
                            setDesignerModalOpen={setDesignerModalOpen}
                            handleAnalyticsEvent={handleAnalyticsEvent} // Pass the analytics function
                            applyColorsToCanvasItems={applyColorsToCanvasItems}
                            triggerAIDetectionForOpenedProject={triggerAIDetectionForOpenedProject}
                            fabricCanvas={canvas} // Pass the canvas as a prop
                            saveUpdate={saveUpdate}
                            isDetectionTriggered={isDetectionTriggered}
                            setIsDetectionTriggered={setIsDetectionTriggered}
                            detectAndApplyColors={detectAndApplyColors}
                            projectChangeKey={projectChangeKey}
                            handleHideLoader={handleHideLoader}
                            handleShowLoader={handleShowLoader}
                            roboflowFoundDetections={roboflowFoundDetections}
                            setRoboflowFoundDetections={setRoboflowFoundDetections}
                            setGeminiScaleFactor={setGeminiScaleFactor}
                            backgroundImageUrl={backgroundImageUrl}
                            selectedBaseImageUrl={activeGeneratedImageUrl}
                            setBackgroundImageUrlInApp={setBackgroundImageUrl}
                            isGuestUser={isGuestUser}
                            onConversationSaveReady={handleConversationSaveReady}
                            onReferenceImageActionReady={handleDesignerReferenceActionReady}
                            setProjectScaleFactor={setProjectScaleFactor} // Pass projectScaleFactor setter
                            onFacadeAIGeneratedImage={handleFacadeAIGeneratedImage}
                            isOriginalProjectBaseActive={isOriginalProjectBaseActive}
                            originalProjectImageUrl={originalProjectImageUrl}
                            onFacadeAIGenerationStateChange={handleFacadeAIGenerationStateChange}
                          />

                        </div>
                      )}

                      {wallsAndTexturesDetections && <WallTextureCanvas imageUrl={detectionImage} detections={wallsAndTexturesDetections} imageWidth={detectionImageWidth}
                        imageHeight={detectionImageHeight} />}

                      {calibrationDisplay && (
                        <CalibrationDisplay width={realDimensions.width} height={realDimensions.height} unit={unit} />
                      )}

                      {!projectName && currentUser && currentUser.emailVerified && (
                        <CanvasPopup
                          setUpload={setUpload}
                          setAccount={setAccount}
                          setShowCanvasPopupModal={setShowCanvasPopupModal}
                          showCanvasPopupModal={showCanvasPopupModal}
                          setIsCreatingNewProject={setIsCreatingNewProject} // ✅ Pass the function
                        />
                      )}

                      <div>


                        {/* <Button onClick={handleOpen}>Open Facade Designer</Button> */}

                        {/* <FacadeDesigner showModal={showModal} handleClose={handleClose} projectId={projectId} projects={projects} newProjectImage={newProjectImage} resetNewProjectImage={resetNewProjectImage} userRole={userRole} /> */}
                        {/* <FacadeDesigner
                        projects={projects}
                        projectId={projectId}
                        newProjectImage={newProjectImage}
                        resetNewProjectImage={resetNewProjectImage}
                        userRole={userRole}
                        isDesignerModalOpen={isDesignerModalOpen}
                        setDesignerModalOpen={setDesignerModalOpen}
                        handleAnalyticsEvent={handleAnalyticsEvent} // Pass the analytics function
                        applyColorsToCanvasItems={applyColorsToCanvasItems}
                        triggerAIDetectionForOpenedProject={triggerAIDetectionForOpenedProject}
                        fabricCanvas={canvas} // Pass the canvas as a prop
                        saveUpdate={saveUpdate}
                        isDetectionTriggered={isDetectionTriggered}
                        setIsDetectionTriggered={setIsDetectionTriggered}
                        detectAndApplyColors={detectAndApplyColors}
                        projectChangeKey={projectChangeKey}
                        handleHideLoader={handleHideLoader}
                        handleShowLoader={handleShowLoader}
                        roboflowFoundDetections={roboflowFoundDetections}
                        setRoboflowFoundDetections={setRoboflowFoundDetections}
                        setGeminiScaleFactor={setGeminiScaleFactor}
                        backgroundImageUrl={backgroundImageUrl}

                      /> */}

                      </div>



                      {projectName && (
                        <div className="zoom-buttons">
                          <div className="zoomout-wrap">
                            <ZoomAndPan
                              show={isZoomModalOpen}
                              onHide={() => setIsZoomModalOpen(false)}
                              canvas={canvas}
                              projectName={projectName}
                              canvasWidth={canvasWidth}
                              canvasHeight={canvasHeight}
                            />
                          </div>
                        </div>
                      )}

                    </div>
                    </div>
                    </div>
                  </>


                )}
                {/* <div className="bannersContainer"> */}
                {/* Sticky Banner under the canvas */}
                {/* <div className="sticky-banner">
                
                  {userPlan === "Free" && projectName && <Banner1 onContactTextClick={handleOpenContactForm} />}

                </div> */}

              </div>
            </div>}
          </div>
        </div>
      </div>
      <Routes>
        <Route path="/cookies" element={null} />
        <Route path="/terms" element={null} />
        <Route path="/pricing" element={<PricingSection key={`pricing-${userRole}`} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/fr/pricing" element={<PricingSection key={`pricing-fr-${userRole}`} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/fr-CA/pricing" element={<PricingSection key={`pricing-fr-CA-${userRole}`} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/en/pricing" element={<PricingSection key={`pricing-en-${userRole}`} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/en-US/pricing" element={<PricingSection key={`pricing-en-US-${userRole}`} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        
        <Route path="/success" element={<SuccessPage setIsAccountModalOpen={setIsAccountModalOpen} />} />
        <Route path="/fr/success" element={<SuccessPage setIsAccountModalOpen={setIsAccountModalOpen} />} />
        <Route path="/fr-CA/success" element={<SuccessPage setIsAccountModalOpen={setIsAccountModalOpen} />} />
        <Route path="/en/success" element={<SuccessPage setIsAccountModalOpen={setIsAccountModalOpen} />} />
        <Route path="/en-US/success" element={<SuccessPage setIsAccountModalOpen={setIsAccountModalOpen} />} />
        
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/fr/cancel" element={<CancelPage />} />
        <Route path="/fr-CA/cancel" element={<CancelPage />} />
        <Route path="/en/cancel" element={<CancelPage />} />
        <Route path="/en-US/cancel" element={<CancelPage />} />

        <Route path="/" element={<Home key={`home-${userRole}`} setAccount={() => setAccount(true)} handleAnalyticsEvent={handleAnalyticsEvent} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />

        <Route path="/fr" element={<Home key={`home-fr-${userRole}`} setAccount={() => setAccount(true)} handleAnalyticsEvent={handleAnalyticsEvent} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/fr-CA" element={<Home key={`home-fr-CA-${userRole}`} setAccount={() => setAccount(true)} handleAnalyticsEvent={handleAnalyticsEvent} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/en" element={<Home key={`home-en-${userRole}`} setAccount={() => setAccount(true)} handleAnalyticsEvent={handleAnalyticsEvent} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="/en-US" element={<Home key={`home-en-US-${userRole}`} setAccount={() => setAccount(true)} handleAnalyticsEvent={handleAnalyticsEvent} handleGuestLogin={handleGuestLogin} userRole={userRole} openAuthModal={openPurchaseAuthModal} requestEditorExitConfirmation={requestEditorExitConfirmation} />} />
        <Route path="*" element={<NotFoundPage />} />

      </Routes>


      <ScrollToTopButton />
      
    </div>
    </OnboardingProvider>
  );
};

export default App;

// Floating designer button rendered as a portal to avoid DOM insertion conflicts
export function FloatingDesignerButton({ visible, onClick }) {
  // Try to mount inside the canvas' menu/container when available to keep
  // the button in the same DOM subtree. Fall back to document.body to
  // avoid timing/insertBefore errors when the canvas DOM isn't ready.
  const [container, setContainer] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(() => {
    try {
      return localStorage.getItem('floatingDesignerCollapsed') === 'true';
    } catch (e) {
      return false;
    }
  });

  React.useEffect(() => {
    let mounted = true;

    const resolveContainer = () => {
      if (!mounted) return;
      // Prefer mounting inside the overall canvas container so absolute
      // positioned elements (like .floating-button) position relative to it.
      const canvasOuter = document.querySelector('.canvasContainer') || document.querySelector('.canvas-container');
      const menu = document.querySelector('.canvasContainer .menu-container') || document.querySelector('.canvas-container .menu-container');
      if (canvasOuter) {
        setContainer(canvasOuter);
      } else if (menu) {
        // fallback to menu if canvas outer isn't available
        setContainer(menu);
      } else {
        setContainer(document.body);
      }
    };

    // Initial attempt
    resolveContainer();
    // Try again shortly in case the canvas mounts after this component
    const timer = setTimeout(resolveContainer, 500);

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, []);
  if (!visible) return null;
  if (!container) return null; // wait until we resolved a container

  const mountedInsideCanvas = container !== document.body;

  const handleCollapseToggle = (e) => {
    e && e.stopPropagation && e.stopPropagation();
    const next = !collapsed;
    setCollapsed(next);
    try {
      localStorage.setItem('floatingDesignerCollapsed', next ? 'true' : 'false');
    } catch (e) {}
  };

  // When collapsed show a tiny icon (similar to zoom control) that will expand on click
  if (collapsed) {
    const collapsedEl = (
      <a
        role="button"
        className={mountedInsideCanvas ? 'designer-collapsed' : 'designer-collapsed designer-fixed'}
        tabIndex={0}
        onClick={() => setCollapsed(false)}
        aria-label="Open Virtual Designer (collapsed)"
        title="Open Virtual Designer"
        data-onboarding="designer-launch"
      >
        <img src="/rnewFacadeDesignerPro_cutout80.png" alt="Facade Designer Icon" className="designer-icon" />
      </a>
    );
    try {
      return createPortal(collapsedEl, container);
    } catch (e) {
      return createPortal(collapsedEl, document.body);
    }
  }

  const el = (
    <a
      role="button"
      className={mountedInsideCanvas ? 'floating-button' : 'designer-link designer-fixed'}
      tabIndex={0}
      onClick={onClick}
      aria-label="Open Virtual Designer"
      data-onboarding="designer-launch"
      >
      <img src="/rnewFacadeDesignerProIcon_cutout.png" alt="Facade Designer Icon" className="designer-icon" />
      {/* include label so desktop .floating-button padding-left has effect */}
      {mountedInsideCanvas && <span className="designer-text">Designer</span>}
      {/* small collapse control inside the button to minimize clutter */}
      <button
        type="button"
        className="designer-collapse-btn"
        onClick={(e) => { e.stopPropagation(); handleCollapseToggle(e); }}
        aria-label="Collapse designer button"
        title="Minimize"
      >
        ▶
      </button>
    </a>
  );

  try {
    return createPortal(el, container);
  } catch (e) {
    // On unexpected errors, fall back to body to keep the app running
    return createPortal(el, document.body);
  }
}
